<template>
  <div id="deCreate">
    <div class="zwdesign-header">
      <div class="zwdesign-header--left logined">
        <span
          @click="handleJumpPath('/index')"
          style="
            color: #4934b2;
            font-size: 19px;
            font-weight: bold;
            cursor: pointer;
            float: left;
            margin: 8px 0 0 0;
          "
          class="iconfont"
        >
          <img class="logo" :src="designLogoUrl"
        /></span>
        <span
          @click="handleMyDesign()"
          class="ml60 flex-col-ct cp"
          style="float: left; margin: 17px 0 0 0"
          ><span class="iconfont iconImport"></span>
          <span class="f14 ml4">回到我的设计</span></span
        >
      </div>
      <div class="zwdesign-header--center">
        <div class="left-toolbar">
          <el-tooltip
            v-if="false"
            class="item toolbar-item"
            effect="dark"
            content="重做"
            placement="bottom"
            ><div
              :class="{ 'zw-disabled': this.config.redoLength == 0 }"
              @click.prevent="handleRedo"
            >
              <span class="iconfont iconforward icon"></span>
              <div class="toolbar-item-text mt5 f12">重做</div>
            </div>
          </el-tooltip>
          <el-tooltip
            v-if="false"
            @click="handleClearCanvas"
            class="item toolbar-item"
            effect="dark"
            content="清空"
            placement="bottom"
            ><div @click="handleClearCanvas">
              <span class="iconfont iconbrush icon"></span>
              <div class="toolbar-item-text mt5 f12">清空</div>
            </div>
          </el-tooltip>
          <div class="line"></div>
          <el-switch
            style="margin: 16px 0 0 0; display: block"
            @change="handleChangePartBySwitch"
            v-model="partMode"
            active-color="#13ce66"
            inactive-color="orange"
            active-text="印花"
            inactive-text="刺绣"
            active-value="1"
            inactive-value="2"
          >
          </el-switch>
          <el-popover
            :close-delay="0"
            v-if="currentConfig.support_embroidery"
            @show="getEmbroideryPriceRange"
            width="399"
            trigger="hover"
            placement="bottom"
          >
            <div slot="reference">
              <span
                ><span class="el-popover__reference-wrapper"
                  ><div
                    class="save-record border-r"
                    style="margin: 3px 20px 0 23px; text-align: center"
                    aria-describedby="el-popover-7773"
                    tabindex="0"
                  >
                    <i
                      class="el-icon-money"
                      style="font-size: 17px; color: #495b6e"
                    ></i>
                    <div class="mt5" style="margin: 0px 0 0 0; font-size: 12px">
                      刺绣优惠
                    </div>
                  </div></span
                ></span
              >
            </div>
            <div class="save-record-cont">
              <div class="title-cont">
                <span class="title-text f14">刺绣优惠表格</span>
              </div>
              <div class="content" style="padding: 0px 0px 8px 17px">
                <el-slider
                  v-if="false"
                  :min="1"
                  :max="embroideryNumMax"
                  @input="handleChangeEmbroideryNum"
                  v-model="embroideryNum"
                ></el-slider>
                <div
                  v-if="false"
                  style="margin: 8px 0 0 0"
                  class="flex data-cont"
                >
                  刺绣优惠：{{ embroideryDiscountPrice }} 折
                </div>
                <el-table
                  id="outTable"
                  ref="table"
                  :data="detail.embroideryList"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :header-cell-style="{ 'text-align': 'center' }"
                >
                  <el-table-column width="100px" label="序号" align="center">
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                    </template>
                  </el-table-column>
                  <el-table-column label="低数量" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.lowNum }}
                    </template>
                  </el-table-column>
                  <el-table-column label="高数量" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.highNum }}
                    </template>
                  </el-table-column>
                  <el-table-column label="折扣" align="center">
                    <template slot-scope="scope">
                      {{
                        scope.row.discount == 1
                          ? "无优惠"
                          : scope.row.discount * 10 + "折"
                      }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-popover>

          <div
            v-if="false"
            class="el-tooltip toolbar-item item"
            aria-describedby="el-tooltip-7012"
            tabindex="0"
          >
            <span class="iconfont iconborder-outer icon"></span>
            <div class="toolbar-item-text mt5 f12">辅助线</div>
          </div>
          <div
            v-if="false"
            class="el-tooltip toolbar-item zw-disabled item hide-llp"
            aria-describedby="el-tooltip-4959"
            tabindex="0"
          >
            <span class="iconfont iconcrop icon"></span>
            <div class="toolbar-item-text mt5 f12">编组</div>
          </div>
        </div>
        <div class="right-toolbar"></div>
      </div>
      <div class="zwdesign-header--right logined">
        <el-tooltip
          class="item toolbar-item"
          effect="dark"
          content="快捷键"
          placement="bottom"
        >
          <div
            @click="handleShowKeyConfig"
            class="el-tooltip toolbar-item item"
            aria-describedby="el-tooltip-2902"
            tabindex="0"
            style="cursor: pointer"
          >
            <i
              class="el-icon-paperclip"
              style="font-size: 17px; color: #495b6e"
            ></i>
            <div class="toolbar-item-text mt5 f12">快捷键</div>
          </div>
        </el-tooltip>
        <el-popover
          :close-delay="0"
          @show="getPartData"
          width="399"
          trigger="hover"
          placement="bottom"
        >
          <div slot="reference">
            <span
              ><span class="el-popover__reference-wrapper"
                ><div
                  class="save-record border-r"
                  style="margin: 3px 20px 0 23px"
                  aria-describedby="el-popover-7773"
                  tabindex="0"
                >
                  <i
                    class="el-icon-download"
                    style="font-size: 17px; color: #495b6e"
                  ></i>
                  <div class="mt5" style="margin: 2px 0 0 0">下载</div>
                </div></span
              ></span
            >
          </div>
          <div class="save-record-cont">
            <div class="title-cont">
              <span class="title-text f14">请选择刀板</span>
            </div>
            <div class="content" style="padding: 8px 0px 8px 17px">
              <div class="flex data-cont">
                <div
                  @click="handleSelectPart(record)"
                  v-for="(record, index) in parts"
                  :key="index"
                  class="part-item"
                  :class="{ active: config.downloadPart == record.name }"
                >
                  <img :src="record.src" :alt="record.i18n.zh" /><span
                    class="product-id"
                    >{{ record.i18n.zh }}</span
                  >
                </div>
              </div>
              <div style="text-align: right">
                <el-button
                  @click="handleDownloadPart"
                  type="primary"
                  size="small"
                  >下载</el-button
                >
              </div>
            </div>
          </div>
        </el-popover>
        <el-popover
          :close-delay="0"
          v-if="partMode == '1'"
          @show="getPartData"
          width="399"
          trigger="hover"
          placement="bottom"
        >
          <div slot="reference">
            <span
              ><span class="el-popover__reference-wrapper"
                ><div
                  class="save-record border-r"
                  style="margin: 3px 20px 0 23px"
                  aria-describedby="el-popover-7773"
                  tabindex="0"
                >
                  <i
                    class="el-icon-document-copy"
                    style="font-size: 17px; color: #495b6e"
                  ></i>
                  <div class="mt5" style="margin: 2px 0 0 0">镜像</div>
                </div></span
              ></span
            >
          </div>
          <div class="save-record-cont">
            <div class="title-cont">
              <span class="title-text f14">请选择镜像方式</span>
            </div>
            <div class="content" style="padding: 8px 0px 8px 17px">
              <div style="margin: 8px 0 16px 0">
                <el-radio v-model="config.partConfig" label="1"
                  >左侧到右侧</el-radio
                >
                <el-radio v-model="config.partConfig" label="2"
                  >右侧到左侧</el-radio
                >
                <el-radio v-model="config.partConfig" label="3"
                  >刀版到刀版</el-radio
                >
              </div>
              <div v-if="config.partConfig == '3'" class="flex data-cont">
                <div
                  @click="handleSelectParts(record)"
                  v-for="(record, index) in parts"
                  :key="index"
                  class="part-item"
                  :class="{ active: config.toParts.includes(record.name) }"
                  v-if="record.name != config.activePart"
                >
                  <img :src="record.src" :alt="record.i18n.zh" /><span
                    class="product-id"
                    >{{ record.i18n.zh }}</span
                  >
                </div>
              </div>
              <div style="text-align: right">
                <el-button @click="handleCopyPart" type="primary" size="small"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
        </el-popover>
        <el-popover
          :close-delay="0"
          @show="getPartData"
          width="399"
          trigger="hover"
          v-if="partMode == '1'"
          placement="bottom"
        >
          <div slot="reference">
            <span
              ><span class="el-popover__reference-wrapper"
                ><div
                  class="save-record border-r"
                  style="margin: 3px 20px 0 23px"
                  aria-describedby="el-popover-7773"
                  tabindex="0"
                >
                  <i
                    class="el-icon-share"
                    style="font-size: 17px; color: #495b6e"
                  ></i>

                  <div class="mt5" style="margin: 2px 0 0 0">复制</div>
                </div></span
              ></span
            >
          </div>
          <div class="save-record-cont">
            <div class="title-cont">
              <span class="title-text f14">请选择复制对象</span>
              <span style="float: right"
                ><el-checkbox @change="handleCheckParts" v-model="checkAllParts"
                  >全选</el-checkbox
                ></span
              >
            </div>
            <div class="content" style="padding: 8px 0px 8px 17px">
              <div class="flex data-cont">
                <div
                  @click="handleSelectParts(record)"
                  v-for="(record, index) in parts"
                  :key="index"
                  class="part-item"
                  :class="{ active: config.toParts.includes(record.name) }"
                  v-if="record.name != config.activePart"
                >
                  <img :src="record.src" :alt="record.i18n.zh" /><span
                    class="product-id"
                    >{{ record.i18n.zh }}</span
                  >
                </div>
              </div>
              <div style="text-align: right">
                <el-button @click="handleCopyObject" type="primary" size="small"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
        </el-popover>
        <el-tooltip
          class="item toolbar-item"
          :class="{ active: components.ruler }"
          effect="dark"
          content="标尺"
          placement="bottom"
        >
          <div
            @click="addRuler"
            class="el-tooltip toolbar-item item"
            aria-describedby="el-tooltip-2902"
            tabindex="0"
            style="cursor: pointer"
          >
            <span class="iconfont iconborder-aider icon"></span>
            <div class="toolbar-item-text mt5 f12">标尺</div>
          </div>
        </el-tooltip>
        <el-tooltip
          class="item toolbar-item"
          :class="{ active: components.assistLine }"
          effect="dark"
          content="网格线"
          placement="bottom"
        >
          <div
            @click="addGrid"
            class="el-tooltip toolbar-item item"
            aria-describedby="el-tooltip-2902"
            tabindex="0"
            style="cursor: pointer"
          >
            <span class="iconfont iconguidelines icon"></span>
            <div class="toolbar-item-text mt5 f12">网格线</div>
          </div>
        </el-tooltip>

        <div
          @click="handleFullScreen"
          class="el-tooltip toolbar-item item"
          aria-describedby="el-tooltip-2902"
          tabindex="0"
          style="cursor: pointer"
        >
          <span class="iconfont iconfullscreen icon"></span>
          <div class="toolbar-item-text mt5 f12">全屏</div>
        </div>
        <el-popover
          @show="getDesignData"
          placement="top-start"
          width="300"
          trigger="hover"
          :close-delay="0"
        >
          <div slot="reference">
            <span
              ><span class="el-popover__reference-wrapper"
                ><div
                  class="save-record border-r"
                  aria-describedby="el-popover-7773"
                  tabindex="0"
                >
                  <i class="iconfont iconfolder-open-fill"></i>
                  <div class="mt5">保存记录</div>
                </div></span
              ></span
            >
          </div>
          <div class="save-record-cont">
            <div class="title-cont">
              <span class="title-text f14">我最近设计的产品</span>
            </div>
            <div class="content">
              <div class="flex data-cont">
                <div
                  @click="handleChangeProduct(record)"
                  v-for="(record, index) in designData"
                  :key="index"
                  class="product-item"
                >
                  <img
                    :src="
                      record.coverPicUrl ? record.coverPicUrl : record.picUrl
                    "
                    :alt="record.designEngProName"
                  /><span
                    @click.stop="handleCopyText(record.designId)"
                    class="product-id"
                    >{{ record.designId }}</span
                  >
                </div>
              </div>
              <el-pagination
                style="text-align: center"
                @current-change="handleCurrentChange"
                :current-page="formDesign.pageNum"
                layout="total, prev, next, jumper"
                :total="totalDesign"
                :page-size="6"
              >
              </el-pagination>
            </div>
          </div>
        </el-popover>
        <div class="dividing-line"></div>
        <span v-if="false"
          ><div
            role="tooltip"
            id="el-popover-8583"
            aria-hidden="true"
            class="el-popover el-popper zw-rest-prop shoppingcart-popover"
            tabindex="0"
            style="width: 302px; display: none"
          >
            <div class="el-popover__title">加入购物车</div>
          </div>
          <span class="el-popover__reference-wrapper"
            ><div
              class="shopping-cart el-popover__reference"
              aria-describedby="el-popover-8583"
              tabindex="0"
            >
              <i class="iconfont iconshopping-cart"></i>
              <div class="mt5">加入购物车</div>
              <span class="dot"></span></div></span
        ></span>
        <div v-if="!isReplaceProduct" class="save-btn-content">
          <a
            @click="handleSaveDesign(false)"
            class="el-tooltip btn save-btn f14 item"
            aria-describedby="el-tooltip-1629"
            tabindex="0"
            :style="{
              backgroundColor: isSubmit
                ? 'gray !important'
                : '#4934b2 !important',
            }"
            ><i class="iconfont iconsave-fill mr2"></i>保存 </a
          ><!---->
        </div>
        <div v-if="isReplaceProduct" class="save-btn-content">
          <a
            @click="handleShowDesignConfirm"
            class="el-tooltip btn save-btn f14 item"
            aria-describedby="el-tooltip-1629"
            tabindex="0"
            :style="{
              backgroundColor: isSubmit
                ? 'gray !important'
                : '#4934b2 !important',
            }"
            ><i class="iconfont iconsave-fill mr2"></i>替换产品 </a
          ><!---->
        </div>
        <el-dropdown @command="handleCommandMenu">
          <span class="el-dropdown-link">
            {{ user.nickName ? user.nickName : user.userName
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="console">控制台</el-dropdown-item>
            <el-dropdown-item command="image">我的图库</el-dropdown-item>
            <el-dropdown-item command="design">我的设计</el-dropdown-item>
            <el-dropdown-item command="list">定制产品</el-dropdown-item>
            <el-dropdown-item command="order">订单管理</el-dropdown-item>
            <el-dropdown-item command="cart">购物车</el-dropdown-item>
            <el-dropdown-item command="center">个人中心</el-dropdown-item>
            <el-dropdown-item command="exit">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="addtocar-mask" style="display: none"></div>
      <!----><!----><!----><!---->
    </div>
    <div class="main">
      <div class="left-panel sidebar">
        <div class="toolbar">
          <ul>
            <li
              @click="handleChangeMenu(0)"
              class="tool-item"
              :class="currentMenu === 0 ? 'active' : ''"
            >
              <svg-icon
                class="menu-item"
                :icon-class="currentMenu === 0 ? 'product_fill' : 'product'"
              />
              <p>产品</p>
            </li>
            <li
              @click="handleChangeMenu(1)"
              class="tool-item"
              :class="currentMenu === 1 ? 'active' : ''"
            >
              <i
                class="menu-item iconfont f24"
                :class="{
                  'iconpicture-fill': currentMenu === 1,
                  iconpicture: currentMenu !== 1,
                }"
              />
              <p>图库</p>
            </li>
            <li
              v-if="false"
              @click="handleChangeMenu(2)"
              class="tool-item"
              :class="currentMenu === 2 ? 'active' : ''"
            >
              <svg-icon
                class="menu-item"
                :icon-class="currentMenu === 2 ? 'order_fill' : 'order'"
              />
              <p>背景</p>
            </li>
            <li
              @click="handleChangeMenu(3)"
              class="tool-item"
              :class="currentMenu === 3 ? 'active' : ''"
            >
              <i
                class="menu-item iconfont f24"
                :class="{
                  'icontext-fill': currentMenu === 3,
                  icontext: currentMenu !== 3,
                }"
              />
              <p>文字</p>
            </li>
            <li
              @click="handleChangeMenu(4)"
              class="tool-item"
              :class="currentMenu === 4 ? 'active' : ''"
            >
              <i
                class="menu-item iconfont f24"
                :class="{
                  'iconupload-fill': currentMenu === 4,
                  iconupload: currentMenu !== 4,
                }"
              />
              <p>上传</p>
            </li>
          </ul>
          <ul>
            <li
              @click="handleShowLayer"
              class="tool-item"
              :class="{ active: components.showLayer }"
            >
              <i class="iconfont f24 iconview-layers icon"></i>
              <p>图层</p>
            </li>
            <li class="tool-item">
              <span
                ><span class="el-popover__reference-wrapper"
                  ><div
                    class="el-popover__reference"
                    aria-describedby="el-popover-9990"
                    tabindex="0"
                  >
                    <a target="_blank" class="help-link"
                      ><i class="iconfont f24 iconquestion icon"></i>
                      <p>帮助</p></a
                    >
                  </div></span
                ></span
              >
            </li>
          </ul>
        </div>
        <div class="content sidebar-cont">
          <div
            v-show="currentMenu === 0"
            class="product cont-top"
            :class="{ layer: components.showLayer }"
          >
            <div class="menu">
              <div
                @click="handleSelectProductMenu(0)"
                :class="{ 'menu-item-select': currentProductMenu === 0 }"
                class="menu-item"
              >
                印花产品
              </div>
              <div
                @click="handleSelectProductMenu(1)"
                :class="{ 'menu-item-select': currentProductMenu === 1 }"
                class="menu-item"
              >
                刺绣产品
              </div>
            </div>
            <ProductList
              ref="product1"
              saleType="1"
              :features="currentProductMenu"
              v-if="currentProduct === 0"
              @loaded="handleProductLoaded"
              @add="handleAddProduct"
            ></ProductList>
          </div>
          <div
            v-show="currentMenu === 1"
            class="material cont-top"
            :class="{ layer: components.showLayer }"
          >
            <div class="menu">
              <div
                v-show="partMode == '1'"
                @click="handleSelectMaterial(0)"
                :class="{ 'menu-item-select': currentMaterial === 0 }"
                class="menu-item"
              >
                印花图库
              </div>
              <div
                v-show="partMode == '1'"
                @click="handleSelectMaterial(1)"
                :class="{ 'menu-item-select': currentMaterial === 1 }"
                class="menu-item"
              >
                收费图库
              </div>
              <div
                v-show="partMode == '1'"
                @click="handleSelectMaterial(2)"
                :class="{ 'menu-item-select': currentMaterial === 2 }"
                class="menu-item"
              >
                共享图库
              </div>
              <div
                v-show="partMode == '2'"
                @click="handleSelectMaterial(3)"
                :class="{ 'menu-item-select': currentMaterial === 3 }"
                class="menu-item"
              >
                刺绣图片
              </div>
            </div>
            <ImageList
              ref="imageMe"
              @add="handleAddImage"
              mapSource="02"
              routeName="imageMe"
              v-if="currentMaterial === 0"
            ></ImageList>
            <ImageList
              ref="imageCommon"
              @add="handleAddImage"
              mapSource="01"
              routeName="imageCommon"
              v-if="currentMaterial === 1"
            ></ImageList>
            <ImageList
              ref="imageShare"
              @add="handleAddImage"
              mapSource="01"
              routeName="imageShare"
              v-if="currentMaterial === 2"
            ></ImageList>
            <ImageList
              ref="imageOrder"
              @add="handleAddImage"
              mapSource="01"
              routeName="imageOrder"
              v-if="currentMaterial === 3"
            ></ImageList>
          </div>
          <div
            v-show="currentMenu === 3"
            class="upload-text cont-top"
            :class="{ layerText: components.showLayer }"
          >
            <div class="add-text-btn" @click="handleAddText">
              <div style="display: inline-block">
                <span>添加</span>
                <span style="color: red">{{
                  partMode == "1" ? "印花" : "刺绣"
                }}</span
                >文字
              </div>
            </div>
          </div>
          <div
            v-show="currentMenu === 4"
            class="upload-image cont-top"
            :class="{ layer: components.showLayer }"
          >
            <div class="menu">
              <div
                v-if="partMode == '1'"
                @click="handleSelectUploadImage(0)"
                :class="{ 'menu-item-select': currentUploadImage === 0 }"
                class="menu-item"
              >
                印花图片
              </div>
              <div
                v-if="partMode == '2'"
                @click="handleSelectUploadImage(1)"
                :class="{ 'menu-item-select': currentUploadImage === 1 }"
                class="menu-item"
              >
                刺绣图片
              </div>
            </div>
            <div class="add-text-btn" @click="uploadImg">
              <span class="el-icon-plus mr3"></span>
              <span>上传图片（支持多张）</span>
            </div>
            <div class="remark-box">
              <div class="mb6">
                1.支持{{
                  partMode == "1" ? "批量" : ""
                }}上传JPG、JPEG、PNG格式的图片，文件大小20M以内
              </div>
              <div class="mb6">
                2.请勿上传涉政、涉黄、侵权等违法行为，情节严重的将给予封号处理
              </div>
              <div class="mb6">
                3.上传代表已阅读并同意
                <a>《法律声明》</a>
              </div>
            </div>
            <div class="upload-title">最近上传记录</div>

            <ImageList
              ref="uploadHistory"
              @add="handleAddImage"
              mapSource="01"
              type="uploadImage"
              :routeName="partMode == '1' ? 'imageMe' : 'imageOrder'"
            ></ImageList>

            <div v-show="false" class="upload-btn-box">
              <Button @click="uploadImg" />
              <input multiple ref="upload" type="file" @change="handleUpload" />
              <input
                ref="uploadEmbroideryImage"
                type="file"
                @change="handleUpload"
              />
            </div>
          </div>
          <div
            v-if="components.showLayer"
            class="cont-bottom"
            style="height: 208px"
          >
            <div class="tit">
              <span class="txt">图层（{{ this.partName }}）</span
              ><span class="close"
                ><i
                  @click="handleCloseLayer"
                  class="iconfont iconclose-bold"
                ></i
              ></span>
            </div>
            <div class="resize-area"></div>
            <div class="layer-box scroll-bar p10">
              <div
                v-for="(record, index) in layers"
                :key="index"
                role="group"
                aria-expanded="true"
                @click="handleSelectLayer(index)"
                class="el-tree-node__children"
                :class="{ active: activeLayer == index }"
              >
                <div
                  role="treeitem"
                  class="el-tree-node is-expanded is-current is-focusable"
                >
                  <div class="el-tree-node__content" style="padding-left: 18px">
                    <span
                      class="is-leaf el-tree-node__expand-icon el-icon-caret-right"
                    ></span
                    ><!----><!---->
                    <div class="custom-tree-node node-image">
                      <div class="name ccc">
                        <!----><!---->

                        <i
                          v-if="record.type == 'i-text'"
                          class="iconfont icontext imgbox"
                        ></i>
                        <div v-else class="imgbox">
                          <img :src="record.url" />
                        </div>
                        <label
                          :title="record.name"
                          v-if="record.type == 'i-text'"
                          class="ml5"
                          >{{ record.name ? record.name : "文本" }}</label
                        >
                        <label :title="record.name" v-else class="ml5">{{
                          record.name
                            ? record.name
                            : record.imageInfo.title
                            ? record.imageInfo.title
                            : "图片"
                        }}</label
                        ><!---->
                      </div>
                      <!---->
                      <div class="operates">
                        <span><!----><!----></span
                        ><span class="suspen">
                          <i
                            @click="handleUp(record, index)"
                            class="el-icon-top mr8 up-icon"
                          ></i>

                          <i
                            @click="handleDown(record, index)"
                            class="el-icon-bottom mr8 down-icon"
                          ></i>

                          <i
                            v-if="!record.isLocked"
                            @click="handleLock(record, true, index)"
                            class="iconfont iconunlock-fill mr8 lock-icon"
                          ></i>
                          <i
                            v-if="record.isLocked"
                            @click="handleLock(record, false, index)"
                            class="iconfont iconlock-fill mr8 lock-icon"
                          ></i>
                          <i
                            v-if="record.visible"
                            @click="handleVisible(record, false, index)"
                            class="iconfont iconeye-open mr8 hidden-icon"
                          ></i>
                          <i
                            v-else
                            @click="handleVisible(record, true, index)"
                            class="iconfont iconeye-close mr8 hidden-icon"
                          ></i>
                          <i
                            @click="handleDelete(record, index)"
                            class="el-icon-delete mr8 delete-icon"
                          ></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    role="group"
                    aria-expanded="true"
                    class="el-tree-node__children"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simple-designer">
        <div v-if="false" class="toolbar">
          <div class="operation-list">
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="上移一层"
                placement="top"
              >
                <i
                  @click="handleOper('bringUp')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-moveup"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="下移一层"
                placement="top"
              >
                <i
                  @click="handleOper('bringDown')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-movedown"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="水平居中"
                placement="top"
              >
                <i
                  @click="handleOper('centerX')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-center-horizontally"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="垂直居中"
                placement="top"
              >
                <i
                  @click="handleOper('centerY')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-verticallycentered"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="水平翻转"
                placement="top"
              >
                <i
                  @click="handleOper('flipX')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-horizontal-mirroring"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="垂直翻转"
                placement="top"
              >
                <i
                  @click="handleOper('flipY')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-vertical-mirror"
                ></i>
              </el-tooltip>
            </div>
            <div
              @click.prevent="performAction({ name: 'rotate', value: 45 })"
              class="base-icon-button"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="图案顺时针旋转45°"
                placement="top"
              >
                <i
                  @click="handleRotate(45)"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-clockwise-rotation"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="图案逆时针旋转45°"
                placement="top"
              >
                <i
                  @click="handleRotate(-45)"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-anticlockwise-rotation"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="复制图案"
                placement="top"
              >
                <i
                  @click="handleOper('copy')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-copy-pattern"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="图案宽度最大化"
                placement="top"
              >
                <i
                  @click="handleOper('maximizeByWidth')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-maximize-width"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="图案高度最大化"
                placement="top"
              >
                <i
                  @click="handleOper('maximizeByHeight')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-maximum-height"
                ></i>
              </el-tooltip>
            </div>
            <div class="base-icon-button">
              <el-tooltip
                class="item"
                effect="dark"
                content="图案最大化设计"
                placement="top"
              >
                <i
                  @click="handleOper('maximize')"
                  class="thirdly-designer-icon base-icon thirdly-designer-icon-maximizethepattern"
                ></i>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="main-panel">
          <div id="designerDiv"></div>
        </div>
        <ul
          :style="{ height: partMode == '1' ? '198px' : '39px' }"
          class="bg-color-set"
          style="padding: 2px 0 0 0"
        >
          <li v-if="canChangeBackgroundColor && partMode == '1'" class="bg-color-pick">
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <!---->
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="背景色"
                  placement="right"
                >
                  <div
                    ref=""
                    @click="handleSetBackgroundColor"
                    class="el-color-picker__trigger"
                  >
                    <span class="el-color-picker__color is-alpha hascolor"
                      ><span
                        class="el-color-picker__color-inner"
                        :style="{ backgroundColor: config.backgroundColor }"
                      ></span
                      ><!----></span
                    >
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li
            v-if="canChangeBackgroundColor && partMode == '1'"
            class="bg-color-pick"
            style="margin-bottom: 0px"
          >
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除背景色"
                  placement="right"
                >
                  <div
                    @click="handleDeleteBackground('')"
                    class="el-color-picker__trigger"
                  >
                    <span class="el-color-picker__color is-delete"
                      ><span
                        class="el-color-picker__color-inner"
                        style="background-color: transparent"
                      ></span
                    ></span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li
            v-if="partMode == '1'"
            class="bg-color-pick"
            style="margin-bottom: 6px"
          >
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="撤销"
                  placement="right"
                >
                  <div @click="handleUndo" class="el-color-picker__trigger">
                    <span
                      style="background: #ffffff; padding: 2px 0 0 0"
                      class="el-color-picker__color is-alpha hascolor"
                      ><span
                        style="font-size: 20px"
                        class="iconfont iconbackward icon"
                      ></span>
                    </span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li
            v-if="partMode == '1'"
            class="bg-color-pick"
            style="margin-bottom: 6px"
          >
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="重做"
                  placement="right"
                >
                  <div @click="handleRedo()" class="el-color-picker__trigger">
                    <span
                      style="background: #ffffff; padding: 2px 0 0 0"
                      class="el-color-picker__color is-alpha hascolor"
                      ><span
                        style="font-size: 20px"
                        class="iconfont iconforward icon"
                      ></span>
                    </span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
          <li class="bg-color-pick" style="margin-bottom: -5px">
            <div class="zw-color-picker mr20">
              <div class="el-color-picker el-color-picker--small">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="清空"
                  placement="right"
                >
                  <div
                    @click="handleClearCanvas"
                    class="el-color-picker__trigger"
                  >
                    <span
                      style="background: #ffffff; padding: 2px 0 0 0"
                      class="el-color-picker__color is-alpha hascolor"
                      ><span
                        style="font-size: 20px"
                        class="iconfont iconbrush icon"
                      ></span>
                    </span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </li>
        </ul>
        <ul
          :style="{
            height: '239px',
            width: '106px',
          }"
          class="bg-color-set"
          style="padding: 8px 2px 4px 2px; top: 290px;right: calc(10vw - 126px);"
        >
          <li class="bg-color-pick" style="margin-bottom: 6px">
            X
            <el-input-number
              @change="handleChangeLayer('x')"
              style="width: 100px;"
              type="text"
              v-model="layerInfo.x"
              size="small"
              controls-position="right"
            ></el-input-number>
          </li>
          <li class="bg-color-pick" style="margin-bottom: 6px">
            Y
            <el-input-number
              @change="handleChangeLayer('y')"
              style="width: 100px;"
              type="text"
              v-model="layerInfo.y"
              size="small"
              controls-position="right"
            ></el-input-number>
          </li>
          <li class="bg-color-pick" style="margin-bottom: 6px">
            宽
            <el-input-number
              @change="handleChangeLayer('w')"
              style="width: 100px;"
              type="text"
              v-model="layerInfo.w"
              size="small"
              controls-position="right"
            ></el-input-number>
          </li>
          <li class="bg-color-pick" style="margin-bottom: 6px">
            高
            <el-input-number
              @change="handleChangeLayer('h')"
              style="width: 100px;"
              type="text"
              v-model="layerInfo.h"
              size="small"
              controls-position="right"
            ></el-input-number>
          </li>
        </ul>
        <ul
          :style="{ paddingBottom: partMode == '1' ? '0px' : '0px' }"
          class="view-img"
        >
          <li
            @click="handleChangePart(record)"
            v-for="(record, index) in parts"
            :key="index"
            :style="{
              marginBottom:
                partMode == '1' && index != parts.length - 1 ? '12px' : '23px',
            }"
            v-if="
              (!record.support_embroidery && partMode == '1') ||
                (record.support_embroidery && partMode == '2')
            "
            :class="{ active: record.name == config.activePart }"
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="record.i18n.zh"
              placement="left"
              :key="index"
            >
              <img :src="record.src" />
            </el-tooltip>
            <div
              v-if="partMode == '2'"
              style="
                margin: 4px 0 0 0;
                text-align: center;
                position: absolute;
                top: 56px;
                left: 8px;
              "
            >
              + ¥ {{ record.embroidery_params.CNY }}
            </div>
          </li>
          <li
            v-if="partMode == '2' && embroideryPrice > 0"
            style="
              background: transparent;
              text-align: center;
              line-height: 25px;
              height: 25px;
              padding: 0;
              margin-bottom: 0;
              font-weight: bold;
            "
          >
            合计:¥<span style="color: red">{{ embroideryPrice }}</span>
          </li>
        </ul>
        <ColorPicker
          v-if="components.colorPicker"
          class="bg-color-picker-"
          @change="handleChangeColor"
          :currentColor="config.backgroundColor"
        ></ColorPicker>
        <div
          :style="{ top: this.toolBarHeight + 'px' }"
          class="designer-footer-left"
        >
          <p class="">印刷品质 (优秀)</p>
          <p
            v-if="currentPart && !currentPart.support_embroidery"
            style="color: rgba(0, 0, 0, 0.45)"
          >
            推荐尺寸 (<span style="color: red"
              >{{ currentPart.psd_params.width }} *
              {{ currentPart.psd_params.height }}</span
            >)
          </p>
          <p
            v-if="currentPart && currentPart.support_embroidery"
            style="color: rgba(0, 0, 0, 0.45)"
          >
            推荐尺寸 (<span style="color: red"
              >{{ currentPart.embroidery_params.width }} *
              {{ currentPart.embroidery_params.height }}</span
            >)
          </p>
        </div>
        <div
          :style="{ top: this.toolBarHeight + 'px' }"
          class="designer-footer-center"
        >
          <p v-if="false">{{ detail.proName }}</p>
          <span>{{ partName }}</span>
        </div>
        <div
          :style="{ top: this.toolBarHeight + 'px' }"
          class="designer-footer-right"
        >
          <div @click="handleRecoverCanvasSize" class="maximize">
            <i class="iconfont iconcanvas-recovery"></i>
          </div>
          <i @click="handleMinusCanvasSize" class="iconfont iconzoom-out"></i>
          <div class="slider">
            <div
              role="slider"
              aria-valuemin="0"
              aria-valuemax="100"
              aria-orientation="horizontal"
              class="el-slider"
              aria-valuetext="0"
              aria-label="slider between 0 and 100"
            >
              <el-slider
                @input="handleChangeCanvasSize"
                v-model="config.canvasSize"
              ></el-slider>
            </div>
          </div>
          <i @click="handleAddCanvasSize" class="iconfont iconzoom-in"></i>
        </div>
      </div>
      <el-tabs
        v-model="activeView"
        @tab-click="handleChangeView"
        class="el-tabs"
        tab-position="left"
        style="height: 90px;position:absolute;right: 325px;top: 0px;"
      >
        <el-tab-pane name="2D" label="2D"></el-tab-pane>
        <el-tab-pane name="3D" label="3D"></el-tab-pane>
      </el-tabs>

      <div class="product-detail-box right-panel">
        <div class="thumb">
          <el-carousel
            v-show="activeView == '2D'"
            @change="handleChangePreview"
            trigger="hover"
            arrow="always"
            height="330px"
            :autoplay="false"
          >
            <el-carousel-item
              @click.native="handleShowPreview"
              v-for="(record, index) in previewsData"
              :key="index"
            >
            </el-carousel-item>
          </el-carousel>
          <canvas
            v-show="activeView == '3D'"
            id="preview"
            :width="600"
            :height="600"
            style="width: 330px; height: 330px;"
          />
          <i
            v-show="activeView == '3D'"
            style="
            top: 20px;
            right: 130px;
              position: absolute;
              cursor: pointer;
              font-size: 20px;
              z-index: 1000;
            "
            @click="handleReset3D"
            class="el-icon-refresh-left"
          ></i>

          <i
            v-show="activeView == '3D'"
            style="
            top: 20px;
            right: 180px;
              position: absolute;
              cursor: pointer;
              font-size: 20px;
              z-index: 1000;
            "
            @click="exportCanvasAsPNG"
            class="el-icon-camera"
          ></i>
          <pic-zoom
            v-show="activeView == '2D'"
            @click.native="handleShowPreview"
            id="pic-zoom"
            style="
              width: 330px;
              height: 330px;
              position: absolute;
              z-index: 100;
            "
            :url="previewImageUrl"
            :scale="3"
          ></pic-zoom>
        </div>
        <div v-if="currentBox == 'product'">
          <div class="row-name pt13">
            <div class="container">
              <div class="name-box">
                <div class="flex name-item">
                  <div
                    class="el-tooltip name mr2 item"
                    aria-describedby="el-tooltip-7040"
                    tabindex="0"
                  >
                    {{ detail.proName }}
                  </div>
                </div>
                <div class="code">(编号:{{ detail.pId }})</div>
                <div class="icons"><!----><!----><!----><!----></div>
              </div>
              <div class="price-box">
                <span class="price"
                  ><span class="unit">￥</span
                  ><span>{{ detail.price + embroideryPrice }}</span></span
                >
              </div>
            </div>
          </div>
          <div class="details scroll-bar">
            <div class="row-info color-primary pointer">
              <a @click="handleJumpDetail"
                ><span>产品信息，价格和指南</span
                ><i class="iconfont iconcaret-right va-2"></i
              ></a>
            </div>
            <div class="row-process">
              <label class="pr36">工艺</label>
              <div class="process-list">
                <div class="process-item active">{{ detail.prodTech }}</div>
              </div>
              <div class="tips align-center" style="display: none">
                工艺说明 <i class="iconfont iconarrow-right-bold va-2 ml5"></i>
              </div>
            </div>
            <div class="sku-attr">
              <div class="sku-name" style="margin: 7px 32px 8px 0">
                颜色
                <i
                  v-if="!components.showProductColor"
                  @click="components.showProductColor = true"
                  class="el-icon-arrow-up"
                ></i>
                <i
                  v-if="components.showProductColor"
                  @click="components.showProductColor = false"
                  class="el-icon-arrow-down"
                ></i>
              </div>
              <div v-if="components.showProductColor" class="sku-detail">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="color"
                  placement="top"
                  v-for="(color, index) in colorList"
                  :key="index"
                >
                  <a
                    :style="{ background: dictMap['color'][color] }"
                    :class="{ 'is-select': currentAttr.color === color }"
                    @click="handleSelectColor(color)"
                    class="sku-color"
                  ></a>
                </el-tooltip>
              </div>
            </div>
            <div class="sku-attr">
              <div class="sku-name" style="margin: 7px 32px 8px 0">
                尺码

                <i
                  v-if="!components.showProductSize"
                  @click="components.showProductSize = true"
                  class="el-icon-arrow-up"
                ></i>
                <i
                  v-if="components.showProductSize"
                  @click="components.showProductSize = false"
                  class="el-icon-arrow-down"
                ></i>
              </div>
              <div
                v-if="components.showProductSize"
                class="sku-detail"
                style="margin: 4px 0 0 0"
              >
                <a
                  :class="{ 'is-select': currentAttr.size === size }"
                  @click="handleSelectSize(size)"
                  class="sku-size"
                  v-for="(size, index) in sizeList"
                  :key="index"
                  >{{ size }}</a
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentBox == 'embroideryImage'">
          <div
            v-for="(color, index) in embroideryImageColorsOrigin"
            :key="index"
            class="details scroll-bar"
            style="border-top: none"
          >
            <div class="row-process">
              <label class="pr36">颜色替换{{ index + 1 }}</label>
              <div class="process-list">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="color"
                  placement="top"
                >
                  <a
                    :style="{ background: textColorMap[color] }"
                    class="sku-color"
                  ></a>
                </el-tooltip>
                <i
                  style="font-size: 20px; margin: 8px 19px 0 12px"
                  class="el-icon-right"
                ></i>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="color"
                  placement="top"
                >
                  <a
                    @click="handleSetColor(index)"
                    :style="{
                      background: textColorMap[embroideryImageColors[index]],
                    }"
                    class="sku-color"
                  ></a>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div style="text-align: center; margin: 16px 0 0 0">
            <el-button
              v-if="false"
              @click="updateEmbroideryImage"
              type="primary"
              size="small"
              >保存</el-button
            >
          </div>
        </div>
        <div class="embroidery-text" v-if="currentBox == 'embroidery'">
          <el-form
            ref="form"
            :model="textForm"
            label-width="90px"
            :rules="rulesText"
            style="margin: 15px"
          >
            <el-form-item label="添加文字：" prop="text">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入英文，暂不支持中文"
                v-model="textForm.text"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="字号：" prop="delivery">
              <el-checkbox size="small" v-model="textForm.bold"
                >加粗</el-checkbox
              >
              <el-checkbox size="small" v-model="textForm.italic"
                >斜体</el-checkbox
              >
            </el-form-item>
            <el-form-item label="字体工艺：" prop="font_type">
              <el-radio-group
                @change="handleChangeEmbroideryFontType"
                v-model="textForm.font_type"
              >
                <el-radio label="2d">平面绣</el-radio>
                <el-radio label="3d">立体绣</el-radio>
              </el-radio-group>
              <div>
                <el-image
                  style="width: 100px; height: 100px"
                  :src="textForm.font_type == '2d' ? image2D : image3D"
                  :preview-src-list="
                    textForm.font_type == '2d' ? [image2D] : [image3D]
                  "
                >
                </el-image>
              </div>
            </el-form-item>
            <el-form-item label="字体：" prop="font_family">
              <el-select
                size="small"
                v-model="textForm.font_family"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in embroideryFontList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="颜色：" prop="delivery">
              <div slot="label">
                颜色：<br /><el-button @click="handleCopyColor" type="text"
                  >复制颜色</el-button
                >
              </div>
              <ul class="background-color-content">
                <el-tooltip
                  v-for="(color, idx) in textColorList"
                  :key="idx"
                  effect="dark"
                  :content="color.hex"
                  placement="top"
                >
                  <li
                    class="background-color-item"
                    :style="{ background: color.hex }"
                    @click="selectTextColor(color, idx)"
                    style="position: relative"
                  >
                    <i
                      class="el-icon-check"
                      style="position: absolute; top: 5px; left: 5px"
                      :style="{
                        color:
                          textForm.color_name == 'white' ? 'black' : '#ffffff',
                      }"
                      v-if="textForm.color_name === color.name"
                    ></i>
                  </li>
                </el-tooltip>
              </ul>
            </el-form-item>
          </el-form>
          <div style="text-align: center">
            <div class="save-btn-content">
              <a
                @click="handleAddEmbroideryText()"
                aria-describedby="el-tooltip-1629"
                tabindex="0"
                class="el-tooltip btn save-btn f14 item"
                style="background-color: rgb(24, 144, 255) !important"
                ><i class="iconfont iconsave-fill mr2"></i>保存
              </a>
            </div>
          </div>
        </div>

        <div class="gallery-detail-box" v-if="currentBox == 'image'">
          <div class="inner-content scroll-bar">
            <!---->
            <div class="img-info">
              <div class="img-info--left pl20">
                <span class="iconfont iconpicture"></span>
                <div :title="currentObject.name" class="f14 ml10 imgName">
                  {{ currentObject.name }}
                  <span style="">.png</span>
                </div>
                <div v-if="false" class="f14 ml10 imgSize">尺寸：4851X4659</div>
              </div>
              <div class="img-info--right pr20 flex flex-col-ct">
                <el-checkbox v-model="config.replaceImage"
                  >替换图片</el-checkbox
                >
              </div>
            </div>

            <div class="img-replace-tip-mask" style="display: none"></div>

            <div class="operation-content">
              <div class="operate-bar">
                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="最大化设计"
                  placement="top"
                > -->
                <div
                  title="最大化设计"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'maximize' })"
                  class="imgway-col"
                >
                  <span
                    class="el-tooltip operate-item mini iconfont iconfullscreen1"
                    slot="reference"
                    aria-describedby="el-tooltip-3381"
                    tabindex="0"
                  ></span>
                </div>
                <!-- </el-tooltip> -->

                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="铺满设计区域"
                  placement="top"
                > -->
                <div
                  title="铺满设计区域"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'maximize' })"
                  class="imgway-col"
                >
                  <span
                    class="el-tooltip operate-item mini iconfont iconarrawsalt"
                    slot="reference"
                    aria-describedby="el-tooltip-3591"
                    tabindex="0"
                  ></span>
                </div>
                <!-- </el-tooltip> -->

                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="高度最大化"
                  placement="top"
                > -->
                <div
                  title="高度最大化"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'maximizeByHeight' })"
                  class="imgway-col"
                >
                  <span
                    class="el-tooltip operate-item mini iconfont iconcolum-height"
                    slot="reference"
                    aria-describedby="el-tooltip-4241"
                    tabindex="0"
                  ></span>
                </div>
                <!-- </el-tooltip> -->

                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="宽度最大化"
                  placement="top"
                > -->
                <div
                  title="宽度最大化"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'maximizeByWidth' })"
                  class="imgway-col"
                >
                  <span
                    class="el-tooltip operate-item mini iconfont iconcolumn-width1"
                    slot="reference"
                    aria-describedby="el-tooltip-3917"
                    tabindex="0"
                  ></span>
                </div>
                <!-- </el-tooltip> -->
              </div>

              <div class="operate-bar">
                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="水平翻转"
                  placement="top"
                > -->
                <span
                  title="水平翻转"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'flipX' })"
                  class="el-tooltip operate-item mini iconfont iconzuoyoufanzhuan_huaban1"
                  aria-describedby="el-tooltip-5598"
                  tabindex="0"
                ></span>
                <!-- </el-tooltip> -->
                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="垂直翻转"
                  placement="top"
                > -->
                <span
                  title="垂直翻转"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'flipY' })"
                  class="el-tooltip operate-item mini iconfont iconchuizhifanzhuan_huaban1"
                  aria-describedby="el-tooltip-9616"
                  tabindex="0"
                ></span>
                <!-- </el-tooltip> -->

                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="逆时针旋转45度"
                  placement="top"
                > -->
                <span
                  title="逆时针旋转45度"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'rotate', value: -45 })"
                  class="el-tooltip operate-item mini iconfont iconrotate-left45"
                  aria-describedby="el-tooltip-3359"
                  tabindex="0"
                ></span>
                <!-- </el-tooltip> -->

                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="顺时针旋转45度"
                  placement="top"
                > -->
                <span
                  title="顺时针旋转45度"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'rotate', value: 45 })"
                  class="el-tooltip operate-item mini iconfont iconrotate-right45"
                  aria-describedby="el-tooltip-4783"
                  tabindex="0"
                ></span>
                <!-- </el-tooltip> -->
              </div>
              <div class="operation-item" style="margin: 16px 0">
                <div class="operation-item-title" style="font-size: 14px">
                  旋转
                </div>
                <div class="operation-item-content" style="background: #ffffff">
                  <el-slider
                    :min="-180"
                    :max="180"
                    @input="
                      performAction({
                        name: 'rotate',
                        value: config.rotate,
                        incremental: false,
                      })
                    "
                    style="width: calc(100% - 125px); margin: 0 0 0 0px"
                    v-model="config.rotate"
                  ></el-slider>
                  <el-input-number
                    :class="{ 'zw-disabled': config.isLocked }"
                    class="zw-slide-input"
                    v-model="config.rotate"
                    width="90px"
                    style="width: 90px"
                    :min="-180"
                    :max="180"
                    controls-position="right"
                    @change="
                      performAction({
                        name: 'rotate',
                        value: config.rotate,
                        incremental: false,
                      })
                    "
                    size="mini"
                  ></el-input-number>
                </div>
              </div>
              <div class="tileway-container">
                <div style="position: relative" class="operate-bar">
                  <div
                    :class="{ 'zw-disabled': config.isLocked }"
                    @click.prevent="handleTileBasic"
                    class="el-tooltip operate-item medium operate-item medium tile-button"
                    aria-describedby="el-tooltip-9893"
                    tabindex="0"
                    style="margin-top: 2px"
                    :style="{
                      background: isTile == 'basic' ? '#4934b2' : '#f0f2f5',
                      color: isTile == 'basic' ? '#ffffff' : 'inherit',
                    }"
                  >
                    基础平铺
                  </div>
                  <div
                    :class="{ 'zw-disabled': config.isLocked }"
                    @click.prevent="handleTileDrop"
                    class="el-tooltip operate-item medium operate-item medium tile-button"
                    aria-describedby="el-tooltip-9893"
                    tabindex="0"
                    style="margin-top: 8px"
                    :style="{
                      background: isTile == 'drop' ? '#4934b2' : '#f0f2f5',
                      color: isTile == 'drop' ? '#ffffff' : 'inherit',
                    }"
                  >
                    横向平铺
                  </div>
                  <div
                    :class="{ 'zw-disabled': config.isLocked }"
                    @click.prevent="handleTileBrick"
                    class="el-tooltip operate-item medium operate-item medium tile-button"
                    aria-describedby="el-tooltip-9893"
                    tabindex="0"
                    style="margin-top: 8px"
                    :style="{
                      background: isTile == 'brick' ? '#4934b2' : '#f0f2f5',
                      color: isTile == 'brick' ? '#ffffff' : 'inherit',
                    }"
                  >
                    纵向平铺
                  </div>
                  <div
                    :class="{ 'zw-disabled': config.isLocked }"
                    @click.prevent="handleTileMirror"
                    class="el-tooltip operate-item medium operate-item medium tile-button"
                    aria-describedby="el-tooltip-9893"
                    tabindex="0"
                    style="margin-top: 8px"
                    :style="{
                      background: isTile == 'mirror' ? '#4934b2' : '#f0f2f5',
                      color: isTile == 'mirror' ? '#ffffff' : 'inherit',
                    }"
                  >
                    镜像平铺
                  </div>
                  <div
                    :class="{ 'zw-disabled': config.isLocked }"
                    @click.prevent="handleUnTile"
                    class="el-tooltip operate-item medium"
                    aria-describedby="el-tooltip-519"
                    tabindex="0"
                    style="margin-top: 8px;width: 100%;"
                  >
                    取消平铺
                  </div>
                  <div v-if="config.showTileConfig" class="tileway-pop">
                    <div class="zw-slide-pop">
                      <div class="zw-slide-pop-main">
                        <div class="slide">
                          <span>横向间距</span>
                          <el-slider
                            @change="handleTile"
                            style="width: 119px; margin: 0 0 0 16px"
                            v-model="config.gapWidth"
                          ></el-slider>
                        </div>
                        <div class="slide">
                          <span>纵向间距</span>
                          <el-slider
                            @change="handleTile"
                            style="width: 119px; margin: 0 0 0 16px"
                            v-model="config.gapHeight"
                          ></el-slider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!---->
              </div>
              <div v-if="false" class="operation-item">
                <div class="operation-item-title">
                  设置
                  <i
                    class="el-tooltip iconfont iconsetting ml5"
                    aria-describedby="el-tooltip-6838"
                    tabindex="0"
                    style="opacity: 0.45"
                  ></i>
                </div>
                <div class="operation-item-content" style="padding: 0px 26px">
                  <el-checkbox
                    :class="{ 'zw-disabled': config.isLocked }"
                    @change="handleSetBackground"
                    v-model="config.isSetBackground"
                    >设为背景</el-checkbox
                  >

                  <label
                    v-if="false"
                    class="el-checkbox el-tooltip"
                    aria-describedby="el-tooltip-734"
                    tabindex="0"
                    ><span class="el-checkbox__input"
                      ><span class="el-checkbox__inner"></span
                      ><input
                        type="checkbox"
                        aria-hidden="false"
                        class="el-checkbox__original"
                        value=""/></span
                    ><span class="el-checkbox__label"
                      ><span class="f12">应用所有面</span
                      ><!----></span
                    ></label
                  >
                </div>
              </div>
              <div v-if="false" class="operation-item2">
                <div :class="{ 'zw-disabled': config.isLocked }" class="item">
                  <i class="iconfont iconfilter"></i
                  ><span class="ml5">滤镜</span>
                </div>
              </div>
            </div>

            <div style="margin: 8px 0 0 0" class="item-box--suspend">
              <div class="optBox-bg">
                <div class="flex opt-box">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="放大"
                    placement="top"
                  >
                    <i
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click="handleZoomin"
                      class="el-icon-zoom-in opt-item"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></i>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="缩小"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click="handleZoomout"
                      class="el-icon-zoom-out opt-item"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="复制"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click="handleCopy"
                      class="el-tooltip item iconfont iconfile-add opt-item cp"
                      aria-describedby="el-tooltip-7163"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="透明"
                    placement="top"
                  >
                    <i
                      style="cursor: pointer; font-size: 20px"
                      @click.prevent="handleShowOpacity"
                      :class="{ 'zw-disabled': config.isLocked }"
                      class="el-icon-view opt-item"
                    ></i>
                  </el-tooltip>
                  <div v-if="components.showOpacityConfig" class="opacity-pop">
                    <div class="zw-slide-pop" style="padding: 0 10px">
                      <div class="zw-slide-pop-main">
                        <div class="slide">
                          <span>透明</span>
                          <el-slider
                            @change="handleChangeOpacity"
                            style="width: calc(100% - 69px); margin: 0 0 0 16px"
                            v-model="config.opacity"
                          ></el-slider>
                        </div>
                      </div>
                    </div>
                  </div>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="加锁"
                    placement="top"
                    v-if="!config.isLocked"
                  >
                    <span
                      @click="handleLockLayer(true)"
                      class="el-tooltip iconfont iconunlock opt-item cp item"
                      aria-describedby="el-tooltip-7767"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="解锁"
                    placement="top"
                    v-if="config.isLocked"
                  >
                    <span
                      @click="handleLockLayer(false)"
                      class="el-tooltip iconfont iconlock opt-item cp item"
                      aria-describedby="el-tooltip-7767"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click="handleRemove"
                      class="el-tooltip item iconfont icondelete opt-item cp"
                      aria-describedby="el-tooltip-1901"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <!---->
          <div class="el-dialog__wrapper" style="display: none">
            <div
              role="dialog"
              aria-modal="true"
              aria-label="dfdf"
              class="el-dialog zw-message-pop"
              style="margin-top: 15vh; width: 480px"
            >
              <div class="el-dialog__header">
                <div class="dialog-title">
                  <i class="el-icon-warning primary-icon"></i>
                  图片设置选择
                </div>
                <button
                  type="button"
                  aria-label="Close"
                  class="el-dialog__headerbtn"
                >
                  <i class="el-dialog__close el-icon el-icon-close"></i>
                </button>
              </div>
              <!---->
              <div class="el-dialog__footer">
                <div class="dialog-footer">
                  <button
                    type="button"
                    class="el-button el-button--default el-button--small"
                  >
                    <!----><!----><span>取消</span></button
                  ><button
                    type="button"
                    class="el-button el-button--primary el-button--small"
                  >
                    <!----><!----><span>确定</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-detail-box" v-if="currentBox == 'text'">
          <div class="inner-content scroll-bar">
            <div v-if="false" class="img-info">
              <div class="img-info--left pl20">
                <span class="iconfont icontext"></span
                ><span class="f14 ml10 textName">文字图层</span>
              </div>
              <div v-if="false" class="img-info--right pr20 flex flex-col-ct">
                <span>编辑文本</span
                ><span class="iconfont iconarrow-right-bold"></span>
              </div>
            </div>
            <div class="operation-content">
              <div v-if="false" class="operation-item">
                <div class="operation-item-title">描边</div>
                <div
                  :class="{ 'zw-disabled': config.isLocked }"
                  class="operation-item-content"
                  style="justify-content: flex-start"
                >
                  <div
                    class="zw-color-picker text-color"
                    style="margin-right: 10px"
                  >
                    <div class="el-color-picker el-color-picker--small">
                      <!---->
                      <div class="el-color-picker__trigger">
                        <span class="el-color-picker__color is-alpha"
                          ><span
                            class="el-color-picker__color-inner"
                            style="background-color: transparent"
                          ></span
                          ><span
                            class="el-color-picker__empty el-icon-close"
                          ></span></span
                        ><span
                          class="el-color-picker__icon el-icon-arrow-down"
                          style="display: none"
                        ></span>
                      </div>
                      <div
                        class="el-color-dropdown el-color-picker__panel zw-color-picker-pop"
                        style="display: none"
                      >
                        <div class="el-color-dropdown__main-wrapper">
                          <div
                            class="el-color-hue-slider is-vertical"
                            style="float: right"
                          >
                            <div class="el-color-hue-slider__bar"></div>
                            <div
                              class="el-color-hue-slider__thumb"
                              style="left: 0px; top: 0px"
                            ></div>
                          </div>
                          <div
                            class="el-color-svpanel"
                            style="background-color: rgb(255, 0, 0)"
                          >
                            <div class="el-color-svpanel__white"></div>
                            <div class="el-color-svpanel__black"></div>
                            <div
                              class="el-color-svpanel__cursor"
                              style="top: 0px; left: 0px"
                            >
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="el-color-alpha-slider"
                          style="display: none"
                        >
                          <div
                            class="el-color-alpha-slider__bar"
                            style="
                              background: linear-gradient(
                                to right,
                                rgba(255, 0, 0, 0) 0%,
                                rgb(255, 0, 0) 100%
                              );
                            "
                          ></div>
                          <div
                            class="el-color-alpha-slider__thumb"
                            style="left: 0px; top: 0px"
                          ></div>
                        </div>
                        <div class="zw-color-predefine" style="display: flex">
                          <span
                            class="color-mark iconfont iconstraw"
                            style="
                              width: 24px;
                              height: 24px;
                              text-align: center;
                              font-size: 24px;
                              margin-left: 5px;
                              margin-top: 8px;
                              border-radius: 3px;
                              cursor: pointer;
                            "
                          ></span
                          ><span
                            class="iconfont icondisable-redline"
                            style="
                              width: 24px;
                              height: 24px;
                              text-align: center;
                              font-size: 24px;
                              margin-left: 5px;
                              margin-top: 8px;
                              border-radius: 3px;
                              color: red;
                              cursor: pointer;
                              border: 1px solid rgb(224, 229, 234);
                            "
                          ></span>
                          <div class="el-color-predefine">
                            <div class="el-color-predefine__colors">
                              <div class="el-color-predefine__color-selector">
                                <div
                                  style="background-color: rgb(0, 0, 0)"
                                ></div>
                              </div>
                              <div class="el-color-predefine__color-selector">
                                <div
                                  style="background-color: rgb(255, 255, 255)"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="zw-slide-input" style="width: 83px">
                    <el-input size="mini"></el-input>
                  </div>
                </div>
              </div>
              <div class="operate-bar">
                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="最大化设计"
                  placement="top"
                > -->
                <div
                  title="最大化设计"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'maximize' })"
                  class="imgway-col"
                >
                  <span
                    class="el-tooltip operate-item mini iconfont iconfullscreen1"
                    slot="reference"
                    aria-describedby="el-tooltip-3381"
                    tabindex="0"
                  ></span>
                </div>
                <!-- </el-tooltip> -->
                <!-- 
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="铺满设计区域"
                  placement="top"
                > -->
                <div
                  title="铺满设计区域"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'maximize' })"
                  class="imgway-col"
                >
                  <span
                    class="el-tooltip operate-item mini iconfont iconarrawsalt"
                    slot="reference"
                    aria-describedby="el-tooltip-3591"
                    tabindex="0"
                  ></span>
                </div>
                <!-- </el-tooltip> -->
                <!-- 
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="高度最大化"
                  placement="top"
                > -->
                <div
                  title="高度最大化"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'maximizeByHeight' })"
                  class="imgway-col"
                >
                  <span
                    class="el-tooltip operate-item mini iconfont iconcolum-height"
                    slot="reference"
                    aria-describedby="el-tooltip-4241"
                    tabindex="0"
                  ></span>
                </div>
                <!-- </el-tooltip> -->
                <!-- <el-tooltip
                  class="item"
                  effect="dark"
                  content="宽度最大化"
                  placement="top"
                > -->
                <div
                  title="宽度最大化"
                  :class="{ 'zw-disabled': config.isLocked }"
                  @click.prevent="performAction({ name: 'maximizeByWidth' })"
                  class="imgway-col"
                >
                  <span
                    class="el-tooltip operate-item mini iconfont iconcolumn-width1"
                    slot="reference"
                    aria-describedby="el-tooltip-3917"
                    tabindex="0"
                  ></span>
                </div>
                <!-- </el-tooltip> -->
              </div>

              <div class="operation-item">
                <div class="operation-item-title" style="font-size: 14px">
                  旋转
                </div>

                <div class="operation-item-content" style="background: #ffffff">
                  <el-slider
                    :min="0"
                    :max="360"
                    @change="
                      performAction({
                        name: 'rotate',
                        value: config.rotate,
                        incremental: false,
                      })
                    "
                    style="width: calc(100% - 105px); margin: 0 0 0 16px"
                    v-model="config.rotate"
                  ></el-slider>
                  <el-input
                    :class="{ 'zw-disabled': config.isLocked }"
                    class="zw-slide-input"
                    v-model="config.rotate"
                    width="60px"
                    style="width: 60px"
                    controls-position="right"
                    @change="
                      performAction({
                        name: 'rotate',
                        value: config.rotate,
                        incremental: false,
                      })
                    "
                    size="mini"
                  ></el-input>
                </div>
              </div>
              <div class="operation-item">
                <div class="operation-item-content">
                  <div class="zw-color-picker text-color ml3 mr3">
                    <div class="el-color-picker el-color-picker--small">
                      <!---->
                      <div
                        :class="{ 'zw-disabled': config.isLocked }"
                        @click="handleSetTextColor"
                        class="el-color-picker__trigger"
                      >
                        <span class="el-color-picker__color is-alpha hascolor"
                          ><span
                            class="el-color-picker__color-inner"
                            :style="{
                              backgroundColor: config.backgroundColorText,
                            }"
                          ></span
                          ><!----></span
                        ><span
                          class="el-color-picker__icon el-icon-arrow-down"
                          style=""
                        ></span>
                      </div>
                      <div
                        class="el-color-dropdown el-color-picker__panel zw-color-picker-pop"
                        style="display: none"
                      >
                        <div class="el-color-dropdown__main-wrapper">
                          <div
                            class="el-color-hue-slider is-vertical"
                            style="float: right"
                          >
                            <div class="el-color-hue-slider__bar"></div>
                            <div
                              class="el-color-hue-slider__thumb"
                              style="left: 0px; top: 0px"
                            ></div>
                          </div>
                          <div
                            class="el-color-svpanel"
                            style="background-color: rgb(255, 0, 0)"
                          >
                            <div class="el-color-svpanel__white"></div>
                            <div class="el-color-svpanel__black"></div>
                            <div
                              class="el-color-svpanel__cursor"
                              style="top: 0px; left: 0px"
                            >
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="el-color-alpha-slider"
                          style="display: none"
                        >
                          <div
                            class="el-color-alpha-slider__bar"
                            style="
                              background: linear-gradient(
                                to right,
                                rgba(0, 0, 0, 0) 0%,
                                rgb(0, 0, 0) 100%
                              );
                            "
                          ></div>
                          <div
                            class="el-color-alpha-slider__thumb"
                            style="left: 0px; top: 0px"
                          ></div>
                        </div>
                        <div class="zw-color-predefine" style="display: flex">
                          <span
                            class="color-mark iconfont iconstraw"
                            style="
                              width: 24px;
                              height: 24px;
                              text-align: center;
                              font-size: 24px;
                              margin-left: 5px;
                              margin-top: 8px;
                              border-radius: 3px;
                              cursor: pointer;
                            "
                          ></span
                          ><span
                            class="iconfont icondisable-redline"
                            style="
                              width: 24px;
                              height: 24px;
                              text-align: center;
                              font-size: 24px;
                              margin-left: 5px;
                              margin-top: 8px;
                              border-radius: 3px;
                              color: red;
                              cursor: pointer;
                              border: 1px solid rgb(224, 229, 234);
                            "
                          ></span>
                          <div class="el-color-predefine">
                            <div class="el-color-predefine__colors">
                              <div
                                class="el-color-predefine__color-selector selected"
                              >
                                <div
                                  style="background-color: rgb(0, 0, 0)"
                                ></div>
                              </div>
                              <div class="el-color-predefine__color-selector">
                                <div
                                  style="background-color: rgb(255, 255, 255)"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="zw-color-predefine">
                          <div class="zw-color-predefine_panelName">预设</div>
                          <div class="zw-color-predefine__colors">
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(224, 32, 32)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(250, 100, 1)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(247, 181, 0)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(109, 212, 0)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(68, 215, 182)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(50, 197, 255)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(0, 145, 255)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(98, 54, 255)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(183, 41, 224)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(109, 114, 120)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(229, 229, 229)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(191, 191, 191)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(127, 127, 127)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(38, 38, 38)"></div>
                            </div>
                            <div
                              class="zw-color-predefine__color-selector selected"
                            >
                              <div style="background: rgb(0, 0, 0)"></div>
                            </div>
                            <div class="zw-color-predefine__color-selector">
                              <div style="background: rgb(255, 255, 255)"></div>
                            </div>
                          </div>
                        </div>
                        <div class="zw-color-custom">
                          <div
                            class="remove-tips"
                            style="
                              position: absolute;
                              left: 0px;
                              top: 0px;
                              z-index: 9999;
                              display: none;
                            "
                          >
                            删除
                          </div>
                          <div class="zw-color-custom_panelName">
                            自定义
                            <span
                              ><div
                                role="tooltip"
                                id="el-popover-5046"
                                aria-hidden="true"
                                class="el-popover el-popper zw-rest-prop"
                                tabindex="0"
                                style="width: 200px; display: none"
                              >
                                <div class="el-popover__title">标题</div>
                                <div
                                  style="
                                    padding: 5px 8px;
                                    font-size: 14px;
                                    line-height: 22px;
                                  "
                                >
                                  自定义颜色最多添加24个，右击可删除
                                </div>
                              </div>
                              <span class="el-popover__reference-wrapper"
                                ><span
                                  class="iconfont iconinfo-circle el-popover__reference"
                                  aria-describedby="el-popover-5046"
                                  tabindex="0"
                                ></span></span
                            ></span>
                          </div>
                          <div class="zw-color-custom__colors">
                            <div class="zw-color-custom__color-selector">
                              <div style="background: rgb(50, 137, 199)"></div>
                            </div>
                            <div class="zw-color-custom__color-add">
                              <span class="add-icon">+</span>
                            </div>
                          </div>
                        </div>
                        <div class="el-color-dropdown__btns">
                          <span class="el-color-dropdown__value"
                            ><div
                              class="el-input el-input--mini"
                              style="display: none"
                            >
                              <!----><input
                                type="text"
                                autocomplete="off"
                                class="el-input__inner"
                              /><!----><!----><!----><!---->
                            </div>
                            <div class="el-input el-input--mini">
                              <!----><input
                                type="text"
                                autocomplete="off"
                                class="el-input__inner"
                              /><!----><!----><!----><!---->
                            </div></span
                          ><button
                            type="button"
                            class="el-button el-color-dropdown__link-btn el-button--default el-button--mini"
                          >
                            <!----><!----><span>取消</span></button
                          ><button
                            type="button"
                            class="el-button el-color-dropdown__btn el-button--default el-button--mini is-plain"
                          >
                            <!----><!----><span>确定</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <ColorPicker
                      v-if="components.colorPickerText"
                      class="bg-color-picker-text"
                      @change="handleChangeColorText"
                    ></ColorPicker>
                  </div>
                  <el-select
                    :class="{ 'zw-disabled': config.isLocked }"
                    style="margin: -4px 0 0 9px; width: 145px"
                    @change="handleChangeFontType"
                    v-model="config.fontFamily"
                    placeholder="字体"
                    size="small"
                    clearable
                    ref="fontFamily"
                  >
                    <el-option
                      :style="{ fontFamily: item }"
                      v-for="item in fontList"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                      <div>{{ item }}</div>
                    </el-option>
                  </el-select>
                  <el-select
                    :class="{ 'zw-disabled': config.isLocked }"
                    style="margin: -4px 0 0 9px; width: 78px"
                    @change="handleChangeFontSize"
                    v-model="config.fontSize"
                    placeholder="大小"
                    size="small"
                    clearable
                  >
                    <el-option
                      v-for="item in fontSizeList"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="operation-item">
                <div class="operation-item-title">样式</div>
                <div class="operation-item-content">
                  <el-tooltip
                    class="item"
                    :class="{ active: currentObject.fontWeight == 'bold' }"
                    effect="dark"
                    content="加粗"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click.prevent="handleAddWeight()"
                      class="el-tooltip item selectItem"
                      aria-describedby="el-tooltip-5078"
                      tabindex="0"
                      ><span class="iconfont iconfont-size1 icon"></span
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    :class="{ active: currentObject.fontStyle == 'italic' }"
                    effect="dark"
                    content="斜体"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click.prevent="handleAddFontStyle()"
                      class="el-tooltip item selectItem"
                      aria-describedby="el-tooltip-3082"
                      tabindex="0"
                      ><span class="iconfont iconfont-slanted icon"></span
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    :class="{ active: currentObject.textAlign == 'left' }"
                    effect="dark"
                    content="左对齐"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click.prevent="handleSetTextAlign('left')"
                      class="el-tooltip item selectItem"
                      aria-describedby="el-tooltip-6011"
                      tabindex="0"
                      ><span class="iconfont iconalign-left1 icon"></span
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    :class="{ active: currentObject.textAlign == 'center' }"
                    effect="dark"
                    content="居中对齐"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click.prevent="handleSetTextAlign('center')"
                      class="el-tooltip item selectItem"
                      aria-describedby="el-tooltip-6098"
                      tabindex="0"
                      ><span class="iconfont iconalign-center icon"></span
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    :class="{ active: currentObject.textAlign == 'right' }"
                    effect="dark"
                    content="右对齐"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click.prevent="handleSetTextAlign('right')"
                      class="el-tooltip item selectItem"
                      aria-describedby="el-tooltip-434"
                      tabindex="0"
                      ><span class="iconfont iconalign-right icon"></span
                    ></span>
                  </el-tooltip>
                  <el-tooltip
                    v-if="false"
                    class="item"
                    effect="dark"
                    content="两端对齐"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      class="el-tooltip item selectItem"
                      aria-describedby="el-tooltip-3860"
                      tabindex="0"
                      ><span class="iconfont iconalign-both icon"></span
                    ></span>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="item-box--suspend">
              <div class="optBox-bg">
                <div class="flex opt-box">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="放大"
                    placement="top"
                  >
                    <i
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click="handleZoomin"
                      class="el-icon-zoom-in opt-item"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></i>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="缩小"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click="handleZoomout"
                      class="el-icon-zoom-out opt-item"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="复制"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click="handleCopy"
                      class="el-tooltip item iconfont iconfile-add opt-item cp"
                      aria-describedby="el-tooltip-7163"
                      tabindex="0"
                    ></span>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="透明"
                    placement="top"
                  >
                    <i
                      style="cursor: pointer; font-size: 20px"
                      @click.prevent="handleShowOpacity"
                      :class="{ 'zw-disabled': config.isLocked }"
                      class="el-icon-view opt-item"
                    ></i>
                  </el-tooltip>
                  <div v-if="components.showOpacityConfig" class="opacity-pop">
                    <div class="zw-slide-pop">
                      <div class="zw-slide-pop-main">
                        <div class="slide">
                          <span>透明</span>
                          <el-slider
                            @change="handleChangeOpacity"
                            style="width: calc(100% - 69px); margin: 0 0 0 16px"
                            v-model="config.opacity"
                          ></el-slider>
                        </div>
                      </div>
                    </div>
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="加锁"
                    placement="top"
                    v-if="!config.isLocked"
                  >
                    <span
                      @click="handleLockLayer(true)"
                      class="el-tooltip iconfont iconunlock opt-item cp item"
                      aria-describedby="el-tooltip-7767"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="解锁"
                    placement="top"
                    v-if="config.isLocked"
                  >
                    <span
                      @click="handleLockLayer(false)"
                      class="el-tooltip iconfont iconlock opt-item cp item"
                      aria-describedby="el-tooltip-7767"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></span>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                  >
                    <span
                      :class="{ 'zw-disabled': config.isLocked }"
                      @click="handleRemove"
                      class="el-tooltip item iconfont icondelete opt-item cp"
                      aria-describedby="el-tooltip-7139"
                      tabindex="0"
                      style="cursor: pointer; font-size: 20px"
                    ></span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="图片上传"
      :visible.sync="uploadImageVisible"
      width="600px"
    >
      <el-form
        ref="form"
        :model="uploadImageForm"
        label-width="80px"
        :rules="rules"
        style="margin: 15px"
      >
        <el-form-item label="图片分类：" prop="delivery">
          <TreeSelect
            :props="{
              value: 'id',
              label: 'label',
              children: 'children',
            }"
            :options="treeData"
            v-model="uploadImageForm.imageType"
            ref="childSelTree"
            style="width: 50%; margin-right: 10px"
            @getValue="getTreeNodeId"
          ></TreeSelect>
        </el-form-item>
        <el-form-item label="选择图片：" prop="delivery">
          <el-upload
            class="upload-demo"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="uploadImageVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="效果图预览"
      :visible.sync="previewImagesVisible"
      width="800px"
    >
      <div class="preview-area">
        <div class="carousel">
          <el-carousel
            ref="carouselPreview"
            style="height: 500px; overflow: hidden"
            :autoplay="false"
            :interval="5000"
            arrow="always"
          >
            <el-carousel-item
              v-for="(productImage, index) in productImageList"
              :key="index"
            >
              <img :src="getSrc(productImage)" />
            </el-carousel-item>
          </el-carousel>
          <div class="color-picker">
            <ul class="color-picker-list">
              <li
                @click="handlePickColor(record)"
                v-for="record of colorList"
                :key="record"
                :class="{ cur: currentColor === record }"
              >
                <a :style="{ backgroundColor: dictMap['color'][record] }"></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="preview-list">
          <div
            v-for="(productImage, index) in productImageList"
            :key="index"
            class="preview-list-item"
            :class="{ 'is-active': activeCarousel === index }"
            @click="handleClickPreviewImage(index)"
          >
            <img :src="getSrc(productImage)" />
            <div class="preview-text">效果图{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showSaveConfirm" width="30%">
      <span>请确认是否替换原订单的产品</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showSaveConfirm = false"
          >取 消</el-button
        >
        <el-button
          v-if="originPId == detail.pId"
          size="small"
          type="primary"
          @click="handleSaveDesign('1')"
          >替换并转换</el-button
        >
        <el-button size="small" type="primary" @click="handleSaveDesign('0')"
          >替换</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="添加刺绣文本"
      :visible.sync="uploadTextVisible"
      width="600px"
    >
      <el-form
        ref="form"
        :model="textForm"
        label-width="100px"
        :rules="rulesText"
        style="margin: 15px"
      >
        <el-form-item label="添加文字：" prop="text">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入英文，暂不支持中文"
            v-model="textForm.text"
            @input="limitLines"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="字号：" prop="delivery">
          <el-checkbox size="small" v-model="textForm.bold">加粗</el-checkbox>
          <el-checkbox size="small" v-model="textForm.italic">斜体</el-checkbox>
        </el-form-item>
        <el-form-item label="字体工艺：" prop="font_type">
          <el-radio-group
            @change="handleChangeEmbroideryFontType"
            v-model="textForm.font_type"
          >
            <el-radio label="2d">平面绣</el-radio>
            <el-radio label="3d">立体绣</el-radio>
          </el-radio-group>
          <div>
            <el-image
              style="width: 100px; height: 100px"
              :src="textForm.font_type == '2d' ? image2D : image3D"
              :preview-src-list="
                textForm.font_type == '2d' ? [image2D] : [image3D]
              "
            >
            </el-image>
          </div>
        </el-form-item>
        <el-form-item label="字体：" prop="font_family">
          <el-select
            size="small"
            v-model="textForm.font_family"
            placeholder="请选择"
          >
            <el-option
              v-for="item in embroideryFontList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="颜色：" prop="delivery">
          <div slot="label">
            颜色：<br /><el-button @click="handleCopyColor" type="text"
              >复制颜色</el-button
            >
          </div>
          <ul class="background-color-content">
            <el-tooltip
              v-for="(color, idx) in textColorList"
              :key="idx"
              effect="dark"
              :content="color.hex"
              placement="top"
            >
              <li
                class="background-color-item"
                :style="{ background: color.hex }"
                @click="selectTextColor(color, idx)"
                style="position: relative"
              >
                <i
                  class="el-icon-check"
                  style="position: absolute; top: 5px; left: 5px"
                  :style="{
                    color: textForm.color_name == 'white' ? 'black' : '#ffffff',
                  }"
                  v-if="textForm.color_name === color.name"
                ></i>
              </li>
            </el-tooltip>
          </ul>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="uploadTextVisible = false"
          >取 消</el-button
        >
        <el-button @click="handleAddEmbroideryText" size="small" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="设置刺绣颜色"
      :visible.sync="setColorVisible"
      width="600px"
    >
      <el-form
        ref="form"
        :model="imageForm"
        label-width="100px"
        style="margin: 15px"
      >
        <el-form-item label="颜色：" prop="delivery">
          <div slot="label">
            颜色：<br /><el-button @click="handleCopyColor" type="text"
              >复制颜色</el-button
            >
          </div>
          <ul class="background-color-content">
            <el-tooltip
              class="item"
              effect="dark"
              :content="color.hex"
              placement="top"
              v-for="(color, idx) in textColorList"
              :key="idx"
            >
              <li
                class="background-color-item"
                :style="{ background: color.hex }"
                @click="selectImageColor(color, idx)"
                style="position: relative"
              >
                <i
                  class="el-icon-check"
                  style="position: absolute; top: 5px; left: 5px"
                  :style="{
                    color:
                      imageForm.color_name == 'white' ? 'black' : '#ffffff',
                  }"
                  v-if="imageForm.color_name === color.name"
                ></i>
              </li>
            </el-tooltip>
          </ul>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="setColorVisible = false"
          >取 消</el-button
        >
        <el-button
          @click="handleAddEmbroideryImageColor"
          size="small"
          type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="快捷键说明"
      :visible.sync="setKeyVisible"
      width="700px"
    >
      <div class="shortcut-box scroll-bar">
        <div class="panel-box">
          <div class="panel-tit mb10">常规操作</div>
          <div class="panel-cont">
            <div
              v-for="record in keyConfig"
              :key="record.event"
              class="panel-item"
            >
              <div>
                <div class="name">{{ record.name }}</div>
                <div v-if="!setKey || !record.canEdit" class="keycode">
                  <span
                    v-for="key in record.keys"
                    :key="key"
                    :class="key == '+' ? 'combine' : 'key'"
                    >{{ key }}</span
                  >
                </div>
                <div v-if="setKey && record.canEdit" class="keycode">
                  <div class="input-box">
                    <input
                      @click="keyBox = record.event"
                      readonly
                      v-model="record.text"
                      placeholder="请按键盘进行设置"
                    /><i
                      @click="record.text = ''"
                      class="iconfont iconclose-fill icon clear"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="float:left"
          @click="handleRestoreKeyConfig"
          size="small"
          >恢复默认配置</el-button
        >
        <el-button v-if="setKey" size="small" @click="handleCancelSetKey"
          >取 消</el-button
        >
        <el-button
          v-if="setKey"
          @click="handleSaveKey"
          size="small"
          type="primary"
          >保 存</el-button
        >
        <el-button
          v-if="!setKey"
          @click="setKey = true"
          size="small"
          type="primary"
          >自定义快捷键</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { setHotKey, getUserProfile } from "@/api/system/user"
import { addDesign, getDesign } from "@/api/customProduct/design"
import ImageList from "./components/ImageList.vue"
import ProductList from "./components/ProductList.vue"
import TreeSelect from "@/components/common/treeSelect"
// import {loadBasicData} from '@/api/customProduct/custom'
import { mapGetters } from "vuex"
import store from "@/store"
import axios from "axios"
import ColorPicker from "@/components/colorPicker/index.vue"
import {
  getProductList,
  getProductDetail,
  getEmbroideryPrice,
} from "@/api/customProduct/product"
import logoSite from "@/assets/images/logo_blue.png"
import "simple-designer"
import { uploadFile } from "./upload"
import { addImgMap, deleteImgMap } from "@/api/customProduct/imageStore"
import { listDesign } from "@/api/customProduct/design"
import { Base64 } from "js-base64"
import { addUserDesign, addUserDesignNew } from "@/api/customProduct/design"
import hotkeys from "hotkeys-js"
import { getMapInfo } from "@/api/map/map"
import Ruler from "./components/ruler.js"
import PicZoom from "vue-piczoom"
import image2D from "@/assets/images/index/2d.jpg"
import image3D from "@/assets/images/index/3d.jpg"

export default {
  name: "create",
  components: {
    Breadcrumb,
    ImageList,
    TreeSelect,
    ProductList,
    ColorPicker,
    PicZoom,
  },
  data() {
    return {
      previewImageUrl: "",
      keyBox: "",
      image2D: image2D,
      image3D: image3D,
      addImagVisible: false, //添加素材弹框开关
      imageList: [], //素材
      designer: null,
      fileList: [],
      currentRow: null,
      skuList: [],
      basicData: {},
      value: [],
      currentMenu: 0,
      menuList: ["产品", "主题", "背景", "图片"],
      currentProduct: 0,
      currentMaterial: 0,
      currentBackground: 0,
      currentImage: 0,
      uploadImageVisible: false,
      uploadImageForm: {},
      treeData: [],
      rules: [],
      rulesText: {},
      productImageList: [],
      currentColor: "",
      currentSize: "",
      previewResult: null,
      previewImagesVisible: false,
      activeCarousel: 0,
      form: {
        pId: "1",
        printsParams: "",
        skuList: [],
        mapIds: ["1", "2"],
        canvasJson: "",
        designId: "",
      },
      embroideryNum: 1,
      textForm: {
        text: "",
        font_family: "Block2",
        color_name: "black",
        bold: false,
        italic: false,
        font_type: "2d",
      },
      imageForm: {
        color_name: "white",
        color_index: 1,
      },
      layerInfo: {
        x: "",
        y: "",
        w: "",
        h: "",
      },
      price: 0,
      proName: "",
      basicId: "",
      isFirstLoading: true,
      previewList: [],
      detail: {},
      SimpleDesigner: null,
      logoSite: logoSite,
      currentAttr: {
        color: "",
        size: "",
      },
      currentBox: "product",
      components: {
        assistLine: false,
        colorPicker: false,
        showProductColor: true,
        showProductSize: false,
        showLayer: true,
        colorPickerText: false,
        ruler: false,
        showOpacityConfig: false,
      },
      currentPart: "",
      config: {
        backgroundColor: "#ffffff",
        backgroundColorText: "#000000",
        fontFamily: "",
        fontSize: "",
        activePart: "",
        isSetBackground: false,
        copyIndex: 0,
        scale: 1,
        canvasSize: 50,
        isLocked: false,
        rotate: 0,
        undoLength: 0,
        redoLength: 0,
        partConfig: "1",
        toParts: [],
        downloadPart: "",
        replaceImage: false,
        tileValue: 50,
        showTileConfig: true,
        gapWidth: 50,
        gapHeight: 50,
        opacity: 100,
        isTile: false,
      },
      textColorList: [
        {
          hex: "#171717",
          name: "black",
        },
        {
          hex: "#ffffff",
          name: "white",
        },
        {
          hex: "#a1a1a1",
          name: "grey",
        },
        {
          hex: "#9c6a23",
          name: "brown",
        },
        {
          hex: "#d82424",
          name: "red",
        },
        {
          hex: "#ee6419",
          name: "orange",
        },
        {
          hex: "#50b03c",
          name: "green",
        },
        {
          hex: "#035239",
          name: "darkGreen",
        },
        {
          hex: "#192c7c",
          name: "blue",
        },
        {
          hex: "#3f92db",
          name: "sky",
        },
        {
          hex: "#934b7c",
          name: "purple",
        },
        {
          hex: "#ffde00",
          name: "yellow",
        },
      ],

      textFontList: [
        "Block2",
        "Crevasse",
        "College",
        "Folio Condensed",
        "Arnold",
        "Handel Gothic",
        "Monoglyceride Bold",
        "Dr Zeus",
        "Enchantment",
        "Old English",
      ],
      textFontList3D: [
        "3D Futuro",
        "3D London",
        "3D Brush",
        "3D Monoglyceride",
      ],
      embroideryFontList: [],
      currentProductMenu: 0,
      currentConfig: {},
      currentObject: {},
      previewsData: [{}],
      previewImages: [],
      layers: [],
      setKeyVisible: false,
      setKey: false,
      fontSizeList: [
        12,
        14,
        16,
        18,
        20,
        22,
        24,
        26,
        28,
        36,
        48,
        56,
        72,
        86,
        100,
      ],
      keyConfig: [
        {
          event: "move",
          name: "移动",
          keys: ["←", "↑", "↓", "→"],
          text: "",
          canEdit: false,
        },
        {
          event: "enlarge",
          name: "放大",
          keys: ["ctrl", "+", "a"],
          text: "ctrl+a",
          canEdit: true,
        },
        {
          event: "reduce",
          name: "缩小",
          keys: ["ctrl", "+", "m"],
          text: "ctrl+m",
          canEdit: true,
        },
        {
          event: "copy",
          name: "复制",
          keys: ["ctrl", "+", "c"],
          text: "ctrl+c",
          canEdit: true,
        },
        {
          event: "stick",
          name: "粘贴",
          keys: ["ctrl", "+", "v"],
          text: "ctrl+v",
          canEdit: true,
        },
        {
          event: "undo",
          name: "撤销",
          keys: ["ctrl", "+", "z"],
          text: "ctrl+z",
          canEdit: true,
        },
        {
          event: "redo",
          name: "重做",
          keys: ["ctrl", "+", "shift", "+", "z"],
          text: "ctrl+shift+z",
          canEdit: true,
        },
        {
          event: "delete",
          name: "删除",
          keys: ["delete"],
          text: "delete",
          canEdit: true,
        },
        {
          event: "save",
          name: "保存",
          keys: ["ctrl", "+", "s"],
          text: "ctrl+s",
          canEdit: true,
        },
        {
          event: "clear",
          name: "清空",
          keys: ["ctrl", "+", "\\"],
          text: "ctrl+\\",
          canEdit: true,
        },
      ],
      activeView: "2D",
      keyConfigDefault: [
        {
          event: "move",
          name: "移动",
          keys: ["←", "↑", "↓", "→"],
          text: "",
          canEdit: false,
        },
        {
          event: "enlarge",
          name: "放大",
          keys: ["ctrl", "+", "a"],
          text: "ctrl+a",
          canEdit: true,
        },
        {
          event: "reduce",
          name: "缩小",
          keys: ["ctrl", "+", "m"],
          text: "ctrl+m",
          canEdit: true,
        },
        {
          event: "copy",
          name: "复制",
          keys: ["ctrl", "+", "c"],
          text: "ctrl+c",
          canEdit: true,
        },
        {
          event: "stick",
          name: "粘贴",
          keys: ["ctrl", "+", "v"],
          text: "ctrl+v",
          canEdit: true,
        },
        {
          event: "undo",
          name: "撤销",
          keys: ["ctrl", "+", "z"],
          text: "ctrl+z",
          canEdit: true,
        },
        {
          event: "redo",
          name: "重做",
          keys: ["ctrl", "+", "shift", "+", "z"],
          text: "ctrl+shift+z",
          canEdit: true,
        },
        {
          event: "delete",
          name: "删除",
          keys: ["delete"],
          text: "delete",
          canEdit: true,
        },
        {
          event: "save",
          name: "保存",
          keys: ["ctrl", "+", "s"],
          text: "ctrl+s",
          canEdit: true,
        },
        {
          event: "clear",
          name: "清空",
          keys: ["ctrl", "+", "\\"],
          text: "ctrl+\\",
          canEdit: true,
        },
      ],
      keyConfigApple: [
        {
          event: "move",
          name: "移动",
          keys: ["←", "↑", "↓", "→"],
          text: "",
          canEdit: false,
        },
        {
          event: "enlarge",
          name: "放大",
          keys: ["command", "+", "a"],
          text: "command+a",
          canEdit: true,
        },
        {
          event: "reduce",
          name: "缩小",
          keys: ["command", "+", "m"],
          text: "command+m",
          canEdit: true,
        },
        {
          event: "copy",
          name: "复制",
          keys: ["command", "+", "c"],
          text: "command+c",
          canEdit: true,
        },
        {
          event: "stick",
          name: "粘贴",
          keys: ["command", "+", "v"],
          text: "command+v",
          canEdit: true,
        },
        {
          event: "undo",
          name: "撤销",
          keys: ["command", "+", "z"],
          text: "command+z",
          canEdit: true,
        },
        {
          event: "redo",
          name: "重做",
          keys: ["command", "+", "shift", "+", "z"],
          text: "command+shift+z",
          canEdit: true,
        },
        {
          event: "delete",
          name: "删除",
          keys: ["backspace"],
          text: "backspace",
          canEdit: true,
        },
        {
          event: "save",
          name: "保存",
          keys: ["command", "+", "s"],
          text: "command+s",
          canEdit: true,
        },
        {
          event: "clear",
          name: "清空",
          keys: ["command", "+", "\\"],
          text: "command+\\",
          canEdit: true,
        },
      ],
      fontList: [
        "Georgia",
        "Impact",
        "微软雅黑",
        "宋体",
        "黑体",
        "Arial",
        "academic",
        "agra",
        "aguzlo",
        "brush_script_std",
        "butter",
        "chiller",
        "clarendon_condensed_bold",
        "comeback",
        "digital",
        "distorti",
        "eccentric_std",
        "forte",
        "friday_night",
        "happy",
        "seaside",
        "spaghettica",
        "varsity",
        "verminmagic",
      ],
      formDesign: {
        pageNum: 1,
        pageSize: 6,
        delFlag: "1",
        sDesignId: '01',
        beginTime: '',
        endTime: '',
        ifNew: '02', //01新，02旧
      },
      designData: [],
      totalDesign: 0,
      parts: [],
      activeLayer: "",
      triggerFlag: false,
      arrKey: [],
      timer: null,
      showSaveConfirm: false,
      myRuler: null,
      isSubmit: false,
      toolBarHeight: "80vh",
      checkAllParts: false,
      psd_params: {
        width: 0,
        height: 0,
      },
      partMode: "1",
      currentUploadImage: 0,
      CPrice: 0,
      uploadTextVisible: false,
      setColorVisible: false,
      embroideryPrice: 0,
      embroideryImageInfo: {
        embroideryParams: {
          colors: ["orange", "white", "grey"],
        },
      },
      embroideryImageColorsOrigin: [],
      embroideryImageColors: ["orange", "white", "grey"],
      textColorMap: {
        white: "#ffffff",
        black: "#171717",
        grey: "#a1a1a1",
        brown: "#9c6a23",
        red: "#d82424",
        orange: "#ee6419",
        green: "#50b03c",
        darkGreen: "#035239",
        blue: "#192c7c",
        sky: "#3f92db",
        purple: "#934b7c",
        yellow: "#ffde00",
      },
      embroideryDiscountPrice: 0,
      embroideryNumMax: 0,
      userProfile: {},
      canSaveDesigner: true,
      isTile: '',
      canChangeBackgroundColor: true,
    }
  },
  computed: {
    ...mapGetters(["nginx", "dictData", "dictMap", "user"]),
    sizeList() {
      let sizeList = []
      if (this.detail.skuList) {
        for (let record of this.detail.skuList) {
          let color = record.properVal.split(":")[0]
          let size = record.properVal.split(":")[1]
          if (color == this.currentAttr.color) {
            if (!sizeList.includes(size)) {
              sizeList.push(size)
            }
          }
        }
      }
      return sizeList
    },
    designLogoUrl() {
      return this.$store.state.setting.siteData.designLogoUrl
    },
    colorList() {
      let colorList = []
      if (this.detail.skuList) {
        for (let record of this.detail.skuList) {
          let color = record.properVal.split(":")[0]
          if (!colorList.includes(color)) {
            colorList.push(color)
          }
        }
      }

      return colorList
    },
    partName() {
      let partName = ""
      for (let record of this.parts) {
        if (record.name == this.config.activePart) {
          partName = record.i18n.zh
          break
        }
      }
      return partName
    },
    isReplaceProduct() {
      let appSkuId = this.$route.query.appSkuId
      if (appSkuId) {
        return true
      } else {
        return false
      }
    },
    originPId() {
      let pId = this.$route.query.pId
      if (pId) {
        return pId
      } else {
        return ""
      }
    },
    isApple() {
      return (
        navigator.platform.indexOf("Mac") > -1 ||
        navigator.platform.indexOf("iPod") > -1 ||
        navigator.platform.indexOf("iPhone") > -1 ||
        navigator.platform.indexOf("iPad") > -1
      )
    },
  },
  async mounted() {
    document.querySelector(".child-content").style.padding = "0"
    document.querySelector(".el-header").style.display = "none"
    document
      .querySelector("body")
      .setAttribute("style", "overflow:hidden !important;")

    document.addEventListener("click", this.clickEvent)
    //  let data = {
    //     userName: this.user.name,
    //     hotKey: '',
    //   }
    //   let result = await setHotKey(data)

    let userProfile = await getUserProfile()
    this.userProfile = userProfile
    if (
      userProfile.user.hotKey &&
      userProfile.user.hotKey.indexOf("windows") > -1 &&
      !this.isApple
    ) {
      let hotKey = JSON.parse(userProfile.user.hotKey)
      this.keyConfig = JSON.parse(JSON.stringify(hotKey.windows))
    } else if (
      userProfile.user.hotKey &&
      this.isApple &&
      userProfile.user.hotKey.indexOf("apple") > -1
    ) {
      let hotKey = JSON.parse(userProfile.user.hotKey)
      this.keyConfig = JSON.parse(JSON.stringify(hotKey.apple))
    } else if (!userProfile.user.hotKey && this.isApple) {
      this.keyConfig = JSON.parse(JSON.stringify(this.keyConfigApple))
    } else if (!userProfile.user.hotKey && !this.isApple) {
      this.keyConfig = JSON.parse(JSON.stringify(this.keyConfigDefault))
    } else if (
      userProfile.user.hotKey &&
      this.isApple &&
      userProfile.user.hotKey.indexOf("apple") == -1
    ) {
      this.keyConfig = JSON.parse(JSON.stringify(this.keyConfigApple))
    } else if (
      userProfile.user.hotKey &&
      !this.isApple &&
      userProfile.user.hotKey.indexOf("windows") == -1
    ) {
      this.keyConfig = JSON.parse(JSON.stringify(this.keyConfigDefault))
    }

    this.bindKey()

    this.myRuler = new Ruler({
      container: document.querySelector(".simple-designer"), // reference to DOM element to apply rulers on
      rulerHeight: 15, // thickness of ruler
      fontFamily: "arial", // font for points
      fontSize: "10px",
      strokeStyle: "black",
      lineWidth: 1,
      enableMouseTracking: true,
      enableToolTip: true,
    })
    this.myRuler.api.toggleRulerVisibility(false)

    window.setInterval(() => {
      this.previewImageUrl = this.convertCanvasToImage(
        document.querySelector("#preview")
      )
      let dom = document.querySelector(".mouse-cover-canvas")
      dom.id = "mouse-cover-canvas"
    }, 1000)
  },

  beforeRouteLeave(to, from, next) {
    document.querySelector(".child-content").style.padding = "12px"
    document.querySelector(".el-header").style.display = "block"
    document.getElementsByTagName("body")[0].style["overflow"] = "inherit"
    document.removeEventListener("click", this.clickEvent)
    hotkeys.unbind()
    next() //允许跳转页面
  },
  methods: {
    async init() {
      this.designer = new window.Designer({
        id: "#designerDiv", // 挂载元素的ID
        baseUrl: "https://www.onecust.cn/3ddesigner",
        defaultScale: 1, // canvas默认缩放比例
        defaultBackgroundColor: "#ffffff",
        objectRemoved: (val) => {
          this.getCurrentObjects()
          this.getHistoryUndoLength()
          this.getHistoryRedoLength()
          this.getEmbroideryPrice()
        },
        objectCopied: (val) => {
          this.handleConfig(val)
          this.getCurrentObjects()
          this.getHistoryUndoLength()
          this.getHistoryRedoLength()
        },
        objectAdded: (val) => {
          this.handleConfig(val)
          this.getCurrentObjects()
          this.getHistoryUndoLength()
          this.getHistoryRedoLength()
          this.getEmbroideryPrice()
        },
        objectMoved: (val) => {
          this.getHistoryUndoLength()
          this.getHistoryRedoLength()
          this.handleConfig(val)
        },
        objectScaled: (val) => {
          this.handleConfig(val)
          this.getHistoryUndoLength()
          this.getHistoryRedoLength()
        },
        objectRotated: (val) => {
          this.getHistoryUndoLength()
          this.getHistoryRedoLength()
          this.handleConfig(val)
        },
        objectMouseDown: (val) => {
          if (!val) {
            this.currentBox = "product"
          } else {
            this.currentObject = val
            if (val.isEmbroideryText) {
              this.currentBox = "embroidery"
            } else if (val.imageInfo && val.imageInfo.isEmbroideryImage) {
              this.currentBox = "embroideryImage"
            } else if (val.type == "image" || val.type == "backgroundImage") {
              this.currentBox = "image"
            } else if (val.type == "i-text") {
              this.currentBox = "text"
            }
            this.handleConfig(val)
          }
        },
        showMessage: (val) => {
          this.msgError(val.message)
        },
        canSaveDesigner: (val) => {
          this.canSaveDesigner = val
        },
      })
      if (this.detail.basicId) {
        await this.init2D(this.detail.basicId, "preview")
        let height = document.documentElement.clientHeight - 129
        this.toolBarHeight = height
      }
    },
    bindKey() {
      hotkeys("*", (event, handler) => {
        if (this.setKeyVisible && this.setKey) {
          event.preventDefault()
          console.log(event)

          let keys = []
          if (event.ctrlKey) {
            keys.push(this.isApple ? "control" : "ctrl")
            keys.push("+")
          }
          if (event.shiftKey) {
            keys.push("shift")
            keys.push("+")
          }
          if (event.altKey) {
            keys.push(this.isApple ? "options" : "alt")
            keys.push("+")
          }
          if (event.metaKey) {
            keys.push("command")
            keys.push("+")
          }
          if (
            event.key != "Control" &&
            event.key != "Shift" &&
            event.key != "Alt" &&
            event.key != "Meta"
          ) {
            keys.push(event.key.toLowerCase())
          }
          if (
            event.key == "Control" ||
            event.key == "Shift" ||
            event.key == "Alt" ||
            event.key == "Meta"
          ) {
            return
          }
          for (let record of this.keyConfig) {
            if (record.event != this.keyBox && record.text == keys.join("+")) {
              this.msgError(
                `快捷键与“${record.name}（${record.text}）”存在冲突，请重新设置`
              )
              return
            }
          }
          for (let record of this.keyConfig) {
            if (record.event == this.keyBox) {
              record.keys = keys
              record.text = keys.join("")
            }
          }
        }
      })

      for (let record of this.keyConfig) {
        let hotKey = record.text
        if (hotKey.indexOf("ctrl") > -1) {
          hotKey += "," + hotKey.replace("ctrl", "command")
        }
        if (hotKey.toLowerCase().indexOf("delete") > -1) {
          hotKey += "," + "backspace"
        }
        hotKey = hotKey.replace("options", "alt")
        hotKey = hotKey.replace("control", "ctrl")

        if (record.event == "enlarge") {
          hotkeys(hotKey, (event, handler) => {
            // Prevent the default refresh event under WINDOWS system
            event.preventDefault()
            this.handleZoomin()
          })
        } else if (record.event == "copy") {
          hotkeys(hotKey, (event, handler) => {
            event.preventDefault()
            if (this.partMode == "2") {
              return
            }
            const object = this.designer.getActiveObject()
            if (object) {
              const objects = this.designer.getCurrentObjects()
              for (let i = 0; i < objects.length; i++) {
                if (objects[i].id == object.id) {
                  this.config.copyIndex = object.id
                  this.msgSuccess("复制成功")
                  break
                }
              }
            }
          })
        } else if (record.event == "stick") {
          hotkeys(hotKey, (event, handler) => {
            // Prevent the default refresh event under WINDOWS system
            event.preventDefault()
            if (this.partMode == "2") {
              return
            }
            const objects = this.designer.getCurrentObjects()
            for (let i = 0; i < objects.length; i++) {
              if (objects[i].id == this.config.copyIndex) {
                let object = objects[i]
                this.designer.selectObject(object)
                this.performAction({ name: "copy" })
              }
            }
            this.msgSuccess("粘贴成功")
          })
        } else if (record.event == "save") {
          hotkeys(hotKey, (event, handler) => {
            // Prevent the default refresh event under WINDOWS system
            event.preventDefault()
            this.handleSaveDesign()
          })
        } else if (record.event == "undo") {
          hotkeys(hotKey, (event, handler) => {
            // Prevent the default refresh event under WINDOWS system
            event.preventDefault()
            this.handleUndo()
          })
        } else if (record.event == "redo") {
          hotkeys(hotKey, (event, handler) => {
            // Prevent the default refresh event under WINDOWS system
            event.preventDefault()
            this.handleRedo()
          })
        } else if (record.event == "delete") {
          hotkeys(hotKey, (event, handler) => {
            // Prevent the default refresh event under WINDOWS system
            event.preventDefault()
            this.performAction({ name: "remove" })
          })
        } else if (record.event == "reduce") {
          hotkeys(hotKey, (event, handler) => {
            // Prevent the default refresh event under WINDOWS system
            event.preventDefault()
            this.handleZoomout()
          })
        } else if (record.event == "clear") {
          hotkeys(hotKey, (event, handler) => {
            // Prevent the default refresh event under WINDOWS system
            event.preventDefault()
            this.handleClearCanvas()
          })
        }
      }
    },
    unbindKey() {
      hotkeys.unbind()
    },
    handleCancelSetKey() {
      this.setKey = false
    },
    handleRestoreKeyConfig() {
      this.$confirm("该操作将所有快捷键恢复为默认值，是否继续？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          this.keyConfig = this.isApple
            ? JSON.parse(JSON.stringify(this.keyConfigApple))
            : JSON.parse(JSON.stringify(this.keyConfigDefault))

          this.handleSaveKey()
        })
        .catch((action) => {})
    },
    handleConfig(object) {
      if (object.imageInfo && object.imageInfo.isEmbroideryText) {
        this.currentBox = "embroidery"
      } else if (object.imageInfo && object.imageInfo.isEmbroideryImage) {
        this.currentBox = "embroideryImage"
        //获取图层的颜色
        window.setTimeout(() => {
          if (this.layers.length > 0) {
            var objects = this.designer.getCurrentObjects()
            this.layers = JSON.parse(JSON.stringify(objects))
            this.embroideryImageInfo = this.layers[0].imageInfo
            let colorList = []
            for (let record of this.embroideryImageInfo.embroideryParams
              .colorList) {
              colorList.push(record.finalColor)
            }
            this.embroideryImageColorsOrigin = colorList
            this.embroideryImageColors = this._.clone(
              this.embroideryImageColorsOrigin
            )
          }
        }, 500)
      } else if (
        object.type == "image" ||
        object.type == "backgroundImage" ||
        object.type == "rect"
      ) {
        this.currentBox = "image"
      } else {
        this.currentBox = "text"
        this.config.fontSize = object.fontSize
        this.config.fontFamily = object.fontFamily
      }
      this.currentObject = object
      this.layerInfo.x = this.currentObject.top
      this.layerInfo.y = this.currentObject.left
      this.layerInfo.w = this.currentObject.width
      this.layerInfo.h = this.currentObject.height

      this.config.scale = object.scale
      this.config.isLocked = object.isLocked
    },
    handleShowOpacity() {
      this.config.opacity = this.currentObject.opacity
      this.components.showOpacityConfig = true
    },
    getEmbroideryPrice() {
      const canvasList = this.designer.getFabricCanvasList()
      window.setTimeout(() => {
        this.embroideryPrice = 0
        canvasList.map((canvas) => {
          const objects = canvas.getObjects()
          if (canvas.IS_EMBROIDERY && objects.length) {
            this.embroideryPrice += canvas.EMBROIDERY_POSITION_INFO.CNY
          }
        })
      }, 500)
    },
    clickEvent(e) {
      let list = document.querySelector(".bg-color-picker-")
      if (
        (list && list.contains(e.target)) ||
        (e.target.className &&
          e.target.className.indexOf &&
          e.target.className.indexOf("el-color-picker") > -1)
      ) {
      } else if (this.components.colorPicker) {
        this.components.colorPicker = false
      }

      let listText = document.querySelector(".bg-color-picker-text")

      if (
        (listText && listText.contains(e.target)) ||
        (e.target.className &&
          e.target.className.indexOf &&
          e.target.className.indexOf("el-color-picker") > -1)
      ) {
      } else if (this.components.colorPickerText) {
        this.components.colorPickerText = false
      }

      let listTile = document.querySelector(".tileway-pop")

      if (
        (listTile && listTile.contains(e.target)) ||
        (e.target.className &&
          e.target.className.indexOf &&
          e.target.className.indexOf("tile-button") > -1)
      ) {
      } else if (this.config.showTileConfig) {
        this.config.showTileConfig = false
      }

      let listOpacity = document.querySelector(".opacity-pop")

      if (
        (listOpacity && listOpacity.contains(e.target)) ||
        (e.target.className &&
          e.target.className.indexOf &&
          e.target.className.indexOf("el-icon-view") > -1 &&
          e.target.className.indexOf("el-icon-view") > -1)
      ) {
      } else if (this.components.showOpacityConfig) {
        this.components.showOpacityConfig = false
      }
    },
    /**
     * 获取图层
     */
    getCurrentObjects() {
      const objects = this.designer.getCurrentObjects()
      this.layers = JSON.parse(JSON.stringify(objects))
    },
    async init2D(code, previewId) {
      // this.performAction({ name: "clearAll" })
      await this.sleep(500)
      await this.designer.init2D(code, previewId)
      this.get2DPreviewsData()
      this.getConfig()

      setTimeout(() => {
        const fabric = this.designer.getFabric()
        fabric.Object.prototype.controls.bl.offsetX = 11
        fabric.Object.prototype.controls.bl.offsetY = -15

        fabric.Object.prototype.controls.br.offsetX = -11
        fabric.Object.prototype.controls.br.offsetY = -15

        fabric.Object.prototype.controls.tl.offsetX = 11
        fabric.Object.prototype.controls.tl.offsetY = 10

        fabric.Object.prototype.controls.tr.offsetX = -11
        fabric.Object.prototype.controls.tr.offsetY = 10
      }, 1000)
    },
    handleSetBackgroundColor() {
      this.components.colorPicker = true
    },
    selectTextColor(color, idx) {
      this.textForm.color_name = color.name
    },
    selectImageColor(color, idx) {
      this.imageForm.color_name = color.name
    },
    async handleDeleteBackground(color) {
      this.designer.changeBackgroundColor(color)
      this.config.backgroundColor = color
    },
    handleSetTextColor() {
      this.components.colorPickerText = true
    },
    beforeUpload() {},
    //确认添加素材
    handleChangeMenu(index) {
      this.currentMenu = index
      if (this.partMode == "1" && index == 1) {
        this.currentMaterial = 0
        this.$nextTick(() => {
          this.$refs["imageMe"].getData()
        })
      }
      if (this.partMode == "2" && index == 1) {
        this.currentMaterial = 3
        this.$nextTick(() => {
          this.$refs["imageOrder"].getData()
        })
      }

      if (index == 4) {
        this.$nextTick(() => {
          this.$refs["uploadHistory"].getData()
        })
      }
    },
    handleSelectProduct(index) {
      this.currentProduct = index
      this.$nextTick(() => {
        if (index == 0) {
          this.$refs["product1"].getData()
        }
        if (index == 1) {
          this.$refs["product2"].getData()
        }
      })
    },
    handleSelectProductMenu(index) {
      this.currentProductMenu = index
      this.$nextTick(() => {
        this.$refs["product1"].getData()
      })
    },
    async handleChangeView(index) {
      if (this.activeView == "3D") {
        this.startLoading()
        await this.designer.init3D()
        this.endLoading()
      } else {
        this.startLoading()
        await this.designer.show2D()
        this.endLoading()
      }
    },
    handleSelectMaterial(index) {
      this.currentMaterial = index
      this.$nextTick(() => {
        if (index == 0) {
          this.$refs["imageMe"].getData()
        }
        if (index == 1) {
          this.$refs["imageCommon"].getData()
        }
        if (index == 2) {
          this.$refs["imageShare"].getData()
        }
        if (index == 3) {
          this.$refs["imageOrder"].getData()
        }
      })
    },
    handleSelectUploadImage(index) {
      if (this.partMode == "1" && index == 1) {
        this.msgError("当前只能上传印花图片")
        return
      }
      if (this.partMode == "2" && index == 0) {
        this.msgError("当前只能上传刺绣图片")
        return
      }
      this.currentUploadImage = index
      this.$nextTick(() => {
        this.$refs["uploadHistory"].getData()
      })
    },
    getSrc(blob) {
      return window.URL.createObjectURL(blob)
    },
    handleSelectBackground(index) {
      this.currentBackground = index
    },
    handleSelectImage(index) {
      this.currentImage = index
    },
    handleShowImageDialog() {
      this.uploadImageVisible = true
    },
    getTreeNodeId() {},
    async handleOper(index, object) {
      const activeObject = object ? object : this.designer.getActiveObject()
      if (activeObject) {
        this.designer.performAction({ name: index }, activeObject)
      }
      // this.preview()
    },
    async handleRotate(value) {
      const activeObject = this.designer.getActiveObject()
      if (activeObject) {
        this.designer.performAction(
          { name: "rotate", value: value },
          activeObject
        )
        // this.preview()
      }
    },
    handleChangeCanvasSize() {
      let value = this.config.canvasSize - 50
      if (!this.designer) {
        return
      }
      this.designer.increaseCanvasSize(value)
    },
    handleRecoverCanvasSize() {
      this.config.canvasSize = 50
      let value = this.config.canvasSize - 50
      if (!this.designer) {
        return
      }
      this.designer.increaseCanvasSize(value)
    },
    handleAddCanvasSize() {
      this.config.canvasSize++
      let value = this.config.canvasSize - 50
      if (!this.designer) {
        return
      }
      this.designer.increaseCanvasSize(value)
    },
    handleMinusCanvasSize() {
      this.config.canvasSize--
      let value = this.config.canvasSize - 50
      if (!this.designer) {
        return
      }
      this.designer.increaseCanvasSize(value)
    },
    handlePickColor(color) {
      this.currentColor = color
      this.setProductImageList()
    },
    handlePickSize(size) {
      this.currentSize = size
      this.setProductImageList()
    },
    setProductImageList() {
      let images = []
      for (let record of this.previewImages) {
        if (record.color_name === this.currentColor) {
          images.push(record.blob)
        }
      }
      this.productImageList = images
    },
    handleClickPreviewImage(index) {
      this.$refs["carouselPreview"].setActiveItem(index)
      this.activeCarousel = index
    },
    async updateEmbroideryImage() {
      try {
        const params = {}
        let embroideryParams = this.layers[0].imageInfo.embroideryParams
        debugger
        let color_list = embroideryParams.colorList
          ? embroideryParams.colorList
          : embroideryParams.color_list
        for (let i = 0; i < color_list.length; i++) {
          color_list[i].currentColor = this.embroideryImageColors[i]
        }

        params.id = embroideryParams.embroidery_id
        params.colorList = color_list
        await this.designer.updateEmbroideryImage(params)

        let layers = this.designer.getCurrentObjects()
        this.handleConfig(layers[0])
        this.getCurrentObjects()
      } catch (error) {
        console.log(error)
      }
    },
    async handleShowPreview() {
      this.startLoading()
      this.previewImages = await this.designer.generateSamples()
      this.previewImagesVisible = true
      console.log(this.previewImages)
      this.handlePickColor(this.colorList[0])

      this.$nextTick(() => {
        document.querySelector(".preview-list").scrollTop = 0
        this.handleClickPreviewImage(0)
        this.endLoading()
      })
    },
    handleReset3D() {
      this.designer.reset3DCamera()
    },
    exportCanvasAsPNG() {
      var canvasElement = document.getElementById("preview")
      var MIME_TYPE = "image/png"
      var imgURL = canvasElement.toDataURL(MIME_TYPE)
      var dlLink = document.createElement("a")
      dlLink.download = new Date().getTime()
      dlLink.href = imgURL
      dlLink.dataset.downloadurl = [
        MIME_TYPE,
        dlLink.download,
        dlLink.href,
      ].join(":")
      document.body.appendChild(dlLink)
      dlLink.click()
      document.body.removeChild(dlLink)
    },
    handleJumpDetail() {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { pId: this.detail.pId },
      })
      window.open(routeUrl.href, "_blank")
    },
    handleJumpPath(path) {
      this.$router.push({ path: path })
    },
    handleMyDesign() {
      let routeUrl = this.$router.resolve({
        path: "/select/selection/design",
      })
      window.open(routeUrl.href, "_blank")
    },
    async performAction(obj) {
      await this.designer.performAction(obj)
    },
    async handleAddImage(record) {
      let imageUrl = record.picUrl
      if (record.picHeight >= record.picWidth && record.picHeight > 2000) {
        let width = Math.round((record.picWidth / record.picHeight) * 2000)
        imageUrl += `?x-oss-process=image/resize,m_fill,w_${width},h_2000/quality,q_100`
      }

      if (record.picWidth > record.picHeight && record.picWidth > 2000) {
        let height = Math.round((record.picHeight / record.picWidth) * 2000)
        imageUrl += `?x-oss-process=image/resize,m_fill,w_2000,h_${height}/quality,q_100`
      }

      let imageObject = {
        id: record.mapId,
        name: record.picName,
        url: imageUrl,
        width: record.picWidth,
        height: record.picHeight,
        originalUrl: record.picUrl,
        info: {
          width: record.picWidth,
          height: record.picHeight,
          type: "image/jpeg",
        },
      }
      if (this.config.replaceImage) {
        this.performAction({ name: "remove" })
      }
      try {
        if (this.partMode == "1") {
          await this.designer.addImage(imageObject)
        } else {
          this.performAction({ name: "clear", backgroundColor: "" })

          const params = {
            image_id: record.mapId,
            name: record.picName,
            width: record.picWidth,
            height: record.picHeight,
            image: record.picUrl,
          }
          try {
            await this.designer.addEmbroideryImage(params)
          } catch (error) {
            this.msgError(error)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleAddBackground(record) {
      let imageObject1 = await this.designer.setBackgroundImage({
        _image_id: record.mapId,
        name: record.picName,
        url: record.picUrl,
        width: record.picWidth,
        height: record.picHeight,
        originalUrl: record.picUrl,
      })
      this.designer.performAction({ name: "maximize" }, imageObject1)
    },
    async handleAddProduct(record) {
      if (record.basicId) {
        if (record.basicId == this.detail.basicId) {
          return
        }
        this.startLoading()
        clearTimeout(this.timer)
        //获取刺绣价格
        let embroideryResult = await getEmbroideryPrice(record.pId)

        this.timer = setTimeout(async () => {
          try {
            this.config.backgroundColor = "#ffffff"
            await this.sleep(500)
            await this.init2D(record.basicId, "preview")
            this.detail = record
            this.detail.embroideryList = embroideryResult.data
            this.processData()
            this.init2DColor()
            this.endLoading()
          } catch (error) {
            console.log(error)
            this.endLoading()
          }
        }, 1000)
      }
    },
    sleep(timemills) {
      return new Promise((resolve, reject) => {
        window.setTimeout(() => {
          resolve(1)
        }, timemills)
      })
    },
    init2DColor() {
      const colors = this.designer.get2DColors();
      if (colors.length) {
        this.designer.change2DColor(colors[0].name)
      }
      const canChangeBackgroundColor = this.designer.canChangeBackgroundColor()

      this.canChangeBackgroundColor = canChangeBackgroundColor
    },
    async handleChangeColor(color, isCover) {
      if (isCover) {
        await this.designer.toggleAllApplyBackgroundColor(color)
      } else {
        await this.designer.changeBackgroundColor(color)
      }
      this.config.backgroundColor = color
    },
    async handleChangeColorText(color) {
      this.performAction({ name: "fontColor", value: color })
      this.config.backgroundColorText = color
    },
    async handleProductLoaded(result) {
      if (this.isFirstLoading) {
        let pId = this.$route.query.pId
        if (!pId) {
          pId = "736315246047821824"
        }
        if (
          window.location.host == "test2.onecust.com" ||
          window.location.host == "localhost:8092" ||
          window.location.host == "localhost:8091"
        ) {
          pId = "744970283762286592"
          pId = "793185951609200640"
        }
        let designId = this.$route.query.designId
        if (designId) {
          await this.init()
          this.handleChangeProduct({
            designId,
          })
        } else {
          let productResult = await getProductDetail(pId)
          this.detail = productResult.data
          this.processData()
          await this.init()
        }
        this.isFirstLoading = false
      }
      this.init2DColor()
    },
    async processData(res) {
      let properVal = this.detail.skuList[0].properVal.split(":")
      this.currentAttr.color = properVal[0]
      // this.change2DColor(properVal[0])
      this.currentAttr.size = properVal[1].replace(/\\/g, "")
      this.currentSku = this.detail.skuList[0]
      this.mainPic = this.currentSku.picList[0].picUrl
    },
    handleSelectColor(color) {
      this.currentAttr.color = color
      // if (this.activeView == "2D") {
      this.change2DColor(color)
      // } else {
      this.change3DColor(color)
      // }
      this.selectSku()
    },
    handleSelectSize(size) {
      this.currentAttr.size = size
      this.selectSku()
    },
    selectSku() {
      for (let record of this.detail.skuList) {
        record.properVal = record.properVal.replace(/\\/g, "")
        if (
          record.properVal ===
          `${this.currentAttr.color}:${this.currentAttr.size}`
        ) {
          this.currentSku = record
          this.mainPic = this.currentSku.picList[0].picUrl
          break
        }
      }
    },
    async handleAddText() {
      try {
        //判断是否可以添加文字
        if (this.partMode == "2") {
          this.textForm = {
            text: "",
            font_family: "Block2",
            color_name: "black",
            bold: false,
            italic: false,
            font_type: "2d",
          }
          this.embroideryFontList = this.textFontList
          this.uploadTextVisible = true
        } else {
          await this.designer.addText()
          this.performAction({ name: "fontSize", value: 30 })
          this.config.fontSize = 30
        }
        this.getCurrentObjects()
      } catch (error) {
        console.log(error)
      }
    },
    handleChangeEmbroideryFontType() {
      if (this.textForm.font_type == "2d") {
        this.embroideryFontList = this.textFontList
        this.textForm.font_family = "Block2"
      } else {
        this.embroideryFontList = this.textFontList3D
        this.textForm.font_family = "3D Futuro"
      }
    },
    handleAddEmbroideryText() {
      if (this.textForm.text == "") {
        this.msgError("请输入文字")
        return
      }
      //判断合法
      if (/[\u4e00-\u9fa5]/.test(this.textForm.text)) {
        this.msgError("暂不支持中文")
        return
      }
      this.performAction({ name: "clear", backgroundColor: "" })
      this.designer.addEmbroideryText(this.textForm)
      this.uploadTextVisible = false
    },
    async handleCopyPart() {
      if (this.config.partConfig == "1") {
        for (let record of this.parts) {
          if (record.name.indexOf("Left") > -1) {
            await this.designer.mirrorTo(
              record.name,
              record.name.replace("Left", "Right"),
              true
            )
            await this.designer.allFlipX(record.name.replace("Left", "Right"))
          }
        }
        this.msgSuccess("镜像成功")
      } else if (this.config.partConfig == "2") {
        for (let record of this.parts) {
          if (record.name.indexOf("Right") > -1) {
            await this.designer.mirrorTo(
              record.name,
              record.name.replace("Right", "Left"),
              true
            )
            await this.designer.allFlipX(record.name.replace("Right", "Left"))
          }
        }
        this.msgSuccess("镜像成功")
      } else if (
        this.config.partConfig == "3" &&
        this.config.toParts.length == 0
      ) {
        this.msgError("请选择需要复制的刀版")
      } else {
        for (let record of this.config.toParts) {
          if (record == this.config.activePart) {
            continue
          }
          await this.designer.mirrorTo(this.config.activePart, record, true)
        }
        this.msgSuccess("镜像成功")
      }
    },
    async handleCopyObject() {
      for (let record of this.config.toParts) {
        if (record == this.config.activePart) {
          continue
        }
        await this.designer.performAction({
          name: "copy",
          canvasName: record,
        })
      }
      this.msgSuccess("复制成功")
    },
    /**
     * 添加网格
     */
    addGrid() {
      if (this.components.assistLine) {
        this.designer.removeGrid()
      } else {
        this.designer.addGrid()
      }
      this.components.assistLine = !this.components.assistLine
    },
    /**
     * 添加尺码
     */
    addRuler() {
      if (this.components.ruler) {
        this.myRuler.api.toggleRulerVisibility(false)
      } else {
        this.myRuler.api.toggleRulerVisibility(true)
      }
      this.components.ruler = !this.components.ruler
    },
    handleShowDesignConfirm() {
      this.showSaveConfirm = true
    },
    async handleTile() {
      const activeObject = this.designer.getActiveObject()
      if (!activeObject) return
      if (
        activeObject.imageInfo.width > 2000 ||
        activeObject.imageInfo.height > 2000
      ) {
        this.msgError("图片比例需要在2000*2000以内")
        return
      }
      if (this.isTile == "basic") {
        this.handleTileBasic()
      }
      if (this.isTile == "drop") {
        this.handleTileDrop()
      }
      if (this.isTile == "brick") {
        this.handleTileBrick()
      }
      if (this.isTile == "mirror") {
        this.handleTileMirror()
      }
    },
    // 平铺
    async handleTileBasic() {
      await this.handleUnTile()
      const activeObject = this.designer.getActiveObject()
      if (!activeObject) return
      if (
        activeObject.imageInfo.width > 2000 ||
        activeObject.imageInfo.height > 2000
      ) {
        this.msgError("图片比例需要在2000*2000以内")
        return
      }

      this.designer.performAction(
        {
          name: "tile",
          gapWidth: this.config.gapWidth,
          gapHeight: this.config.gapHeight,
        },
        activeObject
      )
      this.isTile = "basic"
      this.config.showTileConfig = true
    },
    // 平铺
    async handleTileDrop() {
      await this.handleUnTile()
      const activeObject = this.designer.getActiveObject()
      if (!activeObject) return
      if (
        activeObject.imageInfo.width > 2000 ||
        activeObject.imageInfo.height > 2000
      ) {
        this.msgError("图片比例需要在2000*2000以内")
        return
      }
      this.designer.performAction(
        {
          name: "tile",
          mode: "half-drop",
          gapWidth: this.config.gapWidth,
          gapHeight: this.config.gapHeight,
        },
        activeObject
      )
      this.isTile = "drop"
      this.config.showTileConfig = true
    },
    async handleTileBrick() {
      await this.handleUnTile()
      const activeObject = this.designer.getActiveObject()
      if (!activeObject) return
      if (
        activeObject.imageInfo.width > 2000 ||
        activeObject.imageInfo.height > 2000
      ) {
        this.msgError("图片比例需要在2000*2000以内")
        return
      }
      this.designer.performAction(
        {
          name: "tile",
          mode: "half-brick",
          gapWidth: this.config.gapWidth,
          gapHeight: this.config.gapHeight,
        },
        activeObject
      )
      this.isTile = "brick"
      this.config.showTileConfig = true
    },
    async handleTileMirror() {
      await this.handleUnTile()
      const activeObject = this.designer.getActiveObject()
      if (!activeObject) return
      if (
        activeObject.imageInfo.width > 2000 ||
        activeObject.imageInfo.height > 2000
      ) {
        this.msgError("图片比例需要在2000*2000以内")
        return
      }
      this.designer.performAction(
        {
          name: "tile",
          mode: "mirror",
          gapWidth: this.config.gapWidth,
          gapHeight: this.config.gapHeight,
        },
        activeObject
      )
      this.isTile = "mirror"
      this.config.showTileConfig = true
    },
    async handleChangeOpacity() {
      const activeObject = this.designer.getActiveObject()
      if (!activeObject) return
      this.designer.performAction(
        {
          name: "opacity",
          value: this.config.opacity,
        },
        activeObject
      )
      this.config.showOpacityConfig = true
    },
    // 获取当前画布的背景图
    getBackgroundImageObject() {
      return this.designer.getBackgroundImageObject()
    },
    async handleUnTile() {
      const activeObject = this.designer.getActiveObject()
      if (!activeObject) return
      await this.designer.performAction({ name: "untile" }, activeObject)
      this.designer.removeBackgroundImage()
      this.isTile = false
    },
    showTileConfig() {
      this.config.showTileConfig = true
    },
    uploadImg() {
      if (!this.$refs.upload) return
      if (this.partMode == "1") {
        this.$refs.upload.dispatchEvent(new MouseEvent("click"))
      } else {
        this.$refs.uploadEmbroideryImage.dispatchEvent(new MouseEvent("click"))
      }
    },
    limitLines() {
      let text = this.textForm.text

      let b = text.indexOf("\n")
      var num = 0
      while (b !== -1) {
        num++
        b = text.indexOf("\n", b + 1)
      }
      if (num >= 2) {
        let index = text.lastIndexOf("\n")
        this.textForm.text =
          text.substring(0, index) + text.substring(index + 1, text.length)
      }
    },
    /**
     * 处理上传图片
     * @param {object} event e
     */
    async handleUpload(event) {
      let _self = this

      const files = event.target.files
      this.startLoading()
      let isSuccess = true
      for (let file of files) {
        let imageDataArr = []
        const isLt2M = file.size / 1024 / 1024 < 20
        if (!isLt2M) {
          isSuccess = false
          _self.msgError(`${file.name}超过20M，上传失败！`)
          continue
        }
        const { uploadFlag, fileUrl } = await uploadFile(file, true)
        if (!uploadFlag) {
          _self.msgError("上传失败！")
          this.endLoading()
          return
        }
        let fileInfo = await this.getFileInfo(file)
        let imageData = {}
        imageData.picUrl = fileUrl
        imageData.picWidth = fileInfo.picWidth
        imageData.picHeight = fileInfo.picHeight
        imageData.picName = file.name
        imageData.fileSize = file.size
        imageData.mapAttr = this.currentUploadImage == 0 ? "01" : "02"

        //上传低清图片
        if (imageData.picWidth > 150) {
          const img = await this.readImg(file)
          const blob = await this.compressImg(
            img,
            file.type,
            150,
            (150 * imageData.picHeight) / imageData.picWidth
          )
          var result = await uploadFile(blob, true)
          imageData.picUrl2 = result.fileUrl
        } else {
          imageData.picUrl2 = imageData.picUrl
        }

        if (imageData.picWidth > 500) {
          const img = await this.readImg(file)
          const blob = await this.compressImg(
            img,
            file.type,
            500,
            (500 * imageData.picHeight) / imageData.picWidth
          )
          var result = await uploadFile(blob, true)
          imageData.picUrl3 = result.fileUrl
        } else {
          imageData.picUrl3 = imageData.picUrl
        }

        imageDataArr.push(imageData)
        if (this.config.replaceImage) {
          this.performAction({ name: "remove" })
        }
        let response = await addImgMap(imageDataArr)

        if (response.code === 200) {
          let imageUrl = fileUrl

          if (
            fileInfo.picHeight >= fileInfo.picWidth &&
            fileInfo.picHeight > 2000
          ) {
            let width = Math.round(
              (fileInfo.picWidth / fileInfo.picHeight) * 2000
            )
            imageUrl += `?x-oss-process=image/resize,m_fill,w_${width},h_2000/quality,q_100`
          }

          if (
            fileInfo.picWidth > fileInfo.picHeight &&
            fileInfo.picWidth > 2000
          ) {
            let height = Math.round(
              (fileInfo.picHeight / fileInfo.picWidth) * 2000
            )
            imageUrl += `?x-oss-process=image/resize,m_fill,w_2000,h_${height}/quality,q_100`
          }

          let imageObject = {
            id: response.data[0].mapId,
            name: file.name,
            url: imageUrl,
            width: fileInfo.picWidth,
            height: fileInfo.picHeight,
            originalUrl: fileUrl,
            info: {
              width: fileInfo.picWidth,
              height: fileInfo.picHeight,
              type: file.type,
              size: file.size,
            },
          }
          try {
            if (this.partMode == "1") {
              await this.designer.addImage(imageObject)
            } else {
              const params = {
                image_id: response.data[0].mapId,
                name: file.name,
                width: fileInfo.picWidth,
                height: fileInfo.picHeight,
                image: fileUrl,
              }

              try {
                this.performAction({ name: "clear", backgroundColor: "" })
                await this.designer.addEmbroideryImage(params)
              } catch (error) {
                //删除图片
                isSuccess = false
                deleteImgMap({ mapId: response.data[0].mapId })
              }
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          _self.msgError("上传失败！")
          this.endLoading()
          return
        }
      }
      if (_self.$refs["uploadHistory"]) {
        _self.$refs["uploadHistory"].getData()
      }

      _self.$refs["upload"].value = null
      if (isSuccess) {
        _self.$message({
          message: "上传成功",
          type: "success",
          duration: 700,
        })
      }

      this.endLoading()
    },
    getFileInfo(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onload = function(event) {
          var txt = event.target.result
          var img = document.createElement("img")
          img.src = txt
          img.onload = function() {
            let record = {}
            record.picWidth = img.width
            record.picHeight = img.height
            resolve(record)
          }
        }
        reader.readAsDataURL(file)
      })
    },
    readImg(file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const reader = new FileReader()
        reader.onload = function(e) {
          img.src = e.target.result
        }
        reader.onerror = function(e) {
          reject(e)
        }
        reader.readAsDataURL(file)
        img.onload = function() {
          resolve(img)
        }
        img.onerror = function(e) {
          reject(e)
        }
      })
    },
    compressImg(img, type, mx, mh) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement("canvas")
        const context = canvas.getContext("2d")
        const { width: originWidth, height: originHeight } = img
        // 最大尺寸限制
        const maxWidth = mx
        const maxHeight = mh
        // 目标尺寸
        let targetWidth = originWidth
        let targetHeight = originHeight
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > 1) {
            // 宽图片
            targetWidth = maxWidth
            targetHeight = Math.round(maxWidth * (originHeight / originWidth))
          } else {
            // 高图片
            targetHeight = maxHeight
            targetWidth = Math.round(maxHeight * (originWidth / originHeight))
          }
        }
        canvas.width = targetWidth
        canvas.height = targetHeight
        context.clearRect(0, 0, targetWidth, targetHeight)
        // 图片绘制
        context.drawImage(img, 0, 0, targetWidth, targetHeight)
        canvas.toBlob(function(blob) {
          resolve(blob)
        }, type || "image/png")
      })
    },
    handleCopy() {
      this.performAction({ name: "copy" })
      this.msgSuccess("复制成功")
    },
    handleShowLayer() {
      this.components.showLayer = !this.components.showLayer
    },
    handleCloseLayer() {
      this.components.showLayer = false
    },
    /**
     * 切换2d颜色列表
     */
    change2DColor(color) {
      this.designer.change2DColor(color)
    },
    change3DColor(color) {
      this.designer.change3DColor(color)
    },
    /**
     * 获取2d缩略图列表
     */
    get2DPreviewsData() {
      let result = this.designer.get2DPreviewsData()
      this.previewsData = result
    },
    /**
     * 切换2d预览视图
     */
    change2DPreview(partName) {
      this.designer.change2DPreview(partName)
    },
    handleChangePart(record) {
      if (record.is_copied) {
        this.msgError("复制图层不支持切换")
        return
      }
      this.currentPart = record
      this.designer.changePart(record.name)
      this.change2DPreviewByPart(record.name)
      this.config.activePart = record.name
      this.getCurrentObjects()
      //获取背景
      const backgroundColor = this.designer.getCurrentCanvasBackgroundColor()
      this.config.backgroundColor = backgroundColor
    },
    handleChangePartBySwitch() {
      if (!this.currentConfig.support_printing && this.partMode == "1") {
        this.partMode = "2"
        this.msgError("当前产品不支持印花")
        return
      }
      if (!this.currentConfig.support_embroidery && this.partMode == "2") {
        this.partMode = "1"
        this.msgError("当前产品不支持刺绣")
        return
      }

      let partName1 = ""
      let partName2 = ""
      for (let record of this.parts) {
        if (!partName1 && !record.support_embroidery) {
          partName1 = record
        }
        if (!partName2 && record.support_embroidery) {
          partName2 = record
        }
      }
      if (this.partMode == "1") {
        this.handleChangePart(partName1)
        this.designer.toggleControlStyle(false)
        this.currentUploadImage = 0
        this.handleSelectUploadImage(0)
      } else {
        this.handleChangePart(partName2)
        this.currentUploadImage = 1
        this.designer.toggleControlStyle(true)
        this.handleSelectUploadImage(1)
      }
      if (this.currentMenu == 1) {
        this.handleChangeMenu(1)
      }
    },
    /**
     * 根据刀板名称切换2d预览视图
     */
    change2DPreviewByPart(partName) {
      this.designer.change2DPreviewByPart(partName)
    },
    handleSetColor(index) {
      this.setColorVisible = true
      this.imageForm.color_name = this.embroideryImageColors[index]
      this.imageForm.color_index = index
    },
    handleAddEmbroideryImageColor() {
      this.setColorVisible = false
      this.embroideryImageColors[
        this.imageForm.color_index
      ] = this.imageForm.color_name
      this.updateEmbroideryImage()
    },
    /**
     * 获取刀板
     */

    getConfig() {
      const config = this.designer.getConfig()
      this.parts = JSON.parse(JSON.stringify(config.parts))
      if (!config.support_printing) {
        this.partMode = "2"
        this.currentUploadImage = 1
        this.currentProductMenu = 1
        this.designer.toggleControlStyle(true)
        this.handleSelectProductMenu(1)
        // this.currentMaterial = 3
        // this.handleSelectMaterial(3)
      } else {
        this.partMode = "1"
        this.currentUploadImage = 0
        this.currentProductMenu = 0
        this.designer.toggleControlStyle(false)
        // this.handleSelectProductMenu()
        // this.currentMaterial = 0
        // this.handleSelectMaterial(0)
      }
      this.currentPart = this.parts[0]
      this.config.activePart = this.parts[0].name
      this.currentConfig = config
      this.psd_params = this.parts[0].psd_params
      // this.$nextTick(() => {
      //   this.$refs["uploadHistory"].getData()
      // })
    },
    handleDownloadPart() {
      // if (this.config.downloadPart == "") {
      //   this.msgError("请选择刀板")
      //   return
      // }
      let basicId = this.detail.basicId
      let index = basicId.indexOf("-")
      if (index != -1) {
        basicId = basicId.substring(0, index)
      }
      window.open(
        `https://3ddesigner.oss-cn-hongkong.aliyuncs.com/${basicId}/Knives/BusinessKnives.zip`,
        "_blank"
      )
    },
    handleSelectParts(record) {
      let find = false
      for (let i = 0; i <= this.config.toParts.length; i++) {
        if (this.config.toParts[i] == record.name) {
          this.config.toParts.splice(i, 1)
          find = true
          break
        }
      }
      if (!find) {
        this.config.toParts.push(record.name)
      }
    },
    handleSelectPart(record) {
      this.config.downloadPart = record.name
    },
    handleUndo() {
      const length = this.designer.getHistoryUndoLength()
      if (length == 0) {
        return
      }

      this.designer.undo()
      setTimeout(() => {
        this.getCurrentObjects()
      }, 500)
    },
    handleRedo() {
      this.designer.redo()
      setTimeout(() => {
        this.getCurrentObjects()
      }, 500)
    },
    handleAddWeight() {
      let fontWeight = "normal"
      if (this.currentObject.fontWeight == "bold") {
        fontWeight = "normal"
      } else if (this.currentObject.fontWeight == "normal") {
        fontWeight = "bold"
      }
      this.performAction({ name: "fontWeight", value: fontWeight })
      this.currentObject = this.designer.getActiveObject()
    },
    handleAddFontStyle() {
      let fontStyle = "normal"
      if (this.currentObject.fontStyle == "italic") {
        fontStyle = "normal"
      } else if (this.currentObject.fontStyle == "normal") {
        fontStyle = "italic"
      }
      this.performAction({ name: "fontStyle", value: fontStyle })
      this.currentObject = this.designer.getActiveObject()
    },

    // 获取后退历史记录列表长度
    getHistoryRedoLength() {
      setTimeout(() => {
        const length = this.designer.getHistoryRedoLength()
        this.config.redoLength = length
      }, 500)
    },
    handleSetTextAlign(textAlign) {
      this.performAction({ name: "textAlign", value: textAlign })
      this.currentObject = this.designer.getActiveObject()
    },
    async handleRemove() {
      let object = this.currentObject
      if (object.type == "rect") {
        await this.designer.performAction({ name: "untile" }, object)
        this.designer.removeBackgroundImage()
      } else {
        this.performAction({ name: "remove" })
      }
    },
    // 获取前进历史记录列表长度
    getHistoryUndoLength() {
      setTimeout(() => {
        const length = this.designer.getHistoryUndoLength()
        this.config.undoLength = length
      }, 500)
    },
    handleFullScreen() {
      this.launchFullscreen(document.querySelector("body"))
    },
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
    },
    handleCommandMenu(command) {
      let url = ""
      if (command == "console") {
        url = "/index"
      } else if (command == "image") {
        url = "/map/map_mng/imageMe"
      } else if (command == "design") {
        url = "/select/selection/design"
      } else if (command == "list") {
        url = "/select/selection/list?pageNum=1&pageSize=30"
      } else if (command == "order") {
        url = "/order/myOrder/order"
      } else if (command == "cart") {
        url = "/order/myOrder/shopCart"
      } else if (command == "center") {
        url = "/system/account/userInfo"
      } else if (command == "exit") {
        this.handleLogOut()
        return
      }
      this.$router.push({
        path: url,
      })
    },
    handleLogOut() {
      this.$store.dispatch("LogOut").then(() => {
        if (this.user.userType == "00") {
          location.href = "/login_admin"
        } else {
          location.href = "/login"
        }
      })
    },
    getDesignData() {
      const endDate = new Date()
      const startDate = new Date()
      startDate.setDate(endDate.getDate() - 30)
      this.formDesign.endTime = `${endDate.getFullYear()}-${(endDate.getMonth()+1).toString().padStart(2, 0)}-${endDate.getDate().toString().padStart(2, 0)}`
      this.formDesign.beginTime = `${startDate.getFullYear()}-${(startDate.getMonth()+1).toString().padStart(2, 0)}-${startDate.getDate().toString().padStart(2, 0)}`
      listDesign(this.formDesign)
        .then((re) => {
          this.designData = re.rows
          this.totalDesign = re.total
        })
        .catch((err) => {})
    },
    getPartData() {
      this.config.toParts = []
      this.config.partConfig = "1"
      this.config.downloadPart = ""
      this.checkAllParts = false

      // for (let i = 0; i <= this.parts.length; i++) {
      //   this.config.toParts.push(this.parts[i].name)
      // }
    },
    handleChangePreview(index) {
      this.change2DPreview(this.previewsData[index].preview_name)
    },
    handleChangeFontType(value) {
      this.performAction({ name: "fontFamily", value: value })
    },
    handleChangeFontSize(value) {
      this.performAction({ name: "fontSize", value: value })
    },
    handleCurrentChange(pageNum) {
      this.formDesign.pageNum = pageNum
      this.getDesignData()
    },
    async handleSaveDesign(flag) {
      let pIds = [
        "759848612718227456",
        "749720374595035136",

        "720341440962994176",
        "707659002355867648",

        "702601711477182464",
        "698620515915960320",

        "1111",
        "1022",

        "1304",
        "1024",

        "1009",
        "1026",

        "1106",
        "1028",
        "1011",

        "1008",
        "1110",

        "1005",
        "655834166810345472",
        "1013",
        "1206",
      ]

      if (pIds.includes(this.detail.pId)) {
        this.msgError("产品上线中，有需要联系请客服")
        return
      }
      if (this.detail.relaPId) {
        let hintText = ""
        if (this.detail.proName.indexOf("男") > -1) {
          hintText = "是否同步此设计到女款产品"
        } else if (this.detail.proName.indexOf("女") > -1) {
          hintText = "是否同步此设计到男款产品"
        } else {
          hintText = "是否同步此设计到同款产品"
        }

        this.$confirm(hintText, "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
          .then(() => {
            this.handleFinalSave(flag, true)
          })
          .catch((action) => {
            if (action == "cancel") {
              this.handleFinalSave(flag, false)
            }
          })
      } else {
        this.handleFinalSave(flag, false)
      }
    },
    async handleFinalSave(flag, isSync) {
      try {
        if (!this.detail.pId) {
          this.msgError("请选择产品")
          return
        }

        if (!this.canSaveDesigner) {
          this.msgError("正在渲染...请稍等保存")
          return
        }
        if (this.isSubmit) {
          this.msgError("设计保存中...请稍等")
          return
        }

        this.isSubmit = true
        this.$message({
          message: "正在保存...",
          type: "success",
          duration: 1000,
        })
        this.startLoading()
        let form = this._.clone(this.form)

        if (this.currentConfig.support_embroidery) {
          await this.designer.saveEmbroideries()
        }

        form.embroideryPrice = this.embroideryPrice
        if (this.detail.relaPId && isSync) {
          form.relaPId = this.detail.relaPId
        } else {
          form.relaPId = undefined
        }

        const canvasList = this.designer.getFabricCanvasList()

        let mapIds = []
        canvasList.forEach((canvas) => {
          for (let record of canvas._objects) {
            if (
              record.IMAGE_CUSTOMIZE_INFO &&
              record.IMAGE_CUSTOMIZE_INFO.isEmbroideryText
            ) {
              continue
            } else if (record.IMAGE_ID) {
              if (!mapIds.includes(record.IMAGE_ID.toString())) {
                mapIds.push(record.IMAGE_ID.toString())
              }
            } else if (
              record.IMAGE_CUSTOMIZE_INFO &&
              record.IMAGE_CUSTOMIZE_INFO.info &&
              record.IMAGE_CUSTOMIZE_INFO.info.image_id
            ) {
              if (
                !mapIds.includes(
                  record.IMAGE_CUSTOMIZE_INFO.info.image_id.toString()
                )
              ) {
                mapIds.push(
                  record.IMAGE_CUSTOMIZE_INFO.info.image_id.toString()
                )
              }
            }
          }
        })

        let printsParams = Base64.encode(
          JSON.stringify(this.designer.getPrintsParams())
        )
        let skuList = []
        let samples = await this.designer.generateSamples()
        form.canvasJson = this.designer.saveDesign()
        form.mapIds = mapIds
        form.pId = this.detail.pId
        form.printsParams = printsParams
        form.designId = ""
        window.setTimeout(() => {
          this.endLoading()
        }, 0)
        window.setTimeout(() => {
          this.performAction({
            name: "clearAll",
            backgroundColor: "#ffffff",
          })
        }, 200)
        
        this.config.backgroundColor = "#ffffff"

        for (let record of samples) {
          var blob = record.blob
          var file = this.blobToFile(blob, new Date().getTime() + ".png")
          let result = await uploadFile(file)
          if (!result.uploadFlag) {
            this.isSubmit = false
            return
          }
          skuList.push({
            color: record.color_name,
            imageUrl: result.fileUrl,
          })
        }

        let colorList = []
        const newSkuList = []

        skuList.map((el) => {
          colorList.push(el.color)
        })

        let coverPic = ""
        let currentAttr = this._.clone(this.currentAttr)

        colorList = this._.uniq(colorList)

        colorList.map((e) => {
          let ob = {
            color: e,
            imageList: [],
          }

          skuList.map((el) => {
            if (e === el.color) {
              ob.imageList.push(el.imageUrl)
            }
            if (el.color == currentAttr.color && !coverPic) {
              coverPic = el.imageUrl
            }
          })
          newSkuList.push(ob)
        })
        form.properVal = currentAttr.color + ":" + currentAttr.size

        form.skuList = newSkuList
        form.coverPic = coverPic

        if (!flag) {
          await addUserDesign(form)
        } else {
          form.appSkuId = this.$route.query.appSkuId

          form.changeFlag = flag

          await addUserDesignNew(form)
        }

        this.$message({
          message: "设计保存成功",
          type: "success",
          duration: 1000,
        })

        // loading.close()
        this.isSubmit = false
        this.showSaveConfirm = false
      } catch (error) {
        console.log(error)
        this.isSubmit = false
      }
    },
    handleSelectLayer(index) {
      const objects = this.designer.getCurrentObjects()
      let object = objects[index]
      this.designer.selectObject(object)
      this.activeLayer = index
      this.handleConfig(object)
    },
    blobToFile: function(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    getEmbroideryPriceRange() {
      let embroideryNumMax = 0
      this.embroideryNum = 1
      let embroideryList = this.detail.embroideryList
      if (embroideryList) {
        embroideryNumMax = embroideryList[embroideryList.length - 1].highNum
        this.embroideryDiscountPrice = embroideryList[0].discount * 10
      }
      this.embroideryNumMax = embroideryNumMax
    },
    handleChangeEmbroideryNum() {
      if (this.detail.embroideryList) {
        for (let record of this.detail.embroideryList) {
          if (
            this.embroideryNum >= record.lowNum &&
            this.embroideryNum <= record.highNum
          ) {
            this.embroideryDiscountPrice = record.discount * 10
            break
          }
        }
      }
    },
    handleClearCanvas() {
      this.$confirm("是否清空当前设计？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          this.performAction({ name: "clearAll", backgroundColor: "#ffffff" })
        })
        .catch(function() {})
    },
    handleVisible(layer, visible, index) {
      layer.visible = visible
      const objects = this.designer.getCurrentObjects()
      this.designer.selectObject(objects[index])
      this.activeLayer = index
      this.performAction({ name: "toggle" })
    },
    handleLock(layer, lock, index) {
      layer.isLocked = lock
      const objects = this.designer.getCurrentObjects()
      this.designer.selectObject(objects[index])
      this.activeLayer = index
      if (lock) {
        this.performAction({ name: "lock" }, this.designer.getActiveObject())
      } else {
        this.performAction({ name: "unlock" }, this.designer.getActiveObject())
      }
    },
    handleChangeLayer(pos) {
      if (pos == "x") {
        this.performAction({ name: "changePositionX", value: this.layerInfo.x })
      }
      if (pos == "y") {
        this.performAction({ name: "changePositionY", value: this.layerInfo.y })
      }
      if (pos == "w") {
        this.performAction({ name: "changeWidth", value: this.layerInfo.w })
      }
      if (pos == "h") {
        this.performAction({ name: "changeHeight", value: this.layerInfo.h })
      }
    },
    handleLockLayer(lock) {
      if (lock) {
        this.performAction({ name: "lock" }, this.designer.getActiveObject())
        this.config.isLocked = true
      } else {
        this.performAction({ name: "unlock" }, this.designer.getActiveObject())
        this.config.isLocked = false
      }
      this.getCurrentObjects()
    },
    handleUp(layer, index) {
      const objects = this.designer.getCurrentObjects()
      this.designer.selectObject(objects[index])
      this.performAction({ name: "bringUp" })
      this.getCurrentObjects()
    },
    handleDown(layer, index) {
      const objects = this.designer.getCurrentObjects()
      this.designer.selectObject(objects[index])
      this.performAction({ name: "bringDown" })
      this.getCurrentObjects()
    },
    async handleDelete(record, index) {
      let objects = this.designer.getCurrentObjects()
      this.designer.selectObject(objects[index])
      const object = objects[index]
      if (object.type == "rect") {
        await this.designer.performAction({ name: "untile" }, object)
        this.designer.removeBackgroundImage()
      } else {
        this.performAction({ name: "remove" })
      }
    },
    async handleChangeProduct(record) {
      this.startLoading()
      let result = await getDesign(record.designId)
      let designData = result.data
      let productResult = await getProductDetail(designData.pId)
      let basicId = this.detail.basicId

      this.config.backgroundColor = "#ffffff"
      this.config.tileValue = "50"

      this.performAction({
        name: "clearAll",
        backgroundColor: "#ffffff",
      })

      this.detail = productResult.data
      this.processData()
      if (basicId != this.detail.basicId) {
        await this.init2D(this.detail.basicId, "preview")
      }

      await this.sleep(500)
      if (designData.canvasJson) {
        await this.designer.loadDesign(designData.canvasJson)
        if (designData && designData.embroideryPrice) {
          this.embroideryPrice = designData.embroideryPrice
        }
      } else {
        //加入一张图片
        if (designData.mapIds && designData.mapIds.length > 0) {
          let mapId = designData.mapIds[0].mapId
          let imageInfo = (await getMapInfo(mapId)).data
          let imageUrl = imageInfo.picUrl
          if (
            imageInfo.picHeight >= imageInfo.picWidth &&
            imageInfo.picHeight > 2000
          ) {
            let width = Math.round(
              (imageInfo.picWidth / imageInfo.picHeight) * 2000
            )
            imageUrl += `?x-oss-process=image/resize,m_fill,w_${width},h_2000/quality,q_100`
          }

          if (
            imageInfo.picWidth > imageInfo.picHeight &&
            imageInfo.picWidth > 2000
          ) {
            let height = Math.round(
              (imageInfo.picHeight / imageInfo.picWidth) * 2000
            )
            imageUrl += `?x-oss-process=image/resize,m_fill,w_2000,h_${height}/quality,q_100`
          }
          let imageObject = {
            id: imageInfo.mapId,
            name: imageInfo.picName,
            url: imageUrl,
            width: imageInfo.picWidth,
            height: imageInfo.picHeight,
            originalUrl: imageInfo.picUrl,
            info: {
              width: imageInfo.picWidth,
              height: imageInfo.picHeight,
              type: "image/jpeg",
            },
          }
          try {
            await this.designer.addImage(imageObject)
          } catch (error) {
            console.log(error)
          }
        }
      }
      this.get2DPreviewsData()
      this.getConfig()
      setTimeout(() => {
        this.getCurrentObjects()
        let backgroundColor = this.designer.getCurrentCanvasBackgroundColor()
        this.config.backgroundColor = backgroundColor
      }, 1000)

      setTimeout(() => {
        const canvasList = this.designer.getFabricCanvasList()
        canvasList.forEach((canvas) => {
          canvas.renderAll()
        })
      }, 3000)

      this.init2DColor()

      this.endLoading()
    },
    handleCopyColor() {
      var text = `
【值: "#171717", 颜色: "black"】
【值: "#ffffff", 颜色: "white"】
【值: "#a1a1a1", 颜色: "grey"】
【值: "#9c6a23", 颜色: "brown"】
【值: "#d82424", 颜色: "red"】
【值: "#ee6419", 颜色: "orange"】
【值: "#50b03c", 颜色: "green"】
【值: "#035239", 颜色: "darkGreen"】
【值: "#192c7c", 颜色: "blue"】
【值: "#3f92db", 颜色: "sky"】
【值: "#934b7c", 颜色: "purple"】
【值: "#ffde00", 颜色: "yellow"】`
      let target = document.createElement("input") //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target)
      target.value = text // 修改文本框的内容
      target.select() // 选中文本
      document.execCommand("copy") // 执行浏览器复制命令
      this.msgSuccess("复制成功")
      document.body.removeChild(target)
    },
    handleCopyText(text) {
      let target = document.createElement("input") //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target)
      target.value = text // 修改文本框的内容
      target.select() // 选中文本
      document.execCommand("copy") // 执行浏览器复制命令
      this.msgSuccess("复制设计编号成功")
      document.body.removeChild(target)
    },
    handleCheckParts() {
      if (this.checkAllParts) {
        this.config.toParts = []
        for (let record of this.parts) {
          this.config.toParts.push(record.name)
        }
      } else {
        this.config.toParts = []
      }
    },
    async handleSetBackground() {
      if (this.config.isSetBackground) {
        await this.handleUnTile()
        const activeObject = this.designer.getActiveObject()
        if (!activeObject) return
        this.designer.performAction(
          {
            name: "tile",
            gapWidth: 0,
            gapHeight: 0,
          },
          activeObject
        )
      } else {
        const activeObject = this.designer.getActiveObject()
        if (!activeObject) return
        await this.designer.performAction({ name: "untile" }, activeObject)
        this.designer.removeBackgroundImage()
      }
    },
    handleShowKeyConfig() {
      this.setKeyVisible = true
    },
    async handleSaveKey() {
      this.unbindKey()
      let hotKey = this.userProfile.user.hotKey
      if (!hotKey) {
        hotKey = {}
      } else {
        hotKey = JSON.parse(this.userProfile.user.hotKey)
      }
      if (this.isApple) {
        hotKey.apple = this.keyConfig
      } else {
        hotKey.windows = this.keyConfig
      }
      let data = {
        userName: this.user.name,
        hotKey: JSON.stringify(hotKey),
      }
      let result = await setHotKey(data)
      this.msgSuccess("保存快捷键成功")
      this.setKey = false
      this.bindKey()
    },
    handleZoomin() {
      this.config.scale++
      this.config.scale++
      this.performAction({ name: "scale", value: this.config.scale })
    },
    handleZoomout() {
      this.config.scale--
      this.config.scale--
      this.performAction({ name: "scale", value: this.config.scale })
    },
    convertCanvasToImage(canvas) {
      if (canvas) {
        let imageBase64 = canvas.toDataURL("image/png")
        return imageBase64
      }
      return ""
    },
  },
}
</script>

<style lang="scss">
@import "../../../assets/css/custom.css";

#deCreate {
  color: #495b6e;
  // position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  .logo {
    width: 118px;
  }
  .main-panel {
    padding: 0 10vw 0px 10vw;
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;
  }
  @media screen and (min-width: 2000px) {
    .main-panel {
      padding: 0 20vw 0px 20vw;
    }
    .view-img {
      left: calc(20vw - 90px) !important;
    }
    .bg-color-set {
      right: calc(20vw - 58px) !important;
    }
  }
  .canvas-item__canvas-wrap {
    top: calc(50%);
    transform: translateY(-50%);
    position: absolute;
  }
  background: #ffffff;
  .main {
    overflow: hidden;
    font-size: 13px;
    color: #666;
    flex: 1;
    display: flex;
    flex-direction: row;
    bottom: 0;
    position: relative;

    .left-panel {
      width: 390px;
      padding: 0 0 8px 0;
      box-sizing: border-box;
      background: #ffffff;

      .search {
        padding: 0 8px 0 0;
      }

      .header {
        padding: 8px 0px 16px 0px;
        border-bottom: 1px dashed #e5e5e5;
        .button {
          height: 36px;
          border: solid 1px #d9d9d9;
          border-radius: 4px;
          padding: 10px 18px;
          color: #666;
          display: inline-block;
          font-size: 14px;
          line-height: 14px;
          cursor: pointer;
          margin-right: 16px;
          box-sizing: border-box;
        }
        :last-child {
          margin-right: 0px;
        }
        .is-select {
          background-color: #4934b2;
          color: #fff;
          cursor: default;
        }
      }

      .content {
        padding: 10px 0 0 9px;

        .classify {
          padding: 16px 8px 0 0;
        }

        .result {
          flex: 1;
          overflow: hidden;
          position: relative;
          padding-bottom: 20px;

          .result-content {
            height: calc(100vh - 246px);
            overflow: auto;
            padding: 0 0 8px 0;
            margin: 8px 0 23px 0;
          }
          .active {
            border: 1px solid #4934b2 !important;
          }

          .item {
            width: 95px;
            height: 95px;
            float: left;
            margin-top: 9px;
            margin-left: 8px;
            position: relative;
            border: solid 1px #e5e5e5;
            box-sizing: border-box;
            border-radius: 5px;

            img {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
              border-radius: 5px;
            }
          }
          .item:hover {
            // box-shadow: rgb(0 0 0 / 5%) 2px 6px 10px 5px;
            border: 1px solid #4934b2 !important;
          }
          .result-content :nth-child(3n + 1) {
            margin-left: 0px;
          }
        }
        .pagination {
          width: 100%;
          height: 44px;
          position: absolute;
          left: 0px;
          right: 0;
          bottom: 0;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-pagination__total {
            margin-right: 0px;
          }
          .btn-prev {
            padding-right: 0px;
          }
          .btn-next {
            padding-left: 0px;
          }
          .el-pagination__jump {
            margin-left: 8px;
          }
          .el-pagination .el-select .el-input {
            width: 86px;
          }
        }
      }
      .menu {
        overflow: hidden;
        margin: 0 0 16px 0;
        .menu-item {
          float: left;
          margin: 0 21px 0 0;
          padding: 0 0 4px 0;
          width: 56px;
          text-align: center;
          box-sizing: border-box;
          cursor: pointer;
        }
        .menu-item-select {
          border-bottom: 2px solid #4934b2;
        }
      }
      .upload-button {
        margin: 0 0 0px 0;
      }
    }
    .simple-designer {
      flex: auto;
      position: relative;
      box-sizing: border-box;
      background-color: #f0f5ff;
      overflow: hidden;
      padding-top: 6vh;

      .toolbar {
        margin: 12px 0 0 0;
        text-align: center;
        .thirdly-designer-icon {
          font-size: 26px !important;
          color: #666;
        }
        .operation-list {
          overflow: hidden;
          margin: 0 auto;
          display: inline-block;
          .base-icon-button {
            float: left;
            margin: 0 16px 0 0;
          }
        }
      }
    }
    .simple-designer__content {
      padding: 2% 0;
      margin: 0 auto;
      max-width: calc(100vh - 154px - 4%);
      box-sizing: border-box;
    }
    .right-panel {
      width: 330px;
      background: #ffffff;
      padding: 0 0 0 0;
      position: relative;
      .layer-list {
        width: 100%;
        padding: 0 8px 0 8px;
        box-sizing: border-box;
        max-height: 220px;
        overflow-y: auto;
        .layer-item {
          overflow: hidden;
          line-height: 36px;
          border: 1px dashed grey;
          padding: 0px 8px 0px 8px;
          margin-bottom: 8px;
          box-sizing: border-box;
          .image-wrap {
            float: left;
            margin: 0 8px 4px 0;
            img {
              width: 32px;
              height: 32px;
              vertical-align: middle;
            }
          }
          .layer-name {
            float: left;
            font-size: 14px;
          }
          .layer-tools {
            float: right;
            i {
              margin-right: 5px;
            }
          }
        }
      }
      .thumb {
        margin: 0 0 10px 0;
        padding: 2px 0 0 0;
        box-sizing: border-box;
        width: 100%;
        border: 1px solid #f6f6f6;
        box-shadow: 0 9px 28px 8px rgb(0 0 0 / 5%), 0 6px 16px 0 rgb(0 0 0 / 8%),
          0 3px 6px -4px rgb(0 0 0 / 12%);
        img {
          width: 70%;
        }
        .name {
          font-size: 16px;
          text-align: center;
        }
      }
      .price {
      }
      .buttons {
        text-align: right;
        margin: 8px 8px 16px 0;
        padding: 6px 0px 14px 0;
        border-bottom: 1px solid #f0f5ff;
      }

      .appearance-button {
        overflow: hidden;
        margin: 0 8px 12px 16px;
        ul {
          float: left;
        }
      }

      .color-picker-list li,
      .color-picker-list-hover li,
      .mgg-preview-colors li {
        background-color: #fff;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: #d6d2d2 solid 1px;
        margin-left: 2px;
        padding: 1px;
        float: left;
      }

      .color-picker-list li.cur,
      .mgg-preview-colors li.cur,
      .size-picker-list li.cur {
        border: #4934b2 solid 2px;
      }

      .color-picker-list li a,
      .color-picker-list-hover li a,
      .mgg-preview-colors li a {
        width: 24px;
        height: 24px;
        display: table;
      }

      .size-button {
        overflow: hidden;
        margin: 0 8px 0 0;
        .size-picker-list {
          float: left;
          margin: 0 0 8px 16px;
        }
      }

      .size-button .size-picker-list li {
        margin: 0px 4px 4px 4px;
        cursor: pointer;
        display: inline-block;
        border-style: solid;
        border-width: 1px;
        padding: 0 4px;
        border-color: rgb(219, 219, 219);
        border-radius: 2px;
        background-color: rgb(253, 253, 253);
        min-width: 40px;
        height: 24px;
        line-height: 22px;
        text-align: center;
      }

      .size-button .size-picker-list li.cur {
        border: 2px solid #4934b2;
        color: #4934b2;
      }
    }
    .el-carousel__item {
      text-align: center;
      cursor: zoom-in;
    }
  }
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ddd;
  }
  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ffffff;
  }
  .el-carousel__button {
    width: 7px;
    height: 7px;
    border-radius: 8px;
    background: #8f8f90;
  }
  .el-carousel__indicator.is-active button {
    background: #4934b2;
  }
  .preview-area {
    overflow: hidden;
    .carousel {
      width: 600px;
      float: left;
      .el-carousel__item {
        text-align: center;
      }
      .el-carousel__container {
        height: 500px;
      }
      img {
        width: 500px;
        height: 500px;
      }
    }
    .preview-list {
      width: 130px;
      float: left;
      height: 500px;
      margin: 0 0 0 16px;
      overflow-y: auto;
      .preview-list-item {
        border: 1px solid #e5e5e5;
        margin: 0 8px 15px 0;
        box-sizing: border-box;
        width: 111px;
        height: 111px;
        position: relative;
        cursor: pointer;
        .preview-text {
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
          text-align: center;
          width: 100%;
          background: rgba(0, 0, 0, 0.4);
          color: #fff;
          padding: 0.05rem 0;
          font-size: 0.14rem;
          z-index: 10;
          font-size: 14px;
        }
        &:hover .preview-text {
          display: block;
        }
        &.is-active .preview-text {
          display: block;
          background: #4934b2;
        }
      }

      img {
        width: 109px;
        height: 109px;
      }
      .is-active {
        border: 1px solid #4934b2;
      }
    }
    .color-picker {
      overflow: hidden;
      margin: 16px 8px 0 0;
      ul {
        overflow: hidden;
        padding: 0px 0 0 266px;
      }
    }

    .color-picker-list li,
    .color-picker-list-hover li {
      background-color: #fff;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      border: #d6d2d2 solid 1px;
      margin-left: 2px;
      padding: 1px;
      float: left;
    }
    .color-picker-list li.cur {
      border: #4934b2 solid 2px;
    }
    .color-picker-list li a,
    .color-picker-list-hover li a {
      width: 24px;
      height: 24px;
      display: table;
    }
  }
  .left-panel {
    display: flex;
    .toolbar {
      width: 65px;
      height: calc(100vh - 75px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: center;
      padding-top: 9px;
      background-color: #fff;
      z-index: 1;
      .tool-item {
        height: 62px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        line-height: 18px;
        cursor: pointer;
      }
      .menu-item {
        font-size: 29px;
        margin: 0 auto;
      }
      .active {
        color: #4934b2;
        background-color: #d2e7f7;
      }
    }
    .content {
      width: 320px;
      height: calc(100vh - 70px);
      overflow: hidden;
      background: #fff;
      transition: all 0.3s;
      opacity: 1;
    }
  }
  .f24 {
    font-size: 24px !important;
    line-height: 32px;
  }
  .product {
    height: 100%;
  }
  .row-name {
    padding: 0 20px 13px 20px;
    font-size: 16px;
    border-bottom: 1px solid #f0f5ff;
    overflow: hidden;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85);
    padding: 14px 20px 13px 20px;
  }
  .row-name .code {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    white-space: nowrap;
    display: flex;
  }
  .row-name .price {
    font-size: 16px;
    color: #fa8c16;
  }
  .row-name > .container {
    display: flex;
    justify-content: space-between;
  }
  .row-size {
    .title {
      line-height: 24px;
      padding: 8px 20px 5px 20px;
      font-size: 14px;
    }
    border-bottom: 1px solid #f0f5ff;
  }
  .product-name {
    float: left;
  }
  .product-price {
    float: right;
    color: #fa8c16;
  }
  .el-color-picker__trigger {
    height: 36px;
    width: 36px;
  }
}

.zwdesign-header {
  flex: none;
  height: 55px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid rgba(31, 93, 145, 0.1);
  box-shadow: 0 0 10px 0 rgba(31, 93, 145, 0.1);
}

.zwdesign-header .zwdesign-header--left {
  min-width: 380px;
  width: 380px;
  padding: 0 15px;
}

.zwdesign-header .zwdesign-header--left .logo {
  font-size: 34px;
  color: #3d47bf;
}

.zwdesign-header .zwdesign-header--center {
  display: flex;
  height: 100%;
  min-width: 450px;
  flex: 1;
  padding: 0;
}

.zwdesign-header .zwdesign-header--center .line {
  width: 1px;
  height: 100%;
  margin-right: 10px;
  margin-left: 10px;
}

[data-theme="default"] .zwdesign-header .zwdesign-header--center .line {
  background-color: #ddd !important;
}

[data-theme="dark"] .zwdesign-header .zwdesign-header--center .line,
[data-theme="light"] .zwdesign-header .zwdesign-header--center .line {
}

.zwdesign-header .zwdesign-header--center .left-toolbar {
  flex: 1 0 auto;
  display: flex;
}

.zwdesign-header .zwdesign-header--center .right-toolbar {
  flex: none;
  display: flex;
}

.zwdesign-header .zwdesign-header--center .toolbar-item {
  margin-top: 5px;
  cursor: pointer;
  text-align: center;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 400;
}

[data-theme="default"] .zwdesign-header .zwdesign-header--center .toolbar-item {
  color: #495b6e !important;
}

[data-theme="dark"] .zwdesign-header .zwdesign-header--center .toolbar-item,
[data-theme="light"] .zwdesign-header .zwdesign-header--center .toolbar-item {
  color: !important;
}

.zwdesign-header .zwdesign-header--center .toolbar-item .iconbox {
  padding: 5px;
  background: transparent;
  border-radius: 5px;
}

.zwdesign-header .zwdesign-header--center .toolbar-item .icon {
  font-size: 16px;
}

.zwdesign-header .zwdesign-header--center .toolbar-item .toolbar-item-text {
  font-weight: 400;
}

.zwdesign-header .zwdesign-header--center .toolbar-item.active .iconbox {
  background: #f0f5ff;
}

.zwdesign-header .zwdesign-header--center .toolbar-item.active .icon,
.zwdesign-header
  .zwdesign-header--center
  .toolbar-item.active
  .toolbar-item-text {
  color: #4934b2;
}

.zwdesign-header .zwdesign-header--right {
  flex: none;
  min-width: 320px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px;
  .toolbar-item {
    color: #495b6e;
    font-size: 12px;
    width: 56px;
    text-align: center;
    &:hover {
      color: #4934b2;
      .toolbar-item-text {
        color: #4934b2;
      }
    }
  }
}

.zwdesign-header .zwdesign-header--right .save-record {
  margin-right: 24px;
  outline: 0;
}

.zwdesign-header .zwdesign-header--right .save-record,
.zwdesign-header .zwdesign-header--right .shopping-cart {
  display: inline-block;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  position: relative;
  margin-left: 8px;
}

.zwdesign-header .zwdesign-header--right .save-record .dot,
.zwdesign-header .zwdesign-header--right .shopping-cart .dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #ff4d4f;
  border-radius: 50%;
  position: absolute;
  right: 19px;
  top: 10px;
}

.zwdesign-header .zwdesign-header--right .save-record .border-r,
.zwdesign-header .zwdesign-header--right .shopping-cart .border-r {
  border-right: 1px solid rgba(0, 0, 0, 0.15);
}

.zwdesign-header .zwdesign-header--right .save-record.active,
.zwdesign-header .zwdesign-header--right .shopping-cart.active {
  color: #4934b2;
}

.zwdesign-header .zwdesign-header--right .dividing-line {
  width: 1px;
  height: 28px;
  background: rgba(0, 0, 0, 0.15);
}

.save-btn-content {
  min-width: 68px;
  height: 32px;
  line-height: 32px;
  color: #ffffff;
  margin: 0 0 0 28px;
}

.save-btn-content .save-btn {
  min-width: 68px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  white-space: nowrap;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 24px;
  padding: 0 8px;
}

[data-theme="default"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  color: #fff !important;
}

[data-theme="light"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  color: #414141 !important;
}

[data-theme="dark"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  color: #a7a7a7 !important;
}

[data-theme="default"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  background-color: #4934b2 !important;
}

[data-theme="dark"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn,
[data-theme="light"]
  .zwdesign-header
  .zwdesign-header--right
  .save-btn-content
  .save-btn {
  background-color: !important;
}

.zwdesign-header .zwdesign-header--right .save-btn-content .buynow-btn {
  min-width: 90px;
  margin-left: 10px;
}

.zwdesign-header .zwdesign-header--right .login-btn {
  color: rgba(0, 0, 0, 0.15);
  font-size: 32px;
  cursor: pointer;
  margin-left: 20px;
}

.zwdesign-header .zwdesign-header--right .merchant-name {
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 550;
  font-size: 14px;
  cursor: pointer;
  padding: 15px 0;
  margin-left: 20px;
}

.zwdesign-header .zwdesign-header--right .merchant-name span {
  display: inline-block;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.zwdesign-header .zwdesign-header--right .merchant-name i.arrow {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 550;
}

@media screen and (max-width: 1450px) {
  .zwdesign-header .zwdesign-header--right.logined .login-btn,
  .zwdesign-header .zwdesign-header--right.logined .merchant-name,
  .zwdesign-header .zwdesign-header--right.logined .save-btn,
  .zwdesign-header .zwdesign-header--right.logined .save-record,
  .zwdesign-header .zwdesign-header--right.logined .shopping-cart {
    margin-left: 10px;
  }

  .zwdesign-header .zwdesign-header--right.logined .save-record {
    margin-right: 10px;
  }
}

.iconfont {
  font-family: iconfont !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.iconnav_logo:before {
  content: "\e68c";
}

.iconmember-o-mian:before {
  content: "\e686";
}

.iconcustom-label:before {
  content: "\e7b7";
}

.iconicon-label_overtime-payment:before {
  content: "\e7b4";
}

.iconicon-label_ontimeship1:before {
  content: "\e7b5";
}

.iconicon-ontimeship:before {
  content: "\e7b3";
}

.iconcolumn-reduction:before {
  content: "\e7b2";
}

.iconalign:before {
  content: "\e7b1";
}

.iconrotate-right:before {
  content: "\e7ad";
}

.iconrotate-left:before {
  content: "\e7ae";
}

.iconfile-copy:before {
  content: "\e7af";
}

.iconbg:before {
  content: "\e7b0";
}

.iconleft-down-deformed:before {
  content: "\e7a7";
}

.icondrag-up:before {
  content: "\e7ac";
}

.iconbtn-add:before {
  content: "\e7a6";
}

.icondrag-left:before {
  content: "\e7a8";
}

.iconbtn-Less:before {
  content: "\e7a9";
}

.iconfloating-window:before {
  content: "\e7aa";
}

.iconreduction:before {
  content: "\e7ab";
}

.iconenlarge:before {
  content: "\e7a5";
}

.iconsetting:before {
  content: "\e7a3";
}

.iconfolder:before {
  content: "\e7a4";
}

.iconclose-fill:before {
  content: "\e7a1";
}

.iconrevoke-fill:before {
  content: "\e7a2";
}

.iconmember-level4:before {
  content: "\e799";
}

.iconmember-o-level2:before {
  content: "\e79d";
}

.iconmember-o-level1:before {
  content: "\e79e";
}

.iconmember-o-level4:before {
  content: "\e79f";
}

.iconmember-o-level3:before {
  content: "\e7a0";
}

.iconqq1:before {
  content: "\e7b6";
}

.iconweixing:before {
  content: "\e87a";
}

.icondrop-out:before {
  content: "\e79c";
}

.iconfolder-open-fill:before {
  content: "\e798";
}

.iconsave-fill:before {
  content: "\e79a";
}

.iconshopping-cart:before {
  content: "\e79b";
}

.iconicon_90degree:before {
  content: "\e600";
}

.iconicon_180degree:before {
  content: "\e601";
}

.iconicon_45degree:before {
  content: "\e602";
}

.iconbtn-lock:before {
  content: "\e797";
}

.iconcaveat-triangle-fill:before {
  content: "\e796";
}

.icondisable-redline:before {
  content: "\e795";
}

.iconstraw:before {
  content: "\e794";
}

.iconalign-center:before {
  content: "\e78c";
}

.iconalign-both:before {
  content: "\e78d";
}

.iconalign-left1:before {
  content: "\e78e";
}

.iconfont-size1:before {
  content: "\e78f";
}

.iconfont-slanted:before {
  content: "\e790";
}

.iconalign-right:before {
  content: "\e791";
}

.iconfont-underscore:before {
  content: "\e792";
}

.iconfont-strikethrough:before {
  content: "\e793";
}

.iconavatar:before {
  content: "\e78a";
}

.iconfree:before {
  content: "\e78b";
}

.iconselected:before {
  content: "\e789";
}

.iconCertification:before {
  content: "\e787";
}

.iconPromotion:before {
  content: "\e788";
}

.iconmember-level2:before {
  content: "\e784";
}

.iconmember-level1:before {
  content: "\e785";
}

.iconmember-level3:before {
  content: "\e786";
}

.iconcaveat-circle-fill:before {
  content: "\e782";
}

.iconcaveat-circle:before {
  content: "\e783";
}

.iconclose-bold:before {
  content: "\e780";
}

.iconselect-bold:before {
  content: "\e781";
}

.iconlabel_promotion:before {
  content: "\e77d";
}

.iconlabel_select:before {
  content: "\e77e";
}

.iconlabel_prerogative:before {
  content: "\e77f";
}

.iconbtn-delete:before {
  content: "\e77b";
}

.iconbtn-sync:before {
  content: "\e77c";
}

.iconungroup:before {
  content: "\e779";
}

.icongroup:before {
  content: "\e77a";
}

.iconinfo-circle-fill:before {
  content: "\e778";
}

.iconfont-column-skip:before {
  content: "\e777";
}

.icontoggle:before {
  content: "\e7c3";
}

.iconlogo1:before {
  content: "\e7c2";
}

.iconheart:before {
  content: "\e7df";
}

.iconheart-fill:before {
  content: "\e849";
}

.iconzoom-out1:before {
  content: "\e684";
}

.iconmenu:before {
  content: "\e7f4";
}

.iconrotate-right45:before {
  content: "\e7b9";
}

.iconrotate-left45:before {
  content: "\e7ba";
}

.iconarrawsalt:before {
  content: "\e7e9";
}

.iconfullscreen1:before {
  content: "\e7ec";
}

.iconcolum-height:before {
  content: "\e7ef";
}

.iconcolumn-width1:before {
  content: "\e7fc";
}

.iconzuoyoufanzhuan_huaban1:before {
  content: "\e65f";
}

.iconchuizhifanzhuan_huaban1:before {
  content: "\e660";
}

.iconicon_new:before {
  content: "\e603";
}

.iconic_amazon:before {
  content: "\e61e";
}

.iconcustomer:before {
  content: "\e7b8";
}

.iconnav_logo:before {
  content: "\e68c";
}

.iconmember-o-mian:before {
  content: "\e686";
}

.iconcustom-label:before {
  content: "\e7b7";
}

.iconicon-label_overtime-payment:before {
  content: "\e7b4";
}

.iconicon-label_ontimeship1:before {
  content: "\e7b5";
}

.iconicon-ontimeship:before {
  content: "\e7b3";
}

.iconcolumn-reduction:before {
  content: "\e7b2";
}

.iconalign:before {
  content: "\e7b1";
}

.iconrotate-right:before {
  content: "\e7ad";
}

.iconrotate-left:before {
  content: "\e7ae";
}

.iconfile-copy:before {
  content: "\e7af";
}

.iconbg:before {
  content: "\e7b0";
}

.iconleft-down-deformed:before {
  content: "\e7a7";
}

.icondrag-up:before {
  content: "\e7ac";
}

.iconbtn-add:before {
  content: "\e7a6";
}

.icondrag-left:before {
  content: "\e7a8";
}

.iconbtn-Less:before {
  content: "\e7a9";
}

.iconfloating-window:before {
  content: "\e7aa";
}

.iconreduction:before {
  content: "\e7ab";
}

.iconenlarge:before {
  content: "\e7a5";
}

.iconsetting:before {
  content: "\e7a3";
}

.iconfolder:before {
  content: "\e7a4";
}

.iconclose-fill:before {
  content: "\e7a1";
}

.iconrevoke-fill:before {
  content: "\e7a2";
}

.iconmember-level4:before {
  content: "\e799";
}

.iconmember-o-level2:before {
  content: "\e79d";
}

.iconmember-o-level1:before {
  content: "\e79e";
}

.iconmember-o-level4:before {
  content: "\e79f";
}

.iconmember-o-level3:before {
  content: "\e7a0";
}

.iconqq1:before {
  content: "\e7b6";
}

.iconweixing:before {
  content: "\e87a";
}

.icondrop-out:before {
  content: "\e79c";
}

.iconfolder-open-fill:before {
  content: "\e798";
}

.iconsave-fill:before {
  content: "\e79a";
}

.iconshopping-cart:before {
  content: "\e79b";
}

.iconicon_90degree:before {
  content: "\e600";
}

.iconicon_180degree:before {
  content: "\e601";
}

.iconicon_45degree:before {
  content: "\e602";
}

.iconbtn-lock:before {
  content: "\e797";
}

.iconcaveat-triangle-fill:before {
  content: "\e796";
}

.icondisable-redline:before {
  content: "\e795";
}

.iconstraw:before {
  content: "\e794";
}

.iconalign-center:before {
  content: "\e78c";
}

.iconalign-both:before {
  content: "\e78d";
}

.iconalign-left1:before {
  content: "\e78e";
}

.iconfont-size1:before {
  content: "\e78f";
}

.iconfont-slanted:before {
  content: "\e790";
}

.iconalign-right:before {
  content: "\e791";
}

.iconfont-underscore:before {
  content: "\e792";
}

.iconfont-strikethrough:before {
  content: "\e793";
}

.iconavatar:before {
  content: "\e78a";
}

.iconfree:before {
  content: "\e78b";
}

.iconselected:before {
  content: "\e789";
}

.iconCertification:before {
  content: "\e787";
}

.iconPromotion:before {
  content: "\e788";
}

.iconmember-level2:before {
  content: "\e784";
}

.iconmember-level1:before {
  content: "\e785";
}

.iconmember-level3:before {
  content: "\e786";
}

.iconcaveat-circle-fill:before {
  content: "\e782";
}

.iconcaveat-circle:before {
  content: "\e783";
}

.iconclose-bold:before {
  content: "\e780";
}

.iconselect-bold:before {
  content: "\e781";
}

.iconlabel_promotion:before {
  content: "\e77d";
}

.iconlabel_select:before {
  content: "\e77e";
}

.iconlabel_prerogative:before {
  content: "\e77f";
}

.iconbtn-delete:before {
  content: "\e77b";
}

.iconbtn-sync:before {
  content: "\e77c";
}

.iconungroup:before {
  content: "\e779";
}

.icongroup:before {
  content: "\e77a";
}

.iconinfo-circle-fill:before {
  content: "\e778";
}

.iconfont-column-skip:before {
  content: "\e777";
}

.iconlogo:before {
  content: "\e776";
}

.iconnum-c6:before {
  content: "\e759";
}

.iconnum-c3:before {
  content: "\e761";
}

.iconarrow-left-bold:before {
  content: "\e775";
}

.iconalign-left:before {
  content: "\e71e";
}

.iconarrow-down-bold:before {
  content: "\e71f";
}

.iconarrow-right-bold:before {
  content: "\e720";
}

.iconarrow-up-bold:before {
  content: "\e721";
}

.iconborder-outer:before {
  content: "\e722";
}

.iconborder-aider:before {
  content: "\e723";
}

.iconbright:before {
  content: "\e724";
}

.iconborder-info:before {
  content: "\e725";
}

.iconcaret-down:before {
  content: "\e726";
}

.iconcanvas-recovery:before {
  content: "\e727";
}

.iconcanvas-expend:before {
  content: "\e728";
}

.iconcaret-more:before {
  content: "\e729";
}

.iconbrush:before {
  content: "\e72a";
}

.iconcaret-right:before {
  content: "\e72b";
}

.iconcolumn-height:before {
  content: "\e72c";
}

.iconcontrol-fill:before {
  content: "\e72d";
}

.iconcolumn-paved:before {
  content: "\e72e";
}

.iconcontrol:before {
  content: "\e72f";
}

.iconcolumn-max:before {
  content: "\e731";
}

.iconcolumn-width:before {
  content: "\e732";
}

.icondelete:before {
  content: "\e733";
}

.iconcutout:before {
  content: "\e734";
}

.iconcrop:before {
  content: "\e735";
}

.icondistribute-level:before {
  content: "\e736";
}

.icondistribute-plumb:before {
  content: "\e737";
}

.icondistributed-bottom:before {
  content: "\e738";
}

.icondistributed-left:before {
  content: "\e739";
}

.icondistributed-center:before {
  content: "\e73a";
}

.icondistributed-left-bottom:before {
  content: "\e73b";
}

.icondistributed-right-top:before {
  content: "\e73c";
}

.iconeye-close:before {
  content: "\e73d";
}

.iconfile-add-to:before {
  content: "\e73e";
}

.iconfilter:before {
  content: "\e73f";
}

.iconfile-add:before {
  content: "\e740";
}

.iconfont-column-width:before {
  content: "\e741";
}

.iconeye-open:before {
  content: "\e742";
}

.iconfont-column-height:before {
  content: "\e743";
}

.iconcanvas-compress:before {
  content: "\e744";
}

.iconpicture-fill:before {
  content: "\e745";
}

.iconfont-vertical:before {
  content: "\e746";
}

.iconinfo-circle:before {
  content: "\e747";
}

.iconunlock:before {
  content: "\e748";
}

.iconzoom:before {
  content: "\e749";
}

.iconzoom-out:before {
  content: "\e74a";
}

.iconnum-c1:before {
  content: "\e74b";
}

.iconupload-fill:before {
  content: "\e74c";
}

.iconkeyboard:before {
  content: "\e74d";
}

.icontext-fill:before {
  content: "\e74e";
}

.iconview-layers:before {
  content: "\e74f";
}

.iconmore:before {
  content: "\e750";
}

.iconsort-Irregular:before {
  content: "\e751";
}

.iconImport:before {
  content: "\e752";
}

.iconmorefill:before {
  content: "\e753";
}

.iconsorting:before {
  content: "\e754";
}

.iconsymmetry-level:before {
  content: "\e755";
}

.iconzoom-in:before {
  content: "\e756";
}

.iconlock-fill:before {
  content: "\e757";
}

.iconsync:before {
  content: "\e758";
}

.iconquestion-fill:before {
  content: "\e75a";
}

.icontext:before {
  content: "\e75b";
}

.iconfullscreen-exit:before {
  content: "\e75c";
}

.iconnum-c4:before {
  content: "\e75d";
}

.iconquestion:before {
  content: "\e75e";
}

.iconforward:before {
  content: "\e75f";
}

.iconskin:before {
  content: "\e760";
}

.iconskin-fill:before {
  content: "\e762";
}

.iconpicture:before {
  content: "\e763";
}

.iconfont-size:before {
  content: "\e764";
}

.iconnum-c5:before {
  content: "\e765";
}

.iconguidelines:before {
  content: "\e766";
}

.iconunlock-fill:before {
  content: "\e767";
}

.iconlock:before {
  content: "\e768";
}

.iconview-layers-fill:before {
  content: "\e769";
}

.iconupload:before {
  content: "\e76a";
}

.iconsort-neat:before {
  content: "\e76b";
}

.iconlayers:before {
  content: "\e76c";
}

.iconnum-c2:before {
  content: "\e76d";
}

.iconsymmetry-vertical:before {
  content: "\e76e";
}

.iconfullscreen:before {
  content: "\e76f";
}

.iconbackward:before {
  content: "\e770";
}

.icondistributed-left-top:before {
  content: "\e771";
}

.icondistributed-right-bottom:before {
  content: "\e772";
}

.icondistributed-right:before {
  content: "\e773";
}

.icondistributed-top:before {
  content: "\e774";
}

.iconlogo:before {
  content: "\e776";
}

.iconnum-c6:before {
  content: "\e759";
}

.iconnum-c3:before {
  content: "\e761";
}

.iconarrow-left-bold:before {
  content: "\e775";
}

.iconalign-left:before {
  content: "\e71e";
}

.iconarrow-down-bold:before {
  content: "\e71f";
}

.iconarrow-right-bold:before {
  content: "\e720";
}

.iconarrow-up-bold:before {
  content: "\e721";
}

.iconborder-outer:before {
  content: "\e722";
}

.iconborder-aider:before {
  content: "\e723";
}

.iconbright:before {
  content: "\e724";
}

.iconborder-info:before {
  content: "\e725";
}

.iconcaret-down:before {
  content: "\e726";
}

.iconcanvas-recovery:before {
  content: "\e727";
}

.iconcanvas-expend:before {
  content: "\e728";
}

.iconcaret-more:before {
  content: "\e729";
}

.iconbrush:before {
  content: "\e72a";
}

.iconcaret-right:before {
  content: "\e72b";
}

.iconcolumn-height:before {
  content: "\e72c";
}

.iconcontrol-fill:before {
  content: "\e72d";
}

.iconcolumn-paved:before {
  content: "\e72e";
}

.iconcontrol:before {
  content: "\e72f";
}

.iconcolumn-max:before {
  content: "\e731";
}

.iconcolumn-width:before {
  content: "\e732";
}

.icondelete:before {
  content: "\e733";
}

.iconcutout:before {
  content: "\e734";
}

.iconcrop:before {
  content: "\e735";
}

.icondistribute-level:before {
  content: "\e736";
}

.icondistribute-plumb:before {
  content: "\e737";
}

.icondistributed-bottom:before {
  content: "\e738";
}

.icondistributed-left:before {
  content: "\e739";
}

.icondistributed-center:before {
  content: "\e73a";
}

.icondistributed-left-bottom:before {
  content: "\e73b";
}

.icondistributed-right-top:before {
  content: "\e73c";
}

.iconeye-close:before {
  content: "\e73d";
}

.iconfile-add-to:before {
  content: "\e73e";
}

.iconfilter:before {
  content: "\e73f";
}

.iconfile-add:before {
  content: "\e740";
}

.iconfont-column-width:before {
  content: "\e741";
}

.iconeye-open:before {
  content: "\e742";
}

.iconfont-column-height:before {
  content: "\e743";
}

.iconcanvas-compress:before {
  content: "\e744";
}

.iconpicture-fill:before {
  content: "\e745";
}

.iconfont-vertical:before {
  content: "\e746";
}

.iconinfo-circle:before {
  content: "\e747";
}

.iconunlock:before {
  content: "\e748";
}

.iconzoom:before {
  content: "\e749";
}

.iconzoom-out:before {
  content: "\e74a";
}

.iconnum-c1:before {
  content: "\e74b";
}

.iconupload-fill:before {
  content: "\e74c";
}

.iconkeyboard:before {
  content: "\e74d";
}

.icontext-fill:before {
  content: "\e74e";
}

.iconview-layers:before {
  content: "\e74f";
}

.iconmore:before {
  content: "\e750";
}

.iconsort-Irregular:before {
  content: "\e751";
}

.iconImport:before {
  content: "\e752";
}

.iconmorefill:before {
  content: "\e753";
}

.iconsorting:before {
  content: "\e754";
}

.iconsymmetry-level:before {
  content: "\e755";
}

.iconzoom-in:before {
  content: "\e756";
}

.iconlock-fill:before {
  content: "\e757";
}

.iconsync:before {
  content: "\e758";
}

.iconquestion-fill:before {
  content: "\e75a";
}

.icontext:before {
  content: "\e75b";
}

.iconfullscreen-exit:before {
  content: "\e75c";
}

.iconnum-c4:before {
  content: "\e75d";
}

.iconquestion:before {
  content: "\e75e";
}

.iconforward:before {
  content: "\e75f";
}

.iconskin:before {
  content: "\e760";
}

.iconskin-fill:before {
  content: "\e762";
}

.iconpicture:before {
  content: "\e763";
}

.iconfont-size:before {
  content: "\e764";
}

.iconnum-c5:before {
  content: "\e765";
}

.iconguidelines:before {
  content: "\e766";
}

.iconunlock-fill:before {
  content: "\e767";
}

.iconlock:before {
  content: "\e768";
}

.iconview-layers-fill:before {
  content: "\e769";
}

.iconupload:before {
  content: "\e76a";
}

.iconsort-neat:before {
  content: "\e76b";
}

.iconlayers:before {
  content: "\e76c";
}

.iconnum-c2:before {
  content: "\e76d";
}

.iconsymmetry-vertical:before {
  content: "\e76e";
}

.iconfullscreen:before {
  content: "\e76f";
}

.iconbackward:before {
  content: "\e770";
}

.icondistributed-left-top:before {
  content: "\e771";
}

.icondistributed-right-bottom:before {
  content: "\e772";
}

.icondistributed-right:before {
  content: "\e773";
}

.icondistributed-top:before {
  content: "\e774";
}
.iconcustomer:before {
  content: "\e7b8";
}

.product-detail-box {
  font-size: 14px;
}

.product-detail-box > div {
  display: flex;
  flex-direction: column;
}
.embroidery-text .el-form-item {
  margin-bottom: 16px !important;
}
.embroidery-text .el-form {
  margin-bottom: 0 !important;
}
#deCreate {
  .row-info {
    line-height: 45px;
    border-bottom: 1px solid #f0f5ff;
  }
  .product-detail-box .details {
    flex: 1;
    padding: 0 20px;
    border-top: 1px solid #f0f5ff;
  }

  .add-text-btn {
    width: calc(100% - 20px);
    height: 40px;
    background: #f0f5ff;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .remark-box {
    margin-top: 20px;
    font-size: 12px;
    line-height: 20px;
    color: #495b6e;

    .mb6 {
      margin-bottom: 6px;
    }

    a {
      color: #4934b2;
    }
  }

  .upload-title {
    color: #000;
    font-size: 14px;
  }
  .zwdesign-header .zwdesign-header--center .line {
    background-color: #ddd !important;
  }
  .tool-item {
    color: #495b6e;
    &:hover {
      color: #4934b2;
    }
  }
  .tool-item a {
    color: #495b6e;
    &:hover {
      color: #4934b2;
    }
  }
  .toolbar-item {
    color: #495b6e;
    &:hover {
      color: #4934b2;
      .toolbar-item-text {
        color: #4934b2;
      }
    }
  }
  .sku-attr {
    overflow: hidden;
    padding: 0 0 0 8px;
    .sku-name {
      margin: 0 32px 0 0;
    }
    .sku-detail {
      margin: 5px 0 0 0;
    }
  }
  .sku-color {
    margin: 0 8px 0 0;
    border: 1px solid #aaaaaa;
    cursor: pointer;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    transition: all 0.5s ease-in-out;
    border: 3px solid transparent;
    box-shadow: 0 0 0 1px #ddd;
  }
  .sku-size {
    color: #333;
    font-size: 12px;
    font-weight: 400;
    line-height: 30px;
    text-transform: capitalize;
    display: inline-block;
    margin: 0;
    min-width: 30px;
    overflow: hidden;
    text-align: center;
    background-color: #f9f9f9;
    border-radius: 7px;
    transition: all 0.5s ease-in-out;
    padding: 0 6px;
    margin: 0 8px 5px 0;
    border: 3px solid transparent;
    box-shadow: 0 0 0 1px #ddd;
    cursor: pointer;
    box-sizing: border-box;
  }

  .is-select {
    border: 3px solid #f25551;
    box-shadow: none;
  }

  .ml40 {
    margin-left: 40px !important;
  }
  .ml80 {
    margin-left: 80px !important;
  }
  .ml60 {
    margin-left: 60px !important;
  }
  .cp {
    cursor: pointer;
  }
  .flex-col-ct {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
  }
  .flex,
  .flex-col {
    display: flex;
  }
  .cp {
    cursor: pointer;
  }
  .f14 {
    font-size: 14px;
    line-height: 22px;
  }
  .ml4 {
    margin-left: 4px !important;
  }

  .gallery-detail-box > .inner-content {
    padding-bottom: 40px;
  }

  .gallery-detail-box.el-checkbox__label {
    padding-left: 8px !important;
  }

  .gallery-detail-box .ajustment-pannel {
    position: absolute;
    left: 0;
    top: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    flex-direction: column;
  }

  .gallery-detail-box .ajustment-pannel .ajustment-pannel-title {
    flex: none;
    height: 50px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f5ff;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-title
    .ajustment-pannel-title--left {
    display: flex;
    align-items: center;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-title
    .ajustment-pannel-title--left
    .title {
    margin: 0 6px;
    font-size: 14px;
    font-weight: 500;
    color: #000;
  }

  .gallery-detail-box .ajustment-pannel .ajustment-pannel-cont {
    padding: 20px 26px;
    overflow-y: auto;
  }

  .gallery-detail-box .ajustment-pannel .ajustment-pannel-cont .render-box {
    display: flex;
    flex-wrap: wrap;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem {
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem:nth-child(5n) {
    margin-right: 0;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-img {
    width: 80px;
    height: 80px;
    border-radius: 5px;
    border: 1px solid #f0f5ff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-img.active {
    border: 2px solid #4934b2;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-img
    img {
    border-radius: 5px;
    max-width: 100%;
    max-height: 100%;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-name {
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
    color: #37474f;
    line-height: 22px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 80px;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .render-box
    .rendItem
    .rendItem-name:hover {
    color: #4934b2;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item {
    width: 233px;
    height: 70px;
    padding: 10px;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item.el-input__inner {
    height: 24px !important;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item
    .item-desc {
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item
    .item-desc
    .label {
    color: #37474f;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .color-ajustment-box
    .color-ajustment-item
    .item-slide {
    width: 100%;
  }

  .gallery-detail-box .ajustment-pannel .ajustment-pannel-cont .path-box {
    display: flex;
    flex-wrap: wrap;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item {
    width: 80px;
    height: 80px;
    background: #f0f5ff;
    border-radius: 5px;
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 2px solid transparent;
    padding: 20px;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item:nth-child(2n) {
    margin-right: 0;
  }

  [data-theme="default"]
    .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item.active {
    border: 2px solid #4934b2 !important;
  }

  [data-theme="dark"]
    .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item.active,
  [data-theme="light"]
    .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item.active {
    border: 2px solid #fff !important;
  }

  .gallery-detail-box
    .ajustment-pannel
    .ajustment-pannel-cont
    .path-box
    .path-item
    img {
    width: 100%;
    height: 100%;
  }

  .gallery-detail-box .icon-box32 {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .gallery-detail-box .icon-caret-more {
    position: relative;
  }

  .gallery-detail-box .icon-caret-more:after {
    position: absolute;
    font-family: iconfont !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    right: 0;
    bottom: 0;
    content: "\e729";
  }

  .gallery-detail-box .label {
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
  }

  [data-theme="default"] .gallery-detail-box .label {
    color: #000 !important;
  }

  [data-theme="dark"] .gallery-detail-box .label,
  [data-theme="light"] .gallery-detail-box .label {
    color: !important;
  }

  .gallery-detail-box .img-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f5ff;
  }

  .gallery-detail-box .img-info .img-info--left {
    align-items: center;
    height: 50px;
    display: flex;
    flex-wrap: wrap;
  }

  .gallery-detail-box .img-info .img-info--left .imgName {
    min-width: 80px;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .gallery-detail-box .img-info .img-info--left .imgSize {
    display: none;
  }

  .gallery-detail-box .img-info .img-info--right {
    color: #4934b2;
  }

  .gallery-detail-box .img-info .img-info--right .img-replace-tip-icon {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    vertical-align: -2px;
    margin-left: 1px;
  }

  .gallery-detail-box .img-info .img-info--right .img-replace-tip-icon.blue {
    color: #4934b2;
  }

  .gallery-detail-box .operation-content {
    padding: 5px 20px;
  }

  .gallery-detail-box .operation-content .operation-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .gallery-detail-box .operation-content .operation-item .operation-item-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50px;
    color: #000;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    height: 40px;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 5px;
    position: relative;
    padding: 0 4px;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .tileway-item {
    display: flex;
    flex-direction: column;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .tileway-item
    .icon {
    height: 32px;
    width: 32px;
    background: #fff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .tileway-item
    .icon.active {
    background: #e1edff;
    color: #4934b2;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item:hover {
    background: #e6e6e6;
  }

  .gallery-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item.active {
    background: #f0f5ff;
  }

  .gallery-detail-box .tileway-pop {
    width: 100%;
    position: absolute;
    top: 160px;
    left: 0;
    z-index: 99;
    background: #fff;
    box-shadow: 0 9px 28px 8px rgba(0, 0, 0, 0.05),
      0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
  }

  .opacity-pop {
    width: 100%;
    position: absolute;
    top: 43px;
    left: 0;
    z-index: 99;
    background: #fff;
    box-shadow: 0 9px 28px 8px rgba(221, 212, 212, 0.05),
      0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
  }

  .gallery-detail-box .operation-content .operation-item2 {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 40px;
  }

  .gallery-detail-box .operation-content .operation-item2 .item {
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 5px;
    flex: 1;
    height: 100%;
    cursor: pointer;
    outline: none;
  }

  .gallery-detail-box .operation-content .operation-item2 .item.checked {
    background: #f0f5ff;
    color: #4934b2;
  }

  .gallery-detail-box .operation-content > div:not(:last-child) {
    margin-bottom: 2px;
  }

  .gallery-detail-box .item-box--suspend {
    width: 100%;
    bottom: 0;
    z-index: 10;
    padding: 0 20px;
  }

  .gallery-detail-box .item-box--suspend .opt-box {
    height: 40px;
    border-radius: 5px;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    background: rgba(0, 0, 0, 0.03);
    position: relative;
  }

  .gallery-detail-box .item-box--suspend .opt-box .opt-item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }

  .gallery-detail-box .item-box--suspend .opt-box .opt-item.active {
    background: #f0f5ff;
    color: #4934b2;
  }

  .gallery-detail-box .item-box--suspend .opt-box .opt-item:hover {
    background: #e6e6e6;
  }

  .view-list-container {
    box-shadow: 0 5px 12px 4px rgba(0, 0, 0, 0.09),
      0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 1px 2px -2px rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    padding: 10px 0;
  }

  .view-list-container .view-item {
    text-align: center;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }

  .view-list-container .view-item:hover {
    background: #f0f5ff;
  }

  .zw-message-pop .dialog-content {
    padding-left: 26px;
  }

  .zw-message-pop .dialog-content .switch-con {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    margin-bottom: 10px;
  }

  .zw-message-pop .dialog-content .tip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 20px;
  }
  div {
    box-sizing: border-box;
  }
  .gallery-detail-box {
    font: 12px/1 sans-serif;
  }
  .pl20 {
    padding-left: 20px !important;
  }
  .pr20 {
    padding-right: 20px !important;
  }
  .ml10 {
    margin-left: 10px !important;
  }

  .text-detail-box .el-slider__button {
    width: 12px;
    height: 12px;
  }

  .text-detail-box .icon-box32 {
    width: 38px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .text-detail-box .icon-box32:hover {
    border: 1px solid rgba(0, 0, 0, 0.45);
  }

  .text-detail-box .icon-box32:before {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }

  .text-detail-box .label {
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
  }

  [data-theme="default"] .text-detail-box .label {
    color: #000 !important;
  }

  [data-theme="dark"] .text-detail-box .label,
  [data-theme="light"] .text-detail-box .label {
    color: !important;
  }

  .text-detail-box .img-info {
    display: flex;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f5ff;
  }

  .text-detail-box .img-info .img-info--right {
    color: #1f96f8;
  }

  .text-detail-box .img-info .img-info--left .textSize {
    display: none;
  }

  .text-detail-box .img-info .img-info--left .textName {
    max-width: 120px;
  }

  .text-detail-box .operation-content {
    padding: 15px 20px;
  }

  .text-detail-box .operation-content .operation-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .text-detail-box .operation-content .operation-item .operation-item-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50px;
    color: #000;
  }

  .text-detail-box .operation-content .operation-item .operation-item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    height: 40px;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 5px;
    position: relative;
    padding: 0 4px;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    outline: none;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item:hover {
    background: #e6e6e6;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .item.active {
    background: #e1edff;
    color: #4934b2;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .selectItem
    .icon {
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    width: 16px;
    height: 16px;
  }

  .text-detail-box
    .operation-content
    .operation-item
    .operation-item-content
    .selectItem
    .icon.rotate90 {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
  }

  .text-detail-box .operation-content > div:not(:last-child) {
    margin-bottom: 12px;
  }

  .text-detail-box .item-box--suspend {
    width: 100%;
    bottom: 0;
    z-index: 10;
    padding: 0 20px;
  }

  .text-detail-box .item-box--suspend .opt-box {
    height: 40px;
    border-radius: 5px;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    background: rgba(0, 0, 0, 0.03);
    background: rgba(0, 0, 0, 0.03);
    position: relative;
  }

  .text-detail-box .item-box--suspend .opt-box .opt-item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }

  .text-detail-box .item-box--suspend .opt-box .opt-item.active {
    background: #f0f5ff;
    color: #4934b2;
  }

  .text-detail-box .item-box--suspend .opt-box .opt-item:hover {
    background: #e6e6e6;
  }

  .text-detail-box .align-box ul.box {
    list-style: none;
    width: 145px;
    height: 98px;
  }

  .text-detail-box .align-box ul.box li {
    float: left;
  }

  .text-detail-box .align-box ul.box li:first-child span {
    border-top-left-radius: 5px;
  }

  .text-detail-box .align-box ul.box li:nth-child(3) span {
    border-top-right-radius: 5px;
  }

  .text-detail-box .align-box ul.box li:nth-child(7) span {
    border-bottom-left-radius: 5px;
  }

  .text-detail-box .align-box ul.box li:nth-child(9) span {
    border-bottom-right-radius: 5px;
  }

  .text-detail-box .align-box ul.box li span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 34px;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.15);
    margin-left: -1px;
    margin-top: -1px;
  }

  .text-detail-box .align-box ul.box li span:hover {
    position: relative;
    border: 2px solid #02a7f0;
    color: #02a7f0;
    z-index: 100;
  }

  .text-detail-box .align-box .box:after {
    content: "";
    height: 0;
    visibility: hidden;
    clear: both;
    display: block;
  }

  .text-detail-box .align-box .align-type {
    display: flex;
    width: 38px;
    height: 32px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #e0e5ea;
  }

  .text-detail-box .align-box .align-type:not(.zw-disabled):hover {
    border: 2px solid #02a7f0;
  }

  .text-detail-box .fontShap-box .el-input .el-input__inner {
    height: 20px;
    line-height: 20px;
  }

  .bg-color-set {
    position: absolute;
    right: calc(10vw - 58px);
    top: 6vh;
    width: 42px;
    height: 198px;
    background: #e0e4ee;
    border-radius: 5px;
  }

  .view-img {
    position: absolute;
    left: calc(10vw - 90px);
    top: 6vh;
    z-index: 1;
    padding: 6px 5px 23px 6px;
    background: #e0e4ee;
    border-radius: 6px;
    max-height: calc(100vh - 49px);
    overflow-y: auto;
  }
  .view-img li {
    width: 60px;
    height: 60px;
    position: relative;
    box-sizing: initial;
    background: #fff;
    border-radius: 3px;
    padding: 6px;
    box-sizing: border-box;
  }
  .view-img li.active {
    border: 1px solid #4934b2;
  }
  .view-img li img {
    width: 100%;
  }
  .view-img li:not(:last-child) {
    margin-bottom: 23px;
  }
  img {
    border-style: none;
  }

  .bg-color-set li {
    text-align: center;
  }

  .bg-color-set li .set-to-view-icon {
    font-size: 22px;
  }

  .bg-color-set li.bg-color-pick {
    margin-bottom: 0px;
  }

  .el-color-picker__color.is-alpha {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);
  }

  .el-color-picker__color.is-delete {
    background-image: url(data:image/png;base64,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) !important;
    background-size: contain;
    background-color: #fff;
  }

  .bg-color-picker- {
    position: absolute;
    right: calc(10vw - 150px);
    top: calc(6vh + 31px);
    /* width: 32px; */
    /* height: 64px; */
    background: #ffffff;
    border-radius: 5px;
    z-index: 100;
  }
  .bg-color-picker-text {
    position: absolute;
    left: 6px;
    top: 39px;
    /* width: 32px; */
    /* height: 64px; */
    background: #ffffff;
    border-radius: 5px;
    z-index: 100;
  }
  .sidebar .sidebar-cont {
    height: calc(100vh - 55px);
    overflow: hidden;
    background: #fff;
    transition: all 0.3s;
    opacity: 1;
    display: flex;
    flex-direction: column;
  }
  .sidebar .sidebar-cont .cont-top {
    overflow-y: hidden;
    height: 100%;
  }

  .sidebar .sidebar-cont .cont-bottom {
    height: 240px;
    min-height: 208px;
    max-height: calc(100% - 300px);
    position: relative;
    border: 1px solid #f0f5ff;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.06);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .sidebar .sidebar-cont .cont-bottom > .tit {
    line-height: 32px;
    background: rgba(0, 0, 0, 0.04);
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
  }
  .el-dropdown-link {
    cursor: pointer;
  }

  .sidebar .sidebar-cont .cont-bottom > .tit .txt {
    display: inline-block;
    padding: 0 30px;
    background: #fff;
    color: #4934b2;
    font-size: 14px;
    font-weight: 600;
  }

  .sidebar .sidebar-cont .cont-bottom > .tit .close {
    padding: 0 10px;
    cursor: pointer;
  }

  .sidebar .sidebar-cont .cont-bottom .resize-area {
    display: inline-block;
    content: "";
    position: absolute;
    left: 50%;
    top: 4px;
    z-index: 99;
    height: 28px;
    padding: 0 10px;
    background: transparent;
    cursor: n-resize;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .product.layer .result-content {
    height: calc(100vh - 488px) !important;
  }

  .material.layer .result-content {
    height: calc(100vh - 525px) !important;
  }

  .main .left-panel .content .material .result .result-content {
    height: calc(100vh - 286px);
  }

  .main .left-panel .content .upload-image .result .result-content {
    height: calc(100vh - 309px);
  }

  .upload-text.layer .result-content {
    height: calc(100vh - 520px) !important;
  }
  .upload-image.layer .result-content {
    height: calc(100vh - 529px) !important;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #37474f;
    position: relative;
    border: none;
    cursor: pointer;
  }

  .custom-tree-node:hover {
    color: #000;
  }

  .custom-tree-node .name {
    flex: 1;
    display: flex;
    align-items: center;
    padding-right: 50px;
  }

  .custom-tree-node .name.bg,
  .custom-tree-node .name.bg label {
    cursor: not-allowed;
  }

  .custom-tree-node .name .bgicon {
    font-size: 15px;
    margin: 1px 5px 0 -20px;
    color: #37474f;
  }

  .custom-tree-node .name label {
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }

  .custom-tree-node .name .imgbox {
    width: 15px;
    height: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 0;
  }

  .custom-tree-node .name .imgbox img {
    max-width: 15px;
    max-height: 15px;
  }

  .custom-tree-node .operates .lock-icon {
    position: absolute;
    right: 46px;
    top: 0;
  }
  .custom-tree-node .operates .down-icon {
    position: absolute;
    right: 69px;
    top: 12px;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
  }
  .custom-tree-node .operates .up-icon {
    position: absolute;
    right: 92px;
    top: 12px;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
  }
  .custom-tree-node .operates .delete-icon {
    position: absolute;
    right: 0px;
    top: 14px;
  }

  .custom-tree-node .operates .hidden-icon {
    position: absolute;
    right: 23px;
    top: 0;
  }

  .custom-tree-node .suspen {
    visibility: hidden;
  }

  .custom-tree-node.node-view {
    font-weight: 500;
  }

  .custom-tree-node:hover .suspen {
    visibility: visible;
  }

  .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    border: 1px solid transparent;
    border-radius: 5px;
    padding: 0 12px 0 12px;
    margin: 0 12px;
  }

  .el-tree-node__content:hover {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.45);
  }

  .active .el-tree-node__content {
    background-color: #f5f7fa;
  }
  .layer-box {
    padding: 8px 0 8px 0;
    height: 200px;
    overflow: auto;
  }
  & .the-main__middle-content {
    width: 100%;
  }
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .designer-footer-left {
    padding: 6px 15px;
    border-radius: 5px;
    box-shadow: 1px 1px 12px #ccc;
    background: #fff;
    position: absolute;
    left: 19px;
  }

  .designer-footer-left p {
    color: #52c41a;
    font-size: 14px;
    line-height: 22px;
  }

  .designer-footer-left span {
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    line-height: 20px;
  }

  .designer-footer-center {
    border-radius: 5px;
    position: absolute;
    left: calc(50% - 29px);
    top: 0px;
    text-align: center;
    margin: 17px 0 0 0;
  }
  .designer-footer-center p {
    font-size: 14px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.65);
  }
  .designer-footer-center span {
    font-size: 14px;
    color: #4934b2;
  }

  .designer-footer-right {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 17px;
    border-radius: 5px;
    box-shadow: 1px 1px 12px #ccc;
    background: #fff;
    position: absolute;
    right: 19px;
  }

  .designer-footer-right .maximize {
    margin-right: 28px;
    position: relative;
  }

  .designer-footer-right .maximize:before {
    content: "";
    position: absolute;
    top: 0;
    left: 35px;
    height: 20px;
    width: 1px;
    background: rgba(0, 0, 0, 0.15);
  }
  .designer-footer-right .iconfont {
    font-size: 20px;
    position: relative;
    cursor: pointer;
  }
  .designer-footer-right .slider {
    width: 60px;
    margin: 0 12px;
  }
  .tool-component {
    position: absolute;
    bottom: 100px;
    width: 100%;
    height: 0;
    justify-content: center;
    display: flex;
    .tool {
      text-align: center;
      &:not(:last-child) {
        margin-right: 30px;
      }
      .tool-button {
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: #fff;
        border-radius: 6px;
        border: 1px solid #ccc;
        margin-bottom: 8px;
        cursor: pointer;
        &.disabled {
          color: #ccc;
          border: 1px solid #ccc;
          cursor: not-allowed;
        }
        &:not(.disabled):hover {
          color: #4934b2;
          border-color: #4934b2;
        }
      }
      .tool-text {
        color: #666;
      }
    }
  }
  .save-btn-content .save-btn {
    background-color: #4934b2 !important;
    color: #ffffff;
    margin: 0px 16px 0 0;
    &:hover {
      opacity: 0.8;
    }
  }
  .row-process {
    display: flex;
    justify-content: space-between;
    line-height: 32px;
    border-bottom: 1px solid #f0f5ff;
    padding: 10px 8px;
    .process-list {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    }
    .process-item.active {
      border: 2px solid #4934b2 !important;
      color: #4934b2;
    }
    .process-item {
      display: inline-block;
      padding: 0 10px;
      height: 32px;
      line-height: 29px;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .pr36 {
    padding-right: 36px !important;
  }
  .zw-disabled {
    pointer-events: none;
  }
  .zw-disabled,
  .zw-disabled:active,
  .zw-disabled:hover {
    opacity: 0.2;
    cursor: not-allowed;
  }
}

.toolbar-item.active .icon,
.toolbar-item.active .toolbar-item-text {
  color: #4934b2;
}

.save-record-cont {
  width: 100%;
  height: auto;
}

.save-record-cont .title-cont {
  padding: 15px 15px 9px 15px;
}

.save-record-cont .title-cont .title-text {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
}

.save-record-cont .title-cont .title-icon {
  color: #4934b2;
  margin-right: 6px;
}

.save-record-cont .content {
  padding: 19px 20px 0px 20px;
}

.save-record-cont .content .data-cont {
  flex-wrap: wrap;
}

.save-record-cont .content .data-cont .product-item {
  position: relative;
  cursor: pointer;
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.06);
  margin-right: 10px;
  margin-bottom: 10px;
}

.save-record-cont .content .data-cont .product-item:nth-child(3n) {
  margin-right: 0;
}

.save-record-cont .content .data-cont .product-item:before {
  content: "";
  background: radial-gradient(
    closest-side at 0 100%,
    transparent 0,
    rgba(0, 0, 0, 0.04) 100%
  );
  width: 100%;
  height: 100%;
  position: absolute;
  display: inline-block;
  z-index: 0;
  top: 0;
  bottom: 0;
}

.save-record-cont .content .data-cont .product-item img {
  width: 100%;
  height: 100%;
}

.save-record-cont .content .data-cont .product-item .product-id {
  display: none;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 80px;
  height: 20px;
  z-index: 99;
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.65);
}

.save-record-cont .content .data-cont .product-item:hover .product-id {
  display: block;
}

.save-record-cont .content .data-cont .part-item {
  position: relative;
  cursor: pointer;
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.06);
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid transparent;
}
.save-record-cont .content .data-cont .active {
  border: 1px solid #4934b2;
}

.save-record-cont .content .data-cont .part-item:nth-child(4n) {
  margin-right: 0;
}

.save-record-cont .content .data-cont .part-item:before {
  content: "";
  background: radial-gradient(
    closest-side at 0 100%,
    transparent 0,
    rgba(0, 0, 0, 0.04) 100%
  );
  width: 100%;
  height: 100%;
  position: absolute;
  display: inline-block;
  z-index: 0;
  top: 0;
  bottom: 0;
}

.save-record-cont .content .data-cont .part-item img {
  width: 100%;
  height: 100%;
}

.save-record-cont .content .data-cont .part-item .product-id {
  display: none;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 80px;
  height: 20px;
  z-index: 99;
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.65);
}

.save-record-cont .content .data-cont .part-item:hover .product-id {
  display: block;
}
.flex {
  display: flex;
}

.zw-slide-pop {
  padding: 14px 10px;
}

.zw-slide-pop .zw-slide-pop-main .slide {
  width: 100%;
  display: flex;
  align-items: center;
}

.zw-slide-pop .zw-slide-pop-main .slide .zw-silder {
  padding: 0 10px;
  flex: 1;
}

.zw-slide-pop .zw-slide-pop-main .slide-value {
  width: 48px;
  text-align: right;
}

.zw-slide-pop .zw-slide-pop-main .slide-value.el-input .el-input__inner {
  height: 24px;
  line-height: 24px;
}

.zw-slide-pop .slide-lock.iconlock {
  color: #4934b2;
}
.rul_cornerTL,
.rul_cornerTR {
  border-bottom: 1px solid rgba(206, 219, 236, 0.5);
}
.rul_cornerBL,
.rul_cornerTL {
  border-right: 1px solid rgba(206, 219, 236, 0.5);
}
.rul_cornerBL,
.rul_cornerBR {
  bottom: 1px;
  border-top: 1px solid rgba(206, 219, 236, 0.5);
}
.rul_cornerBR,
.rul_cornerTR {
  right: 1px;
  border-left: 1px solid rgba(206, 219, 236, 0.5);
}
.rul_wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
  top: 0px;
}
.rul_corner,
.rul_line,
.rul_ruler {
  pointer-events: all;
  position: absolute;
}
.rul_wrapper * {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
.rul_ruler {
  display: block;
  border: 1px solid rgba(206, 219, 236, 0.5);
  filter: blur(0);
  -webkit-filter: blur(0);
  z-index: 1000;
}
.rul_corner {
  background-color: #fff;
  z-index: 1010;
  cursor: pointer;
}
.rul_corner:hover {
  background-color: #d3d3d3;
}
.rul_cornerTL {
  top: 0;
  left: 0;
}
.rul_cornerTR {
  top: 1px;
}
.rul_cornerBL {
  left: 1px;
}
.rul_ruler_Vertical {
  cursor: ew-resize;
  border-left: none;
}
.rul_ruler_Horizontal {
  cursor: ns-resize;
  border-top: none;
}
.rul_line {
  color: transparent;
  background-color: transparent;
  border-bottom: 1px solid #4934b2;
  border-left: 1px solid #4934b2;
  z-index: 1000;
}
.rul_line_dragged {
  border: 1px dotted #6b7587;
}
.rul_line:hover {
  border-bottom: 1px solid #236e77;
  border-left: 1px solid #236e77;
}
.rul_lineVer {
  top: 0;
  bottom: 0;
}
.rul_lineVer:hover {
  cursor: ew-resize;
}
.rul_lineHor {
  right: 0;
  left: 0;
}
.rul_lineHor:hover {
  cursor: ns-resize;
}
.rul_tooltip:after {
  background: #fff;
  color: #000;
  border: 1px solid gray;
  font-size: 10px;
  content: attr(data-tip);
  top: 50%;
  left: 50%;
  margin-top: 1px;
  margin-left: 1px;
  padding: 2px 5px;
  position: absolute;
  z-index: 10001;
  min-width: 45px;
}
.rul_tracker {
  height: 1px;
  width: 1px;
  background: #000;
  position: absolute;
  pointer-events: none;
}

@font-face {
  font-family: "academic"; //自定义文字名
  src: url("../../../assets/fonts/academic.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "agra"; //自定义文字名
  src: url("../../../assets/fonts/agra.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "aguzlo"; //自定义文字名
  src: url("../../../assets/fonts/aguzlo.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "brush_script_std"; //自定义文字名
  src: url("../../../assets/fonts/brush_script_std.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "butter"; //自定义文字名
  src: url("../../../assets/fonts/butter.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "chiller"; //自定义文字名
  src: url("../../../assets/fonts/chiller.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "clarendon_condensed_bold"; //自定义文字名
  src: url("../../../assets/fonts/clarendon_condensed_bold.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "comeback"; //自定义文字名
  src: url("../../../assets/fonts/comeback.otf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "digital"; //自定义文字名
  src: url("../../../assets/fonts/digital.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "academic"; //自定义文字名
  src: url("../../../assets/fonts/academic.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "distorti"; //自定义文字名
  src: url("../../../assets/fonts/distorti.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "eccentric_std"; //自定义文字名
  src: url("../../../assets/fonts/eccentric_std.otf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "forte"; //自定义文字名
  src: url("../../../assets/fonts/forte.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "friday_night"; //自定义文字名
  src: url("../../../assets/fonts/friday_night.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "happy"; //自定义文字名
  src: url("../../../assets/fonts/happy.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "seaside"; //自定义文字名
  src: url("../../../assets/fonts/seaside.otf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "spaghettica"; //自定义文字名
  src: url("../../../assets/fonts/spaghettica.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "academic"; //自定义文字名
  src: url("../../../assets/fonts/academic.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "varsity"; //自定义文字名
  src: url("../../../assets/fonts/varsity.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "verminmagic"; //自定义文字名
  src: url("../../../assets/fonts/verminmagic.ttf"); //路径引入文字
  font-weight: normal;
  font-style: normal;
}
.operate-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
}

.operate-bar .operate-item {
  background: #f0f2f5;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 12px;
}

.operate-bar .operate-item.iconfont {
  font-size: 22px;
}

.operate-bar .operate-item:hover {
  background-color: #ebecf8;
  color: #3d47bf;
}

.operate-bar .operate-item.active {
  background: #3d47bf;
  color: #fff;
}

.operate-bar .operate-item.mini {
  width: 64px;
}

.operate-bar .operate-item.medium {
  width: 136px;
}

.background-color-content {
  position: relative;
  max-width: 209px;
  padding: 0.64em 0 0 0.64em;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  flex-wrap: wrap;
  align-content: flex-start;
  display: flex;
}

.background-color-content .background-color-item {
  width: 24px;
  height: 24px;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 0.64em 0.64em 0;
  list-style: none;
  box-sizing: border-box;
}
#pic-zoom img {
  width: 100% !important;
}
.product-detail-box .el-carousel__indicators {
  z-index: 1001;
}
.mouse-cover-canvas {
  right: 330px !important;
  left: inherit !important;
  top: 57px !important;
}
.magnifier-box .mouse-cover {
  cursor: zoom-in !important;
}
.shortcut-box {
  max-height: calc(90vh - 220px);
  overflow: auto;
  color: #37474f;
  position: relative;
}

.panel-box {
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

.panel-tit {
  width: 100%;
  height: 32px;
  line-height: 32px;
  background: #f0f5ff;
  padding: 0 15px;
  font-weight: 700;
  color: #37474f;
}

.panel-tit.gray {
  background: rgba(0, 0, 0, 0.02);
}

.panel-cont {
  width: 100%;
  column-count: 2;
  column-gap: 20px;
  -moz-column-rule: 1px solid rgba(0, 0, 0, 0.06);
  column-rule: 1px solid rgba(0, 0, 0, 0.06);
  -webkit-column-count: 2;
  -webkit-column-gap: 20px;
  -moz-column-count: 2;
  -moz-column-gap: 20px;
}

.panel-cont .panel-item {
  -moz-column-break-inside: avoid;
  break-inside: avoid;
  width: 100%;
  font-size: 13px;
  cursor: pointer;
}

.panel-cont .panel-item.disabled {
  color: #aaa;
}

.panel-cont .panel-item.warning {
  color: #ff4500;
}

.panel-cont .panel-item > div {
  height: 32px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-cont .panel-item > div:hover {
  background: rgba(0, 0, 0, 0.04);
  color: #0453f3;
}

.panel-cont .panel-item .keycode {
  font-family: sans-serif;
}

.panel-cont .panel-item .keycode span.key {
  display: inline-block;
  padding: 5px 4px;
  background: #f0f5ff;
  border-radius: 3px;
}

.panel-cont .panel-item .keycode span.combine {
  padding: 0 3px;
}

.panel-cont .panel-item .input-box {
  display: inline-block;
  position: relative;
}

.panel-cont .panel-item .input-box input {
  width: 140px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  border: 1px solid #efefef;
  border-radius: 5px;
  outline: 0;
  padding-right: 16px;
  text-align: center;
  caret-color: transparent;
}

.panel-cont .panel-item .input-box input:focus {
  border-color: #0453f3;
  color: #0453f3;
}

.panel-cont .panel-item .input-box input:focus::-webkit-input-placeholder {
  color: #0453f3;
}

.panel-cont .panel-item .input-box i {
  display: inline-block;
  line-height: 24px;
  padding: 0 2px;
  position: absolute;
  right: 0;
  top: 0;
  color: rgba(0, 0, 0, 0.15);
}

.panel-cont .panel-item input:focus + i {
  color: #0453f3;
}

.panel-box.sublevel {
  padding-bottom: 0;
}

.panel-box.sublevel .panel-tit {
  background: rgba(0, 0, 0, 0.02);
  margin-top: 10px;
}

.panel-box.sublevel .panel-cont {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding-bottom: 10px;
}
.el-carousel__arrow--left,
.el-carousel__arrow--right {
  z-index: 200;
}
</style>
